/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';
import type {
  MaybeRef
} from 'vue';

import type {
  AddWordCloudWordBody,
  AiAssistant,
  AiAssistantFile,
  AiChatCompletion,
  AiConversation,
  AiConverter,
  AiDocumentQa,
  AiFeedback,
  AiFeedbackResult,
  AiImage,
  AiImageRecognition,
  AiMessage,
  AiMiniTool,
  AiMiniToolRequest,
  AiPersona,
  AiRun,
  AiSpeechRecognition,
  App,
  AudioRecorderFile,
  AudioRecording,
  Author,
  BookmarkStatus,
  CheckBookmarkParams,
  ClassroomPages,
  ClassroomScreenCard,
  ClassroomScreenPage,
  ClassroomScreenScreen,
  Collection,
  CreateAiChatCompletionBody,
  CreateAiConversationBody,
  CreateAiConverterBody,
  CreateAiFeedbackBody,
  CreateAiFeedbackResultBody,
  CreateAiMessageBody,
  CreateAiMessageParams,
  CreateAiPersonaBody,
  CreateAiRunBody,
  CreateAnswerOptionBody,
  CreateAssistantBody,
  CreateAssistantFileBody,
  CreateAudioRecordingBody,
  CreateClassroomScreenCardBody,
  CreateClassroomScreenPageBody,
  CreateDocumentQaBody,
  CreateFileSharingFileAttachmentBody,
  CreateFolderBody,
  CreateImageAttachmentBody,
  CreateImageBody,
  CreateImageRecognitionBody,
  CreateMiniToolBody,
  CreateMiniToolRequestBody,
  CreateOwnerFileBody,
  CreateProjectBody,
  CreatePupilFeedbackFeedbackBody,
  CreatePupilFeedbackResponseBody,
  CreateSchoolClassBody,
  CreateSpeechRecognitionBody,
  CreateSurveyQuestionBody,
  CreateSurveyResponseBody,
  CreateTemplateParams,
  CreateTextEditorDocumentBody,
  CreateUserPdfBody,
  CreateWorksheetBlockBody,
  CreateWorksheetBlockSolutionBody,
  CreateWorksheetBody,
  CreateWorksheetFeedbackBody,
  CreateWorksheetResponseBody,
  DeleteDiscardedItemsParams,
  DeleteFileSharingFileAttachmentParams,
  DuplicateItemParams,
  FileSharingFile,
  Folder,
  GetAudioRecorderFileParams,
  GetClassroomScreenParams,
  GetFileSharingFileParams,
  GetItemParams,
  GetLinkShortenerLinkParams,
  GetPupilFeedbackAssignmentParams,
  GetScreenRecorderFileParams,
  GetSurveyParams,
  GetTestEditorDocumentParams,
  GetWebsitePageParams,
  GetWordCloudParams,
  GetWorksheetParams,
  ImageAttachment,
  Item,
  ItemCreateInput,
  ItemInput,
  ItemMoveInput,
  LimitsParams,
  LinkShortenerLink,
  ListAiAssistantsParams,
  ListAiConversationsParams,
  ListAiConvertersParams,
  ListAiDocumentQaParams,
  ListAiFeedbackResultsParams,
  ListAiFeedbacksParams,
  ListAiImageRecognitionParams,
  ListAiImagesParams,
  ListAiMessagesParams,
  ListAiMiniToolRequestsParams,
  ListAiMiniToolsParams,
  ListAiModelCardsParams,
  ListAiPersonasParams,
  ListAiSpeechRecognitionParams,
  ListApprovedToolsUsersParams,
  ListBookmarksParams,
  ListClassroomScreensParams,
  ListCollectionsParams,
  ListDiscardedItemsParams,
  ListFeaturedAiAssistantsParams,
  ListFeaturedAiMiniToolsParams,
  ListFeaturedCollectionsParams,
  ListFoldersParams,
  ListItemsParams,
  ListMaterialsParams,
  ListProjectItemsParams,
  ListProjectsParams,
  ListPupilActivitiesParams,
  ListPupilFeedbackResponsesParams,
  ListPupilsParams,
  ListRecentlyCreatedItemsParams,
  ListSchoolClassesParams,
  ListTemplatesParams,
  ListToTeachWorksheetsParams,
  ListWordCloudsParams,
  ListWorksheetBlocksParams,
  ListWorksheetResponsesParams,
  Message,
  MoveClassroomScreenPageBody,
  MoveSurveyQuestionBody,
  OwnerFile,
  PaginatedAiAssistants,
  PaginatedAiChatCompletions,
  PaginatedAiConversations,
  PaginatedAiConverters,
  PaginatedAiDocumentQas,
  PaginatedAiFeedbackResults,
  PaginatedAiFeedbacks,
  PaginatedAiImageRecognitions,
  PaginatedAiImages,
  PaginatedAiMessages,
  PaginatedAiMiniToolRequests,
  PaginatedAiMiniTools,
  PaginatedAiModelCards,
  PaginatedAiPersonas,
  PaginatedAiRuns,
  PaginatedAiSpeechRecognitions,
  PaginatedBookmarks,
  PaginatedClassroomScreens,
  PaginatedFileSharingFiles,
  PaginatedFolders,
  PaginatedItems,
  PaginatedLinkShortenerLinks,
  PaginatedMaterials,
  PaginatedPartnerEntries,
  PaginatedProjectItems,
  PaginatedProjects,
  PaginatedPupilActivities,
  PaginatedSchoolClasses,
  PaginatedScreenRecorderFiles,
  PaginatedSurveyResponses,
  PaginatedTextEditorDocuments,
  PaginatedToTeachWorksheets,
  PaginatedVideoRecorderFiles,
  PaginatedWebsitePages,
  PaginatedWordClouds,
  PartnerEntry,
  PinboardBoard,
  Project,
  ProjectItem,
  ProjectItemInput,
  PupilFeedbackAssignment,
  PupilFeedbackFeedback,
  PupilFeedbackResponse,
  PupilFeedbackResponses,
  RecentlyUsedAiAssistantsParams,
  RemixParams,
  RemixSyncParams,
  ResumeProjectBody,
  SchoolClass,
  ScreenRecorderFile,
  Search,
  SearchAiAssistantsParams,
  SearchAiConversationsParams,
  SearchItemsParams,
  SearchMaterialsParams,
  SearchParams,
  ShowVideoRecorderFileParams,
  StandardError,
  Survey,
  SurveyQuestion,
  SurveyResponse,
  SurveyResponsesParams,
  SurveyResults,
  Template,
  TextEditorDocument,
  ToggleBookmarkParams,
  ToggleDiscardedItemParams,
  ToggleTemplateItemParams,
  ToolsUser,
  UpdateAiAssistantBody,
  UpdateAiChatCompletionBody,
  UpdateAiConversationBody,
  UpdateAiFeedbackBody,
  UpdateAiFeedbackResultBody,
  UpdateAiImageRecognitionBody,
  UpdateAiPersonaBody,
  UpdateAiRunBody,
  UpdateAnswerOptionBody,
  UpdateAudioRecorderFileBody,
  UpdateAudioRecordingBody,
  UpdateClassroomScreenCardBody,
  UpdateClassroomScreenPageBody,
  UpdateFileSharingFileBody,
  UpdateFolderBody,
  UpdateItemParams,
  UpdateLinkShortenerLinkBody,
  UpdatePinboardBoardBody,
  UpdateProjectBody,
  UpdatePupilFeedbackAssignmentBody,
  UpdateSchoolClassBody,
  UpdateScreenRecorderFileBody,
  UpdateSurveyBody,
  UpdateSurveyQuestionBody,
  UpdateTextEditorDocumentBody,
  UpdateToolsUserBody,
  UpdateVideoRecorderFileBody,
  UpdateWebsitePageBody,
  UpdateWordCloudBody,
  UpdateWorksheetBlockBody,
  UpdateWorksheetBlockSolutionBody,
  UpdateWorksheetBody,
  UpdateWorksheetFeedbackBody,
  UserLimit,
  UserLimits,
  UserPdf,
  ValidationError,
  VideoRecorderFile,
  WebsitePage,
  WordCloud,
  Worksheet,
  WorksheetAnswerOption,
  WorksheetBlock,
  WorksheetBlockSolution,
  WorksheetBlocks,
  WorksheetResponse,
  WorksheetResponseFeedback,
  WorksheetResponses
} from '../models';

import { axiosClient } from '../../axiosClient';
import type { ErrorType } from '../../axiosClient';
import { customQueryOptions } from '../../customQueryOptions';




/**
 * @summary Create AI Assistant Avatar
 */
export const createAssistantAvatar = (
    assistantId: MaybeRef<string>,
 signal?: AbortSignal
) => {
      assistantId = unref(assistantId);
      
      return axiosClient<void>(
      {url: `/api/ai/assistants/${assistantId}/assistant_avatars`, method: 'POST', signal
    },
      );
    }
  


export const getCreateAssistantAvatarMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssistantAvatar>>, TError,{assistantId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAssistantAvatar>>, TError,{assistantId: string}, TContext> => {
    
const mutationKey = ['createAssistantAvatar'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAssistantAvatar>>, {assistantId: string}> = (props) => {
          const {assistantId} = props ?? {};

          return  createAssistantAvatar(assistantId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAssistantAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof createAssistantAvatar>>>
    
    export type CreateAssistantAvatarMutationError = ErrorType<void>

    /**
 * @summary Create AI Assistant Avatar
 */
export const useCreateAssistantAvatar = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssistantAvatar>>, TError,{assistantId: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createAssistantAvatar>>,
        TError,
        {assistantId: string},
        TContext
      > => {

      const mutationOptions = getCreateAssistantAvatarMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create AI Assistant File
 */
export const createAssistantFile = (
    assistantId: MaybeRef<string>,
    createAssistantFileBody: MaybeRef<CreateAssistantFileBody>,
 signal?: AbortSignal
) => {
      assistantId = unref(assistantId);
createAssistantFileBody = unref(createAssistantFileBody);
      
      return axiosClient<AiAssistantFile>(
      {url: `/api/ai/assistants/${assistantId}/assistant_files`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAssistantFileBody, signal
    },
      );
    }
  


export const getCreateAssistantFileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssistantFile>>, TError,{assistantId: string;data: CreateAssistantFileBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAssistantFile>>, TError,{assistantId: string;data: CreateAssistantFileBody}, TContext> => {
    
const mutationKey = ['createAssistantFile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAssistantFile>>, {assistantId: string;data: CreateAssistantFileBody}> = (props) => {
          const {assistantId,data} = props ?? {};

          return  createAssistantFile(assistantId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAssistantFileMutationResult = NonNullable<Awaited<ReturnType<typeof createAssistantFile>>>
    export type CreateAssistantFileMutationBody = CreateAssistantFileBody
    export type CreateAssistantFileMutationError = ErrorType<void>

    /**
 * @summary Create AI Assistant File
 */
export const useCreateAssistantFile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssistantFile>>, TError,{assistantId: string;data: CreateAssistantFileBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createAssistantFile>>,
        TError,
        {assistantId: string;data: CreateAssistantFileBody},
        TContext
      > => {

      const mutationOptions = getCreateAssistantFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Delete AI AssistantFile
 */
export const deleteAiAssistantFile = (
    assistantId: MaybeRef<string>,
    id: MaybeRef<string>,
 ) => {
      assistantId = unref(assistantId);
id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/ai/assistants/${assistantId}/assistant_files/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAiAssistantFileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiAssistantFile>>, TError,{assistantId: string;id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiAssistantFile>>, TError,{assistantId: string;id: string}, TContext> => {
    
const mutationKey = ['deleteAiAssistantFile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiAssistantFile>>, {assistantId: string;id: string}> = (props) => {
          const {assistantId,id} = props ?? {};

          return  deleteAiAssistantFile(assistantId,id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiAssistantFileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiAssistantFile>>>
    
    export type DeleteAiAssistantFileMutationError = ErrorType<void>

    /**
 * @summary Delete AI AssistantFile
 */
export const useDeleteAiAssistantFile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiAssistantFile>>, TError,{assistantId: string;id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiAssistantFile>>,
        TError,
        {assistantId: string;id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAiAssistantFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Archive AI Assistant
 */
export const archiveAiAssistant = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/ai/assistants/${id}/archive`, method: 'PUT'
    },
      );
    }
  


export const getArchiveAiAssistantMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveAiAssistant>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof archiveAiAssistant>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['archiveAiAssistant'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveAiAssistant>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  archiveAiAssistant(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ArchiveAiAssistantMutationResult = NonNullable<Awaited<ReturnType<typeof archiveAiAssistant>>>
    
    export type ArchiveAiAssistantMutationError = ErrorType<void>

    /**
 * @summary Archive AI Assistant
 */
export const useArchiveAiAssistant = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveAiAssistant>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof archiveAiAssistant>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getArchiveAiAssistantMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create AI Assistant
 */
export const createAssistant = (
    createAssistantBody: MaybeRef<CreateAssistantBody>,
 signal?: AbortSignal
) => {
      createAssistantBody = unref(createAssistantBody);
      
      return axiosClient<AiAssistant>(
      {url: `/api/ai/assistants`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAssistantBody, signal
    },
      );
    }
  


export const getCreateAssistantMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssistant>>, TError,{data: CreateAssistantBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAssistant>>, TError,{data: CreateAssistantBody}, TContext> => {
    
const mutationKey = ['createAssistant'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAssistant>>, {data: CreateAssistantBody}> = (props) => {
          const {data} = props ?? {};

          return  createAssistant(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAssistantMutationResult = NonNullable<Awaited<ReturnType<typeof createAssistant>>>
    export type CreateAssistantMutationBody = CreateAssistantBody
    export type CreateAssistantMutationError = ErrorType<void>

    /**
 * @summary Create AI Assistant
 */
export const useCreateAssistant = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssistant>>, TError,{data: CreateAssistantBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createAssistant>>,
        TError,
        {data: CreateAssistantBody},
        TContext
      > => {

      const mutationOptions = getCreateAssistantMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of AI Assistants
 */
export const listAiAssistants = (
    params?: MaybeRef<ListAiAssistantsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedAiAssistants>(
      {url: `/api/ai/assistants`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListAiAssistantsQueryKey = (params?: MaybeRef<ListAiAssistantsParams>,) => {
    return ['api','ai','assistants', ...(params ? [params]: [])] as const;
    }

    
export const useListAiAssistantsQueryOptions = <TData = Awaited<ReturnType<typeof listAiAssistants>>, TError = ErrorType<unknown>>(params?: MaybeRef<ListAiAssistantsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAssistants>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiAssistantsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiAssistants>>> = ({ signal }) => listAiAssistants(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listAiAssistants>>, TError, TData> 
}

export type ListAiAssistantsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiAssistants>>>
export type ListAiAssistantsQueryError = ErrorType<unknown>


/**
 * @summary List of AI Assistants
 */

export function useListAiAssistants<TData = Awaited<ReturnType<typeof listAiAssistants>>, TError = ErrorType<unknown>>(
 params?: MaybeRef<ListAiAssistantsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAssistants>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListAiAssistantsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete AI Assistant
 */
export const deleteAiAssistant = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/ai/assistants/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAiAssistantMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiAssistant>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiAssistant>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAiAssistant'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiAssistant>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAiAssistant(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiAssistantMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiAssistant>>>
    
    export type DeleteAiAssistantMutationError = ErrorType<void>

    /**
 * @summary Delete AI Assistant
 */
export const useDeleteAiAssistant = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiAssistant>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiAssistant>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAiAssistantMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary AI Assistant Details
 */
export const getAiAssistant = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<AiAssistant>(
      {url: `/api/ai/assistants/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetAiAssistantQueryKey = (id: MaybeRef<string>,) => {
    return ['api','ai','assistants',id] as const;
    }

    
export const useGetAiAssistantQueryOptions = <TData = Awaited<ReturnType<typeof getAiAssistant>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAssistant>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiAssistantQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiAssistant>>> = ({ signal }) => getAiAssistant(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getAiAssistant>>, TError, TData> 
}

export type GetAiAssistantQueryResult = NonNullable<Awaited<ReturnType<typeof getAiAssistant>>>
export type GetAiAssistantQueryError = ErrorType<void>


/**
 * @summary AI Assistant Details
 */

export function useGetAiAssistant<TData = Awaited<ReturnType<typeof getAiAssistant>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAssistant>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAiAssistantQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update AI Assistant
 */
export const updateAiAssistant = (
    id: MaybeRef<string>,
    updateAiAssistantBody: MaybeRef<UpdateAiAssistantBody>,
 ) => {
      id = unref(id);
updateAiAssistantBody = unref(updateAiAssistantBody);
      
      return axiosClient<AiAssistant>(
      {url: `/api/ai/assistants/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAiAssistantBody
    },
      );
    }
  


export const getUpdateAiAssistantMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiAssistant>>, TError,{id: string;data: UpdateAiAssistantBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAiAssistant>>, TError,{id: string;data: UpdateAiAssistantBody}, TContext> => {
    
const mutationKey = ['updateAiAssistant'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAiAssistant>>, {id: string;data: UpdateAiAssistantBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAiAssistant(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAiAssistantMutationResult = NonNullable<Awaited<ReturnType<typeof updateAiAssistant>>>
    export type UpdateAiAssistantMutationBody = UpdateAiAssistantBody
    export type UpdateAiAssistantMutationError = ErrorType<void>

    /**
 * @summary Update AI Assistant
 */
export const useUpdateAiAssistant = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiAssistant>>, TError,{id: string;data: UpdateAiAssistantBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAiAssistant>>,
        TError,
        {id: string;data: UpdateAiAssistantBody},
        TContext
      > => {

      const mutationOptions = getUpdateAiAssistantMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of AI Assistants
 */
export const listFeaturedAiAssistants = (
    params?: MaybeRef<ListFeaturedAiAssistantsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedAiAssistants>(
      {url: `/api/ai/assistants/featured`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListFeaturedAiAssistantsQueryKey = (params?: MaybeRef<ListFeaturedAiAssistantsParams>,) => {
    return ['api','ai','assistants','featured', ...(params ? [params]: [])] as const;
    }

    
export const useListFeaturedAiAssistantsQueryOptions = <TData = Awaited<ReturnType<typeof listFeaturedAiAssistants>>, TError = ErrorType<unknown>>(params?: MaybeRef<ListFeaturedAiAssistantsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeaturedAiAssistants>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListFeaturedAiAssistantsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFeaturedAiAssistants>>> = ({ signal }) => listFeaturedAiAssistants(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listFeaturedAiAssistants>>, TError, TData> 
}

export type ListFeaturedAiAssistantsQueryResult = NonNullable<Awaited<ReturnType<typeof listFeaturedAiAssistants>>>
export type ListFeaturedAiAssistantsQueryError = ErrorType<unknown>


/**
 * @summary List of AI Assistants
 */

export function useListFeaturedAiAssistants<TData = Awaited<ReturnType<typeof listFeaturedAiAssistants>>, TError = ErrorType<unknown>>(
 params?: MaybeRef<ListFeaturedAiAssistantsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeaturedAiAssistants>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListFeaturedAiAssistantsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Recently used AI Assistants
 */
export const recentlyUsedAiAssistants = (
    params?: MaybeRef<RecentlyUsedAiAssistantsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedAiAssistants>(
      {url: `/api/ai/assistants/recently_used`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getRecentlyUsedAiAssistantsQueryKey = (params?: MaybeRef<RecentlyUsedAiAssistantsParams>,) => {
    return ['api','ai','assistants','recently_used', ...(params ? [params]: [])] as const;
    }

    
export const useRecentlyUsedAiAssistantsQueryOptions = <TData = Awaited<ReturnType<typeof recentlyUsedAiAssistants>>, TError = ErrorType<void>>(params?: MaybeRef<RecentlyUsedAiAssistantsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recentlyUsedAiAssistants>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getRecentlyUsedAiAssistantsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof recentlyUsedAiAssistants>>> = ({ signal }) => recentlyUsedAiAssistants(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof recentlyUsedAiAssistants>>, TError, TData> 
}

export type RecentlyUsedAiAssistantsQueryResult = NonNullable<Awaited<ReturnType<typeof recentlyUsedAiAssistants>>>
export type RecentlyUsedAiAssistantsQueryError = ErrorType<void>


/**
 * @summary Recently used AI Assistants
 */

export function useRecentlyUsedAiAssistants<TData = Awaited<ReturnType<typeof recentlyUsedAiAssistants>>, TError = ErrorType<void>>(
 params?: MaybeRef<RecentlyUsedAiAssistantsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof recentlyUsedAiAssistants>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useRecentlyUsedAiAssistantsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Search AI Assistants
 */
export const searchAiAssistants = (
    params?: MaybeRef<SearchAiAssistantsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedAiAssistants>(
      {url: `/api/ai/assistants/search`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getSearchAiAssistantsQueryKey = (params?: MaybeRef<SearchAiAssistantsParams>,) => {
    return ['api','ai','assistants','search', ...(params ? [params]: [])] as const;
    }

    
export const useSearchAiAssistantsQueryOptions = <TData = Awaited<ReturnType<typeof searchAiAssistants>>, TError = ErrorType<unknown>>(params?: MaybeRef<SearchAiAssistantsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAiAssistants>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSearchAiAssistantsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchAiAssistants>>> = ({ signal }) => searchAiAssistants(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof searchAiAssistants>>, TError, TData> 
}

export type SearchAiAssistantsQueryResult = NonNullable<Awaited<ReturnType<typeof searchAiAssistants>>>
export type SearchAiAssistantsQueryError = ErrorType<unknown>


/**
 * @summary Search AI Assistants
 */

export function useSearchAiAssistants<TData = Awaited<ReturnType<typeof searchAiAssistants>>, TError = ErrorType<unknown>>(
 params?: MaybeRef<SearchAiAssistantsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAiAssistants>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useSearchAiAssistantsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Cancel AI Chat Completion
 */
export const cancelAiChatCompletion = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/ai/chat_completions/${id}/cancel`, method: 'PUT'
    },
      );
    }
  


export const getCancelAiChatCompletionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAiChatCompletion>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelAiChatCompletion>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['cancelAiChatCompletion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelAiChatCompletion>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  cancelAiChatCompletion(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelAiChatCompletionMutationResult = NonNullable<Awaited<ReturnType<typeof cancelAiChatCompletion>>>
    
    export type CancelAiChatCompletionMutationError = ErrorType<void>

    /**
 * @summary Cancel AI Chat Completion
 */
export const useCancelAiChatCompletion = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAiChatCompletion>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof cancelAiChatCompletion>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCancelAiChatCompletionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create AI Chat Completion
 */
export const createAiChatCompletion = (
    createAiChatCompletionBody: MaybeRef<CreateAiChatCompletionBody>,
 signal?: AbortSignal
) => {
      createAiChatCompletionBody = unref(createAiChatCompletionBody);
      
      return axiosClient<AiChatCompletion>(
      {url: `/api/ai/chat_completions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAiChatCompletionBody, signal
    },
      );
    }
  


export const getCreateAiChatCompletionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiChatCompletion>>, TError,{data: CreateAiChatCompletionBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAiChatCompletion>>, TError,{data: CreateAiChatCompletionBody}, TContext> => {
    
const mutationKey = ['createAiChatCompletion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiChatCompletion>>, {data: CreateAiChatCompletionBody}> = (props) => {
          const {data} = props ?? {};

          return  createAiChatCompletion(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAiChatCompletionMutationResult = NonNullable<Awaited<ReturnType<typeof createAiChatCompletion>>>
    export type CreateAiChatCompletionMutationBody = CreateAiChatCompletionBody
    export type CreateAiChatCompletionMutationError = ErrorType<void>

    /**
 * @summary Create AI Chat Completion
 */
export const useCreateAiChatCompletion = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiChatCompletion>>, TError,{data: CreateAiChatCompletionBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createAiChatCompletion>>,
        TError,
        {data: CreateAiChatCompletionBody},
        TContext
      > => {

      const mutationOptions = getCreateAiChatCompletionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of AI Chat Completions
 */
export const listAiChatCompletions = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<PaginatedAiChatCompletions>(
      {url: `/api/ai/chat_completions`, method: 'GET', signal
    },
      );
    }
  

const getListAiChatCompletionsQueryKey = () => {
    return ['api','ai','chat_completions'] as const;
    }

    
export const useListAiChatCompletionsQueryOptions = <TData = Awaited<ReturnType<typeof listAiChatCompletions>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiChatCompletions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiChatCompletionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiChatCompletions>>> = ({ signal }) => listAiChatCompletions(signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listAiChatCompletions>>, TError, TData> 
}

export type ListAiChatCompletionsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiChatCompletions>>>
export type ListAiChatCompletionsQueryError = ErrorType<void>


/**
 * @summary List of AI Chat Completions
 */

export function useListAiChatCompletions<TData = Awaited<ReturnType<typeof listAiChatCompletions>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiChatCompletions>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListAiChatCompletionsQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete AI Chat Completion
 */
export const deleteAiChatCompletion = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/ai/chat_completions/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAiChatCompletionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiChatCompletion>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiChatCompletion>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAiChatCompletion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiChatCompletion>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAiChatCompletion(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiChatCompletionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiChatCompletion>>>
    
    export type DeleteAiChatCompletionMutationError = ErrorType<void>

    /**
 * @summary Delete AI Chat Completion
 */
export const useDeleteAiChatCompletion = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiChatCompletion>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiChatCompletion>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAiChatCompletionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary AI Chat Completion Details
 */
export const getAiChatCompletion = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<AiChatCompletion>(
      {url: `/api/ai/chat_completions/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetAiChatCompletionQueryKey = (id: MaybeRef<string>,) => {
    return ['api','ai','chat_completions',id] as const;
    }

    
export const useGetAiChatCompletionQueryOptions = <TData = Awaited<ReturnType<typeof getAiChatCompletion>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiChatCompletion>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiChatCompletionQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiChatCompletion>>> = ({ signal }) => getAiChatCompletion(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getAiChatCompletion>>, TError, TData> 
}

export type GetAiChatCompletionQueryResult = NonNullable<Awaited<ReturnType<typeof getAiChatCompletion>>>
export type GetAiChatCompletionQueryError = ErrorType<void>


/**
 * @summary AI Chat Completion Details
 */

export function useGetAiChatCompletion<TData = Awaited<ReturnType<typeof getAiChatCompletion>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiChatCompletion>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAiChatCompletionQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update AI Chat Completion
 */
export const updateAiChatCompletion = (
    id: MaybeRef<string>,
    updateAiChatCompletionBody: MaybeRef<UpdateAiChatCompletionBody>,
 ) => {
      id = unref(id);
updateAiChatCompletionBody = unref(updateAiChatCompletionBody);
      
      return axiosClient<AiChatCompletion>(
      {url: `/api/ai/chat_completions/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAiChatCompletionBody
    },
      );
    }
  


export const getUpdateAiChatCompletionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiChatCompletion>>, TError,{id: string;data: UpdateAiChatCompletionBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAiChatCompletion>>, TError,{id: string;data: UpdateAiChatCompletionBody}, TContext> => {
    
const mutationKey = ['updateAiChatCompletion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAiChatCompletion>>, {id: string;data: UpdateAiChatCompletionBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAiChatCompletion(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAiChatCompletionMutationResult = NonNullable<Awaited<ReturnType<typeof updateAiChatCompletion>>>
    export type UpdateAiChatCompletionMutationBody = UpdateAiChatCompletionBody
    export type UpdateAiChatCompletionMutationError = ErrorType<void>

    /**
 * @summary Update AI Chat Completion
 */
export const useUpdateAiChatCompletion = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiChatCompletion>>, TError,{id: string;data: UpdateAiChatCompletionBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAiChatCompletion>>,
        TError,
        {id: string;data: UpdateAiChatCompletionBody},
        TContext
      > => {

      const mutationOptions = getUpdateAiChatCompletionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create AI Conversation
 */
export const createAiConversation = (
    createAiConversationBody: MaybeRef<CreateAiConversationBody>,
 signal?: AbortSignal
) => {
      createAiConversationBody = unref(createAiConversationBody);
      
      return axiosClient<AiConversation>(
      {url: `/api/ai/conversations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAiConversationBody, signal
    },
      );
    }
  


export const getCreateAiConversationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiConversation>>, TError,{data: CreateAiConversationBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAiConversation>>, TError,{data: CreateAiConversationBody}, TContext> => {
    
const mutationKey = ['createAiConversation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiConversation>>, {data: CreateAiConversationBody}> = (props) => {
          const {data} = props ?? {};

          return  createAiConversation(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAiConversationMutationResult = NonNullable<Awaited<ReturnType<typeof createAiConversation>>>
    export type CreateAiConversationMutationBody = CreateAiConversationBody
    export type CreateAiConversationMutationError = ErrorType<void>

    /**
 * @summary Create AI Conversation
 */
export const useCreateAiConversation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiConversation>>, TError,{data: CreateAiConversationBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createAiConversation>>,
        TError,
        {data: CreateAiConversationBody},
        TContext
      > => {

      const mutationOptions = getCreateAiConversationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of AI Conversations
 */
export const listAiConversations = (
    params?: MaybeRef<ListAiConversationsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedAiConversations>(
      {url: `/api/ai/conversations`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListAiConversationsQueryKey = (params?: MaybeRef<ListAiConversationsParams>,) => {
    return ['api','ai','conversations', ...(params ? [params]: [])] as const;
    }

    
export const useListAiConversationsQueryOptions = <TData = Awaited<ReturnType<typeof listAiConversations>>, TError = ErrorType<void>>(params?: MaybeRef<ListAiConversationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiConversations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiConversationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiConversations>>> = ({ signal }) => listAiConversations(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listAiConversations>>, TError, TData> 
}

export type ListAiConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiConversations>>>
export type ListAiConversationsQueryError = ErrorType<void>


/**
 * @summary List of AI Conversations
 */

export function useListAiConversations<TData = Awaited<ReturnType<typeof listAiConversations>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListAiConversationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiConversations>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListAiConversationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete AI Conversation
 */
export const deleteAiConversation = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/ai/conversations/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAiConversationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiConversation>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiConversation>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAiConversation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiConversation>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAiConversation(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiConversationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiConversation>>>
    
    export type DeleteAiConversationMutationError = ErrorType<void>

    /**
 * @summary Delete AI Conversation
 */
export const useDeleteAiConversation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiConversation>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiConversation>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAiConversationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary AI Conversation Details
 */
export const getAiConversation = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<AiConversation>(
      {url: `/api/ai/conversations/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetAiConversationQueryKey = (id: MaybeRef<string>,) => {
    return ['api','ai','conversations',id] as const;
    }

    
export const useGetAiConversationQueryOptions = <TData = Awaited<ReturnType<typeof getAiConversation>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiConversationQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiConversation>>> = ({ signal }) => getAiConversation(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getAiConversation>>, TError, TData> 
}

export type GetAiConversationQueryResult = NonNullable<Awaited<ReturnType<typeof getAiConversation>>>
export type GetAiConversationQueryError = ErrorType<void>


/**
 * @summary AI Conversation Details
 */

export function useGetAiConversation<TData = Awaited<ReturnType<typeof getAiConversation>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConversation>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAiConversationQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update AI Conversation
 */
export const updateAiConversation = (
    id: MaybeRef<string>,
    updateAiConversationBody: MaybeRef<UpdateAiConversationBody>,
 ) => {
      id = unref(id);
updateAiConversationBody = unref(updateAiConversationBody);
      
      return axiosClient<AiConversation>(
      {url: `/api/ai/conversations/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAiConversationBody
    },
      );
    }
  


export const getUpdateAiConversationMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiConversation>>, TError,{id: string;data: UpdateAiConversationBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAiConversation>>, TError,{id: string;data: UpdateAiConversationBody}, TContext> => {
    
const mutationKey = ['updateAiConversation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAiConversation>>, {id: string;data: UpdateAiConversationBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAiConversation(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAiConversationMutationResult = NonNullable<Awaited<ReturnType<typeof updateAiConversation>>>
    export type UpdateAiConversationMutationBody = UpdateAiConversationBody
    export type UpdateAiConversationMutationError = ErrorType<void>

    /**
 * @summary Update AI Conversation
 */
export const useUpdateAiConversation = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiConversation>>, TError,{id: string;data: UpdateAiConversationBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAiConversation>>,
        TError,
        {id: string;data: UpdateAiConversationBody},
        TContext
      > => {

      const mutationOptions = getUpdateAiConversationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Search of AI Conversations
 */
export const searchAiConversations = (
    params?: MaybeRef<SearchAiConversationsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedAiConversations>(
      {url: `/api/ai/conversations/search`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getSearchAiConversationsQueryKey = (params?: MaybeRef<SearchAiConversationsParams>,) => {
    return ['api','ai','conversations','search', ...(params ? [params]: [])] as const;
    }

    
export const useSearchAiConversationsQueryOptions = <TData = Awaited<ReturnType<typeof searchAiConversations>>, TError = ErrorType<void>>(params?: MaybeRef<SearchAiConversationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAiConversations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSearchAiConversationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchAiConversations>>> = ({ signal }) => searchAiConversations(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof searchAiConversations>>, TError, TData> 
}

export type SearchAiConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof searchAiConversations>>>
export type SearchAiConversationsQueryError = ErrorType<void>


/**
 * @summary Search of AI Conversations
 */

export function useSearchAiConversations<TData = Awaited<ReturnType<typeof searchAiConversations>>, TError = ErrorType<void>>(
 params?: MaybeRef<SearchAiConversationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAiConversations>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useSearchAiConversationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Create AI Converter
 */
export const createAiConverter = (
    createAiConverterBody: MaybeRef<CreateAiConverterBody>,
 signal?: AbortSignal
) => {
      createAiConverterBody = unref(createAiConverterBody);
      
      return axiosClient<void>(
      {url: `/api/ai/converters`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAiConverterBody, signal
    },
      );
    }
  


export const getCreateAiConverterMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiConverter>>, TError,{data: CreateAiConverterBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAiConverter>>, TError,{data: CreateAiConverterBody}, TContext> => {
    
const mutationKey = ['createAiConverter'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiConverter>>, {data: CreateAiConverterBody}> = (props) => {
          const {data} = props ?? {};

          return  createAiConverter(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAiConverterMutationResult = NonNullable<Awaited<ReturnType<typeof createAiConverter>>>
    export type CreateAiConverterMutationBody = CreateAiConverterBody
    export type CreateAiConverterMutationError = ErrorType<void>

    /**
 * @summary Create AI Converter
 */
export const useCreateAiConverter = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiConverter>>, TError,{data: CreateAiConverterBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createAiConverter>>,
        TError,
        {data: CreateAiConverterBody},
        TContext
      > => {

      const mutationOptions = getCreateAiConverterMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List AI Converters
 */
export const listAiConverters = (
    params?: MaybeRef<ListAiConvertersParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedAiConverters>(
      {url: `/api/ai/converters`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListAiConvertersQueryKey = (params?: MaybeRef<ListAiConvertersParams>,) => {
    return ['api','ai','converters', ...(params ? [params]: [])] as const;
    }

    
export const useListAiConvertersQueryOptions = <TData = Awaited<ReturnType<typeof listAiConverters>>, TError = ErrorType<void>>(params?: MaybeRef<ListAiConvertersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiConverters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiConvertersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiConverters>>> = ({ signal }) => listAiConverters(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listAiConverters>>, TError, TData> 
}

export type ListAiConvertersQueryResult = NonNullable<Awaited<ReturnType<typeof listAiConverters>>>
export type ListAiConvertersQueryError = ErrorType<void>


/**
 * @summary List AI Converters
 */

export function useListAiConverters<TData = Awaited<ReturnType<typeof listAiConverters>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListAiConvertersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiConverters>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListAiConvertersQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete AI Converter
 */
export const deleteAiConverter = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/ai/converters/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAiConverterMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiConverter>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiConverter>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAiConverter'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiConverter>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAiConverter(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiConverterMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiConverter>>>
    
    export type DeleteAiConverterMutationError = ErrorType<void>

    /**
 * @summary Delete AI Converter
 */
export const useDeleteAiConverter = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiConverter>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiConverter>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAiConverterMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Show AI Converter
 */
export const getAiConverter = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<AiConverter>(
      {url: `/api/ai/converters/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetAiConverterQueryKey = (id: MaybeRef<string>,) => {
    return ['api','ai','converters',id] as const;
    }

    
export const useGetAiConverterQueryOptions = <TData = Awaited<ReturnType<typeof getAiConverter>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConverter>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiConverterQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiConverter>>> = ({ signal }) => getAiConverter(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getAiConverter>>, TError, TData> 
}

export type GetAiConverterQueryResult = NonNullable<Awaited<ReturnType<typeof getAiConverter>>>
export type GetAiConverterQueryError = ErrorType<void>


/**
 * @summary Show AI Converter
 */

export function useGetAiConverter<TData = Awaited<ReturnType<typeof getAiConverter>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiConverter>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAiConverterQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Create AI DocumentQa
 */
export const createDocumentQa = (
    createDocumentQaBody: MaybeRef<CreateDocumentQaBody>,
 signal?: AbortSignal
) => {
      createDocumentQaBody = unref(createDocumentQaBody);
      
      return axiosClient<AiDocumentQa>(
      {url: `/api/ai/document_qas`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createDocumentQaBody, signal
    },
      );
    }
  


export const getCreateDocumentQaMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDocumentQa>>, TError,{data: CreateDocumentQaBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createDocumentQa>>, TError,{data: CreateDocumentQaBody}, TContext> => {
    
const mutationKey = ['createDocumentQa'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDocumentQa>>, {data: CreateDocumentQaBody}> = (props) => {
          const {data} = props ?? {};

          return  createDocumentQa(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateDocumentQaMutationResult = NonNullable<Awaited<ReturnType<typeof createDocumentQa>>>
    export type CreateDocumentQaMutationBody = CreateDocumentQaBody
    export type CreateDocumentQaMutationError = ErrorType<void>

    /**
 * @summary Create AI DocumentQa
 */
export const useCreateDocumentQa = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDocumentQa>>, TError,{data: CreateDocumentQaBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createDocumentQa>>,
        TError,
        {data: CreateDocumentQaBody},
        TContext
      > => {

      const mutationOptions = getCreateDocumentQaMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of AI DocumentQa
 */
export const listAiDocumentQa = (
    params?: MaybeRef<ListAiDocumentQaParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedAiDocumentQas>(
      {url: `/api/ai/document_qas`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListAiDocumentQaQueryKey = (params?: MaybeRef<ListAiDocumentQaParams>,) => {
    return ['api','ai','document_qas', ...(params ? [params]: [])] as const;
    }

    
export const useListAiDocumentQaQueryOptions = <TData = Awaited<ReturnType<typeof listAiDocumentQa>>, TError = ErrorType<void>>(params?: MaybeRef<ListAiDocumentQaParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiDocumentQa>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiDocumentQaQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiDocumentQa>>> = ({ signal }) => listAiDocumentQa(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listAiDocumentQa>>, TError, TData> 
}

export type ListAiDocumentQaQueryResult = NonNullable<Awaited<ReturnType<typeof listAiDocumentQa>>>
export type ListAiDocumentQaQueryError = ErrorType<void>


/**
 * @summary List of AI DocumentQa
 */

export function useListAiDocumentQa<TData = Awaited<ReturnType<typeof listAiDocumentQa>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListAiDocumentQaParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiDocumentQa>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListAiDocumentQaQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete AI DocumentQa
 */
export const deleteDocumentQa = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/ai/document_qas/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteDocumentQaMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentQa>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentQa>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteDocumentQa'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDocumentQa>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteDocumentQa(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDocumentQaMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDocumentQa>>>
    
    export type DeleteDocumentQaMutationError = ErrorType<void>

    /**
 * @summary Delete AI DocumentQa
 */
export const useDeleteDocumentQa = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentQa>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteDocumentQa>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteDocumentQaMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary AI DocumentQa Details
 */
export const getAiDocumentQa = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<AiDocumentQa>(
      {url: `/api/ai/document_qas/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetAiDocumentQaQueryKey = (id: MaybeRef<string>,) => {
    return ['api','ai','document_qas',id] as const;
    }

    
export const useGetAiDocumentQaQueryOptions = <TData = Awaited<ReturnType<typeof getAiDocumentQa>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiDocumentQa>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiDocumentQaQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiDocumentQa>>> = ({ signal }) => getAiDocumentQa(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getAiDocumentQa>>, TError, TData> 
}

export type GetAiDocumentQaQueryResult = NonNullable<Awaited<ReturnType<typeof getAiDocumentQa>>>
export type GetAiDocumentQaQueryError = ErrorType<void>


/**
 * @summary AI DocumentQa Details
 */

export function useGetAiDocumentQa<TData = Awaited<ReturnType<typeof getAiDocumentQa>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiDocumentQa>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAiDocumentQaQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Create AI Feedback Result
 */
export const createAiFeedbackResult = (
    feedbackId: MaybeRef<string>,
    createAiFeedbackResultBody: MaybeRef<CreateAiFeedbackResultBody>,
 signal?: AbortSignal
) => {
      feedbackId = unref(feedbackId);
createAiFeedbackResultBody = unref(createAiFeedbackResultBody);
      
      return axiosClient<AiFeedbackResult>(
      {url: `/api/ai/feedbacks/${feedbackId}/feedback_results`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAiFeedbackResultBody, signal
    },
      );
    }
  


export const getCreateAiFeedbackResultMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiFeedbackResult>>, TError,{feedbackId: string;data: CreateAiFeedbackResultBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAiFeedbackResult>>, TError,{feedbackId: string;data: CreateAiFeedbackResultBody}, TContext> => {
    
const mutationKey = ['createAiFeedbackResult'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiFeedbackResult>>, {feedbackId: string;data: CreateAiFeedbackResultBody}> = (props) => {
          const {feedbackId,data} = props ?? {};

          return  createAiFeedbackResult(feedbackId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAiFeedbackResultMutationResult = NonNullable<Awaited<ReturnType<typeof createAiFeedbackResult>>>
    export type CreateAiFeedbackResultMutationBody = CreateAiFeedbackResultBody
    export type CreateAiFeedbackResultMutationError = ErrorType<void>

    /**
 * @summary Create AI Feedback Result
 */
export const useCreateAiFeedbackResult = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiFeedbackResult>>, TError,{feedbackId: string;data: CreateAiFeedbackResultBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createAiFeedbackResult>>,
        TError,
        {feedbackId: string;data: CreateAiFeedbackResultBody},
        TContext
      > => {

      const mutationOptions = getCreateAiFeedbackResultMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of AI Feedback Results
 */
export const listAiFeedbackResults = (
    feedbackId: MaybeRef<string>,
    params?: MaybeRef<ListAiFeedbackResultsParams>,
 signal?: AbortSignal
) => {
      feedbackId = unref(feedbackId);
params = unref(params);
      
      return axiosClient<PaginatedAiFeedbackResults>(
      {url: `/api/ai/feedbacks/${feedbackId}/feedback_results`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListAiFeedbackResultsQueryKey = (feedbackId: MaybeRef<string>,
    params?: MaybeRef<ListAiFeedbackResultsParams>,) => {
    return ['api','ai','feedbacks',feedbackId,'feedback_results', ...(params ? [params]: [])] as const;
    }

    
export const useListAiFeedbackResultsQueryOptions = <TData = Awaited<ReturnType<typeof listAiFeedbackResults>>, TError = ErrorType<void>>(feedbackId: MaybeRef<string>,
    params?: MaybeRef<ListAiFeedbackResultsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiFeedbackResults>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiFeedbackResultsQueryKey(feedbackId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiFeedbackResults>>> = ({ signal }) => listAiFeedbackResults(feedbackId,params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listAiFeedbackResults>>, TError, TData> 
}

export type ListAiFeedbackResultsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiFeedbackResults>>>
export type ListAiFeedbackResultsQueryError = ErrorType<void>


/**
 * @summary List of AI Feedback Results
 */

export function useListAiFeedbackResults<TData = Awaited<ReturnType<typeof listAiFeedbackResults>>, TError = ErrorType<void>>(
 feedbackId: MaybeRef<string>,
    params?: MaybeRef<ListAiFeedbackResultsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiFeedbackResults>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListAiFeedbackResultsQueryOptions(feedbackId,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete AI Feedback Result
 */
export const deleteAiFeedbackResult = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/ai/feedback_results/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAiFeedbackResultMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiFeedbackResult>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiFeedbackResult>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAiFeedbackResult'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiFeedbackResult>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAiFeedbackResult(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiFeedbackResultMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiFeedbackResult>>>
    
    export type DeleteAiFeedbackResultMutationError = ErrorType<void>

    /**
 * @summary Delete AI Feedback Result
 */
export const useDeleteAiFeedbackResult = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiFeedbackResult>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiFeedbackResult>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAiFeedbackResultMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary AI Feedback Result Details
 */
export const getAiFeedbackResult = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<AiFeedbackResult>(
      {url: `/api/ai/feedback_results/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetAiFeedbackResultQueryKey = (id: MaybeRef<string>,) => {
    return ['api','ai','feedback_results',id] as const;
    }

    
export const useGetAiFeedbackResultQueryOptions = <TData = Awaited<ReturnType<typeof getAiFeedbackResult>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiFeedbackResult>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiFeedbackResultQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiFeedbackResult>>> = ({ signal }) => getAiFeedbackResult(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getAiFeedbackResult>>, TError, TData> 
}

export type GetAiFeedbackResultQueryResult = NonNullable<Awaited<ReturnType<typeof getAiFeedbackResult>>>
export type GetAiFeedbackResultQueryError = ErrorType<void>


/**
 * @summary AI Feedback Result Details
 */

export function useGetAiFeedbackResult<TData = Awaited<ReturnType<typeof getAiFeedbackResult>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiFeedbackResult>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAiFeedbackResultQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update AI Feedback Result
 */
export const updateAiFeedbackResult = (
    id: MaybeRef<string>,
    updateAiFeedbackResultBody: MaybeRef<UpdateAiFeedbackResultBody>,
 ) => {
      id = unref(id);
updateAiFeedbackResultBody = unref(updateAiFeedbackResultBody);
      
      return axiosClient<AiFeedbackResult>(
      {url: `/api/ai/feedback_results/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAiFeedbackResultBody
    },
      );
    }
  


export const getUpdateAiFeedbackResultMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiFeedbackResult>>, TError,{id: string;data: UpdateAiFeedbackResultBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAiFeedbackResult>>, TError,{id: string;data: UpdateAiFeedbackResultBody}, TContext> => {
    
const mutationKey = ['updateAiFeedbackResult'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAiFeedbackResult>>, {id: string;data: UpdateAiFeedbackResultBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAiFeedbackResult(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAiFeedbackResultMutationResult = NonNullable<Awaited<ReturnType<typeof updateAiFeedbackResult>>>
    export type UpdateAiFeedbackResultMutationBody = UpdateAiFeedbackResultBody
    export type UpdateAiFeedbackResultMutationError = ErrorType<void>

    /**
 * @summary Update AI Feedback Result
 */
export const useUpdateAiFeedbackResult = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiFeedbackResult>>, TError,{id: string;data: UpdateAiFeedbackResultBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAiFeedbackResult>>,
        TError,
        {id: string;data: UpdateAiFeedbackResultBody},
        TContext
      > => {

      const mutationOptions = getUpdateAiFeedbackResultMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create AI Feedback
 */
export const createAiFeedback = (
    createAiFeedbackBody: MaybeRef<CreateAiFeedbackBody>,
 signal?: AbortSignal
) => {
      createAiFeedbackBody = unref(createAiFeedbackBody);
      
      return axiosClient<AiFeedback>(
      {url: `/api/ai/feedbacks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAiFeedbackBody, signal
    },
      );
    }
  


export const getCreateAiFeedbackMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiFeedback>>, TError,{data: CreateAiFeedbackBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAiFeedback>>, TError,{data: CreateAiFeedbackBody}, TContext> => {
    
const mutationKey = ['createAiFeedback'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiFeedback>>, {data: CreateAiFeedbackBody}> = (props) => {
          const {data} = props ?? {};

          return  createAiFeedback(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAiFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof createAiFeedback>>>
    export type CreateAiFeedbackMutationBody = CreateAiFeedbackBody
    export type CreateAiFeedbackMutationError = ErrorType<void>

    /**
 * @summary Create AI Feedback
 */
export const useCreateAiFeedback = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiFeedback>>, TError,{data: CreateAiFeedbackBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createAiFeedback>>,
        TError,
        {data: CreateAiFeedbackBody},
        TContext
      > => {

      const mutationOptions = getCreateAiFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of AI Feedbacks
 */
export const listAiFeedbacks = (
    params?: MaybeRef<ListAiFeedbacksParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedAiFeedbacks>(
      {url: `/api/ai/feedbacks`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListAiFeedbacksQueryKey = (params?: MaybeRef<ListAiFeedbacksParams>,) => {
    return ['api','ai','feedbacks', ...(params ? [params]: [])] as const;
    }

    
export const useListAiFeedbacksQueryOptions = <TData = Awaited<ReturnType<typeof listAiFeedbacks>>, TError = ErrorType<void>>(params?: MaybeRef<ListAiFeedbacksParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiFeedbacks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiFeedbacksQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiFeedbacks>>> = ({ signal }) => listAiFeedbacks(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listAiFeedbacks>>, TError, TData> 
}

export type ListAiFeedbacksQueryResult = NonNullable<Awaited<ReturnType<typeof listAiFeedbacks>>>
export type ListAiFeedbacksQueryError = ErrorType<void>


/**
 * @summary List of AI Feedbacks
 */

export function useListAiFeedbacks<TData = Awaited<ReturnType<typeof listAiFeedbacks>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListAiFeedbacksParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiFeedbacks>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListAiFeedbacksQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete AI Feedback
 */
export const deleteAiFeedback = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/ai/feedbacks/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAiFeedbackMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiFeedback>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiFeedback>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAiFeedback'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiFeedback>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAiFeedback(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiFeedback>>>
    
    export type DeleteAiFeedbackMutationError = ErrorType<void>

    /**
 * @summary Delete AI Feedback
 */
export const useDeleteAiFeedback = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiFeedback>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiFeedback>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAiFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary AI Feedback Details
 */
export const getAiFeedback = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<AiFeedback>(
      {url: `/api/ai/feedbacks/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetAiFeedbackQueryKey = (id: MaybeRef<string>,) => {
    return ['api','ai','feedbacks',id] as const;
    }

    
export const useGetAiFeedbackQueryOptions = <TData = Awaited<ReturnType<typeof getAiFeedback>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiFeedback>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiFeedbackQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiFeedback>>> = ({ signal }) => getAiFeedback(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getAiFeedback>>, TError, TData> 
}

export type GetAiFeedbackQueryResult = NonNullable<Awaited<ReturnType<typeof getAiFeedback>>>
export type GetAiFeedbackQueryError = ErrorType<void>


/**
 * @summary AI Feedback Details
 */

export function useGetAiFeedback<TData = Awaited<ReturnType<typeof getAiFeedback>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiFeedback>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAiFeedbackQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update AI Feedback
 */
export const updateAiFeedback = (
    id: MaybeRef<string>,
    updateAiFeedbackBody: MaybeRef<UpdateAiFeedbackBody>,
 ) => {
      id = unref(id);
updateAiFeedbackBody = unref(updateAiFeedbackBody);
      
      return axiosClient<AiFeedback>(
      {url: `/api/ai/feedbacks/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAiFeedbackBody
    },
      );
    }
  


export const getUpdateAiFeedbackMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiFeedback>>, TError,{id: string;data: UpdateAiFeedbackBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAiFeedback>>, TError,{id: string;data: UpdateAiFeedbackBody}, TContext> => {
    
const mutationKey = ['updateAiFeedback'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAiFeedback>>, {id: string;data: UpdateAiFeedbackBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAiFeedback(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAiFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof updateAiFeedback>>>
    export type UpdateAiFeedbackMutationBody = UpdateAiFeedbackBody
    export type UpdateAiFeedbackMutationError = ErrorType<void>

    /**
 * @summary Update AI Feedback
 */
export const useUpdateAiFeedback = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiFeedback>>, TError,{id: string;data: UpdateAiFeedbackBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAiFeedback>>,
        TError,
        {id: string;data: UpdateAiFeedbackBody},
        TContext
      > => {

      const mutationOptions = getUpdateAiFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create AI ImageRecognition
 */
export const createImageRecognition = (
    createImageRecognitionBody: MaybeRef<CreateImageRecognitionBody>,
 signal?: AbortSignal
) => {
      createImageRecognitionBody = unref(createImageRecognitionBody);
      
      return axiosClient<AiImageRecognition>(
      {url: `/api/ai/image_recognitions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createImageRecognitionBody, signal
    },
      );
    }
  


export const getCreateImageRecognitionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImageRecognition>>, TError,{data: CreateImageRecognitionBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createImageRecognition>>, TError,{data: CreateImageRecognitionBody}, TContext> => {
    
const mutationKey = ['createImageRecognition'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createImageRecognition>>, {data: CreateImageRecognitionBody}> = (props) => {
          const {data} = props ?? {};

          return  createImageRecognition(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateImageRecognitionMutationResult = NonNullable<Awaited<ReturnType<typeof createImageRecognition>>>
    export type CreateImageRecognitionMutationBody = CreateImageRecognitionBody
    export type CreateImageRecognitionMutationError = ErrorType<void>

    /**
 * @summary Create AI ImageRecognition
 */
export const useCreateImageRecognition = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImageRecognition>>, TError,{data: CreateImageRecognitionBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createImageRecognition>>,
        TError,
        {data: CreateImageRecognitionBody},
        TContext
      > => {

      const mutationOptions = getCreateImageRecognitionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of AI ImageRecognition
 */
export const listAiImageRecognition = (
    params?: MaybeRef<ListAiImageRecognitionParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedAiImageRecognitions>(
      {url: `/api/ai/image_recognitions`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListAiImageRecognitionQueryKey = (params?: MaybeRef<ListAiImageRecognitionParams>,) => {
    return ['api','ai','image_recognitions', ...(params ? [params]: [])] as const;
    }

    
export const useListAiImageRecognitionQueryOptions = <TData = Awaited<ReturnType<typeof listAiImageRecognition>>, TError = ErrorType<void>>(params?: MaybeRef<ListAiImageRecognitionParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiImageRecognition>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiImageRecognitionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiImageRecognition>>> = ({ signal }) => listAiImageRecognition(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listAiImageRecognition>>, TError, TData> 
}

export type ListAiImageRecognitionQueryResult = NonNullable<Awaited<ReturnType<typeof listAiImageRecognition>>>
export type ListAiImageRecognitionQueryError = ErrorType<void>


/**
 * @summary List of AI ImageRecognition
 */

export function useListAiImageRecognition<TData = Awaited<ReturnType<typeof listAiImageRecognition>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListAiImageRecognitionParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiImageRecognition>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListAiImageRecognitionQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete AI ImageRecognition
 */
export const deleteAiImageRecognition = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/ai/image_recognitions/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAiImageRecognitionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiImageRecognition>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiImageRecognition>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAiImageRecognition'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiImageRecognition>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAiImageRecognition(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiImageRecognitionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiImageRecognition>>>
    
    export type DeleteAiImageRecognitionMutationError = ErrorType<void>

    /**
 * @summary Delete AI ImageRecognition
 */
export const useDeleteAiImageRecognition = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiImageRecognition>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiImageRecognition>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAiImageRecognitionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary AI ImageRecognition Details
 */
export const getAiImageRecognition = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<AiImageRecognition>(
      {url: `/api/ai/image_recognitions/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetAiImageRecognitionQueryKey = (id: MaybeRef<string>,) => {
    return ['api','ai','image_recognitions',id] as const;
    }

    
export const useGetAiImageRecognitionQueryOptions = <TData = Awaited<ReturnType<typeof getAiImageRecognition>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiImageRecognition>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiImageRecognitionQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiImageRecognition>>> = ({ signal }) => getAiImageRecognition(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getAiImageRecognition>>, TError, TData> 
}

export type GetAiImageRecognitionQueryResult = NonNullable<Awaited<ReturnType<typeof getAiImageRecognition>>>
export type GetAiImageRecognitionQueryError = ErrorType<void>


/**
 * @summary AI ImageRecognition Details
 */

export function useGetAiImageRecognition<TData = Awaited<ReturnType<typeof getAiImageRecognition>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiImageRecognition>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAiImageRecognitionQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update AI ImageRecognition
 */
export const updateAiImageRecognition = (
    id: MaybeRef<string>,
    updateAiImageRecognitionBody: MaybeRef<UpdateAiImageRecognitionBody>,
 ) => {
      id = unref(id);
updateAiImageRecognitionBody = unref(updateAiImageRecognitionBody);
      
      return axiosClient<AiImageRecognition>(
      {url: `/api/ai/image_recognitions/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAiImageRecognitionBody
    },
      );
    }
  


export const getUpdateAiImageRecognitionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiImageRecognition>>, TError,{id: string;data: UpdateAiImageRecognitionBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAiImageRecognition>>, TError,{id: string;data: UpdateAiImageRecognitionBody}, TContext> => {
    
const mutationKey = ['updateAiImageRecognition'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAiImageRecognition>>, {id: string;data: UpdateAiImageRecognitionBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAiImageRecognition(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAiImageRecognitionMutationResult = NonNullable<Awaited<ReturnType<typeof updateAiImageRecognition>>>
    export type UpdateAiImageRecognitionMutationBody = UpdateAiImageRecognitionBody
    export type UpdateAiImageRecognitionMutationError = ErrorType<void>

    /**
 * @summary Update AI ImageRecognition
 */
export const useUpdateAiImageRecognition = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiImageRecognition>>, TError,{id: string;data: UpdateAiImageRecognitionBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAiImageRecognition>>,
        TError,
        {id: string;data: UpdateAiImageRecognitionBody},
        TContext
      > => {

      const mutationOptions = getUpdateAiImageRecognitionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create AI Image
 */
export const createImage = (
    createImageBody: MaybeRef<CreateImageBody>,
 signal?: AbortSignal
) => {
      createImageBody = unref(createImageBody);
      
      return axiosClient<AiImage>(
      {url: `/api/ai/images`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createImageBody, signal
    },
      );
    }
  


export const getCreateImageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImage>>, TError,{data: CreateImageBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createImage>>, TError,{data: CreateImageBody}, TContext> => {
    
const mutationKey = ['createImage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createImage>>, {data: CreateImageBody}> = (props) => {
          const {data} = props ?? {};

          return  createImage(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateImageMutationResult = NonNullable<Awaited<ReturnType<typeof createImage>>>
    export type CreateImageMutationBody = CreateImageBody
    export type CreateImageMutationError = ErrorType<void>

    /**
 * @summary Create AI Image
 */
export const useCreateImage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImage>>, TError,{data: CreateImageBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createImage>>,
        TError,
        {data: CreateImageBody},
        TContext
      > => {

      const mutationOptions = getCreateImageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of AI Images
 */
export const listAiImages = (
    params?: MaybeRef<ListAiImagesParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedAiImages>(
      {url: `/api/ai/images`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListAiImagesQueryKey = (params?: MaybeRef<ListAiImagesParams>,) => {
    return ['api','ai','images', ...(params ? [params]: [])] as const;
    }

    
export const useListAiImagesQueryOptions = <TData = Awaited<ReturnType<typeof listAiImages>>, TError = ErrorType<void>>(params?: MaybeRef<ListAiImagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiImages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiImagesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiImages>>> = ({ signal }) => listAiImages(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listAiImages>>, TError, TData> 
}

export type ListAiImagesQueryResult = NonNullable<Awaited<ReturnType<typeof listAiImages>>>
export type ListAiImagesQueryError = ErrorType<void>


/**
 * @summary List of AI Images
 */

export function useListAiImages<TData = Awaited<ReturnType<typeof listAiImages>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListAiImagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiImages>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListAiImagesQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete AI Assistant
 */
export const deleteAiImage = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/ai/images/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAiImageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiImage>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiImage>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAiImage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiImage>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAiImage(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiImageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiImage>>>
    
    export type DeleteAiImageMutationError = ErrorType<void>

    /**
 * @summary Delete AI Assistant
 */
export const useDeleteAiImage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiImage>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiImage>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAiImageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary AI Image Details
 */
export const getAiImage = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<AiImage>(
      {url: `/api/ai/images/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetAiImageQueryKey = (id: MaybeRef<string>,) => {
    return ['api','ai','images',id] as const;
    }

    
export const useGetAiImageQueryOptions = <TData = Awaited<ReturnType<typeof getAiImage>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiImage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiImageQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiImage>>> = ({ signal }) => getAiImage(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getAiImage>>, TError, TData> 
}

export type GetAiImageQueryResult = NonNullable<Awaited<ReturnType<typeof getAiImage>>>
export type GetAiImageQueryError = ErrorType<void>


/**
 * @summary AI Image Details
 */

export function useGetAiImage<TData = Awaited<ReturnType<typeof getAiImage>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiImage>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAiImageQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Create AI Message
 */
export const createAiMessage = (
    createAiMessageBody: MaybeRef<CreateAiMessageBody>,
    params: MaybeRef<CreateAiMessageParams>,
 signal?: AbortSignal
) => {
      createAiMessageBody = unref(createAiMessageBody);
params = unref(params);
      
      return axiosClient<AiMessage>(
      {url: `/api/ai/messages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAiMessageBody,
        params: unref(params), signal
    },
      );
    }
  


export const getCreateAiMessageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiMessage>>, TError,{data: CreateAiMessageBody;params: CreateAiMessageParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAiMessage>>, TError,{data: CreateAiMessageBody;params: CreateAiMessageParams}, TContext> => {
    
const mutationKey = ['createAiMessage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiMessage>>, {data: CreateAiMessageBody;params: CreateAiMessageParams}> = (props) => {
          const {data,params} = props ?? {};

          return  createAiMessage(data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAiMessageMutationResult = NonNullable<Awaited<ReturnType<typeof createAiMessage>>>
    export type CreateAiMessageMutationBody = CreateAiMessageBody
    export type CreateAiMessageMutationError = ErrorType<void>

    /**
 * @summary Create AI Message
 */
export const useCreateAiMessage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiMessage>>, TError,{data: CreateAiMessageBody;params: CreateAiMessageParams}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createAiMessage>>,
        TError,
        {data: CreateAiMessageBody;params: CreateAiMessageParams},
        TContext
      > => {

      const mutationOptions = getCreateAiMessageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of AI Messages
 */
export const listAiMessages = (
    params: MaybeRef<ListAiMessagesParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedAiMessages>(
      {url: `/api/ai/messages`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListAiMessagesQueryKey = (params: MaybeRef<ListAiMessagesParams>,) => {
    return ['api','ai','messages', ...(params ? [params]: [])] as const;
    }

    
export const useListAiMessagesQueryOptions = <TData = Awaited<ReturnType<typeof listAiMessages>>, TError = ErrorType<void>>(params: MaybeRef<ListAiMessagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiMessages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiMessagesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiMessages>>> = ({ signal }) => listAiMessages(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listAiMessages>>, TError, TData> 
}

export type ListAiMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof listAiMessages>>>
export type ListAiMessagesQueryError = ErrorType<void>


/**
 * @summary List of AI Messages
 */

export function useListAiMessages<TData = Awaited<ReturnType<typeof listAiMessages>>, TError = ErrorType<void>>(
 params: MaybeRef<ListAiMessagesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiMessages>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListAiMessagesQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete AI Message
 */
export const deleteAiMessage = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/ai/messages/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAiMessageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiMessage>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiMessage>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAiMessage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiMessage>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAiMessage(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiMessageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiMessage>>>
    
    export type DeleteAiMessageMutationError = ErrorType<void>

    /**
 * @summary Delete AI Message
 */
export const useDeleteAiMessage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiMessage>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiMessage>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAiMessageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary AI Message Details
 */
export const getAiMessage = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<AiMessage>(
      {url: `/api/ai/messages/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetAiMessageQueryKey = (id: MaybeRef<string>,) => {
    return ['api','ai','messages',id] as const;
    }

    
export const useGetAiMessageQueryOptions = <TData = Awaited<ReturnType<typeof getAiMessage>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiMessage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiMessageQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiMessage>>> = ({ signal }) => getAiMessage(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getAiMessage>>, TError, TData> 
}

export type GetAiMessageQueryResult = NonNullable<Awaited<ReturnType<typeof getAiMessage>>>
export type GetAiMessageQueryError = ErrorType<void>


/**
 * @summary AI Message Details
 */

export function useGetAiMessage<TData = Awaited<ReturnType<typeof getAiMessage>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiMessage>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAiMessageQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Create AI MiniToolRequest
 */
export const createMiniToolRequest = (
    miniToolId: MaybeRef<string>,
    createMiniToolRequestBody: MaybeRef<CreateMiniToolRequestBody>,
 signal?: AbortSignal
) => {
      miniToolId = unref(miniToolId);
createMiniToolRequestBody = unref(createMiniToolRequestBody);
      
      return axiosClient<AiMiniToolRequest>(
      {url: `/api/ai/mini_tools/${miniToolId}/mini_tool_requests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMiniToolRequestBody, signal
    },
      );
    }
  


export const getCreateMiniToolRequestMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMiniToolRequest>>, TError,{miniToolId: string;data: CreateMiniToolRequestBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createMiniToolRequest>>, TError,{miniToolId: string;data: CreateMiniToolRequestBody}, TContext> => {
    
const mutationKey = ['createMiniToolRequest'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMiniToolRequest>>, {miniToolId: string;data: CreateMiniToolRequestBody}> = (props) => {
          const {miniToolId,data} = props ?? {};

          return  createMiniToolRequest(miniToolId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateMiniToolRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createMiniToolRequest>>>
    export type CreateMiniToolRequestMutationBody = CreateMiniToolRequestBody
    export type CreateMiniToolRequestMutationError = ErrorType<void>

    /**
 * @summary Create AI MiniToolRequest
 */
export const useCreateMiniToolRequest = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMiniToolRequest>>, TError,{miniToolId: string;data: CreateMiniToolRequestBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createMiniToolRequest>>,
        TError,
        {miniToolId: string;data: CreateMiniToolRequestBody},
        TContext
      > => {

      const mutationOptions = getCreateMiniToolRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Delete AI MiniToolRequest
 */
export const deleteMiniToolRequest = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/ai/mini_tool_requests/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteMiniToolRequestMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMiniToolRequest>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteMiniToolRequest>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteMiniToolRequest'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMiniToolRequest>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteMiniToolRequest(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMiniToolRequestMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMiniToolRequest>>>
    
    export type DeleteMiniToolRequestMutationError = ErrorType<void>

    /**
 * @summary Delete AI MiniToolRequest
 */
export const useDeleteMiniToolRequest = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMiniToolRequest>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteMiniToolRequest>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteMiniToolRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of AI MiniToolRequests
 */
export const listAiMiniToolRequests = (
    params?: MaybeRef<ListAiMiniToolRequestsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedAiMiniToolRequests>(
      {url: `/api/ai/mini_tool_requests`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListAiMiniToolRequestsQueryKey = (params?: MaybeRef<ListAiMiniToolRequestsParams>,) => {
    return ['api','ai','mini_tool_requests', ...(params ? [params]: [])] as const;
    }

    
export const useListAiMiniToolRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listAiMiniToolRequests>>, TError = ErrorType<void>>(params?: MaybeRef<ListAiMiniToolRequestsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiMiniToolRequests>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiMiniToolRequestsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiMiniToolRequests>>> = ({ signal }) => listAiMiniToolRequests(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listAiMiniToolRequests>>, TError, TData> 
}

export type ListAiMiniToolRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiMiniToolRequests>>>
export type ListAiMiniToolRequestsQueryError = ErrorType<void>


/**
 * @summary List of AI MiniToolRequests
 */

export function useListAiMiniToolRequests<TData = Awaited<ReturnType<typeof listAiMiniToolRequests>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListAiMiniToolRequestsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiMiniToolRequests>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListAiMiniToolRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Create AI MiniTool
 */
export const createMiniTool = (
    createMiniToolBody: MaybeRef<CreateMiniToolBody>,
 signal?: AbortSignal
) => {
      createMiniToolBody = unref(createMiniToolBody);
      
      return axiosClient<AiMiniTool>(
      {url: `/api/ai/mini_tools`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMiniToolBody, signal
    },
      );
    }
  


export const getCreateMiniToolMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMiniTool>>, TError,{data: CreateMiniToolBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createMiniTool>>, TError,{data: CreateMiniToolBody}, TContext> => {
    
const mutationKey = ['createMiniTool'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMiniTool>>, {data: CreateMiniToolBody}> = (props) => {
          const {data} = props ?? {};

          return  createMiniTool(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateMiniToolMutationResult = NonNullable<Awaited<ReturnType<typeof createMiniTool>>>
    export type CreateMiniToolMutationBody = CreateMiniToolBody
    export type CreateMiniToolMutationError = ErrorType<void>

    /**
 * @summary Create AI MiniTool
 */
export const useCreateMiniTool = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMiniTool>>, TError,{data: CreateMiniToolBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createMiniTool>>,
        TError,
        {data: CreateMiniToolBody},
        TContext
      > => {

      const mutationOptions = getCreateMiniToolMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of AI MiniTools
 */
export const listAiMiniTools = (
    params?: MaybeRef<ListAiMiniToolsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedAiMiniTools>(
      {url: `/api/ai/mini_tools`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListAiMiniToolsQueryKey = (params?: MaybeRef<ListAiMiniToolsParams>,) => {
    return ['api','ai','mini_tools', ...(params ? [params]: [])] as const;
    }

    
export const useListAiMiniToolsQueryOptions = <TData = Awaited<ReturnType<typeof listAiMiniTools>>, TError = ErrorType<unknown>>(params?: MaybeRef<ListAiMiniToolsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiMiniTools>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiMiniToolsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiMiniTools>>> = ({ signal }) => listAiMiniTools(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listAiMiniTools>>, TError, TData> 
}

export type ListAiMiniToolsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiMiniTools>>>
export type ListAiMiniToolsQueryError = ErrorType<unknown>


/**
 * @summary List of AI MiniTools
 */

export function useListAiMiniTools<TData = Awaited<ReturnType<typeof listAiMiniTools>>, TError = ErrorType<unknown>>(
 params?: MaybeRef<ListAiMiniToolsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiMiniTools>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListAiMiniToolsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete AI MiniTool
 */
export const deleteAiMiniTool = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/ai/mini_tools/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAiMiniToolMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiMiniTool>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiMiniTool>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAiMiniTool'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiMiniTool>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAiMiniTool(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiMiniToolMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiMiniTool>>>
    
    export type DeleteAiMiniToolMutationError = ErrorType<void>

    /**
 * @summary Delete AI MiniTool
 */
export const useDeleteAiMiniTool = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiMiniTool>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiMiniTool>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAiMiniToolMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary AI MiniTool
 */
export const getAiMiniTool = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<AiMiniTool>(
      {url: `/api/ai/mini_tools/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetAiMiniToolQueryKey = (id: MaybeRef<string>,) => {
    return ['api','ai','mini_tools',id] as const;
    }

    
export const useGetAiMiniToolQueryOptions = <TData = Awaited<ReturnType<typeof getAiMiniTool>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiMiniTool>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiMiniToolQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiMiniTool>>> = ({ signal }) => getAiMiniTool(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getAiMiniTool>>, TError, TData> 
}

export type GetAiMiniToolQueryResult = NonNullable<Awaited<ReturnType<typeof getAiMiniTool>>>
export type GetAiMiniToolQueryError = ErrorType<void>


/**
 * @summary AI MiniTool
 */

export function useGetAiMiniTool<TData = Awaited<ReturnType<typeof getAiMiniTool>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiMiniTool>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAiMiniToolQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List of featured AI MiniTools
 */
export const listFeaturedAiMiniTools = (
    params?: MaybeRef<ListFeaturedAiMiniToolsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedAiMiniTools>(
      {url: `/api/ai/mini_tools/featured`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListFeaturedAiMiniToolsQueryKey = (params?: MaybeRef<ListFeaturedAiMiniToolsParams>,) => {
    return ['api','ai','mini_tools','featured', ...(params ? [params]: [])] as const;
    }

    
export const useListFeaturedAiMiniToolsQueryOptions = <TData = Awaited<ReturnType<typeof listFeaturedAiMiniTools>>, TError = ErrorType<unknown>>(params?: MaybeRef<ListFeaturedAiMiniToolsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeaturedAiMiniTools>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListFeaturedAiMiniToolsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFeaturedAiMiniTools>>> = ({ signal }) => listFeaturedAiMiniTools(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listFeaturedAiMiniTools>>, TError, TData> 
}

export type ListFeaturedAiMiniToolsQueryResult = NonNullable<Awaited<ReturnType<typeof listFeaturedAiMiniTools>>>
export type ListFeaturedAiMiniToolsQueryError = ErrorType<unknown>


/**
 * @summary List of featured AI MiniTools
 */

export function useListFeaturedAiMiniTools<TData = Awaited<ReturnType<typeof listFeaturedAiMiniTools>>, TError = ErrorType<unknown>>(
 params?: MaybeRef<ListFeaturedAiMiniToolsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeaturedAiMiniTools>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListFeaturedAiMiniToolsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List of AI Model Cards
 */
export const listAiModelCards = (
    params?: MaybeRef<ListAiModelCardsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedAiModelCards>(
      {url: `/api/ai/model_cards`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListAiModelCardsQueryKey = (params?: MaybeRef<ListAiModelCardsParams>,) => {
    return ['api','ai','model_cards', ...(params ? [params]: [])] as const;
    }

    
export const useListAiModelCardsQueryOptions = <TData = Awaited<ReturnType<typeof listAiModelCards>>, TError = ErrorType<unknown>>(params?: MaybeRef<ListAiModelCardsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiModelCards>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiModelCardsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiModelCards>>> = ({ signal }) => listAiModelCards(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listAiModelCards>>, TError, TData> 
}

export type ListAiModelCardsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiModelCards>>>
export type ListAiModelCardsQueryError = ErrorType<unknown>


/**
 * @summary List of AI Model Cards
 */

export function useListAiModelCards<TData = Awaited<ReturnType<typeof listAiModelCards>>, TError = ErrorType<unknown>>(
 params?: MaybeRef<ListAiModelCardsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiModelCards>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListAiModelCardsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Create AI Personas
 */
export const createAiPersona = (
    createAiPersonaBody: MaybeRef<CreateAiPersonaBody>,
 signal?: AbortSignal
) => {
      createAiPersonaBody = unref(createAiPersonaBody);
      
      return axiosClient<AiPersona>(
      {url: `/api/ai/personas`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAiPersonaBody, signal
    },
      );
    }
  


export const getCreateAiPersonaMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiPersona>>, TError,{data: CreateAiPersonaBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAiPersona>>, TError,{data: CreateAiPersonaBody}, TContext> => {
    
const mutationKey = ['createAiPersona'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiPersona>>, {data: CreateAiPersonaBody}> = (props) => {
          const {data} = props ?? {};

          return  createAiPersona(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAiPersonaMutationResult = NonNullable<Awaited<ReturnType<typeof createAiPersona>>>
    export type CreateAiPersonaMutationBody = CreateAiPersonaBody
    export type CreateAiPersonaMutationError = ErrorType<void>

    /**
 * @summary Create AI Personas
 */
export const useCreateAiPersona = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiPersona>>, TError,{data: CreateAiPersonaBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createAiPersona>>,
        TError,
        {data: CreateAiPersonaBody},
        TContext
      > => {

      const mutationOptions = getCreateAiPersonaMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of AI Personas
 */
export const listAiPersonas = (
    params?: MaybeRef<ListAiPersonasParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedAiPersonas>(
      {url: `/api/ai/personas`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListAiPersonasQueryKey = (params?: MaybeRef<ListAiPersonasParams>,) => {
    return ['api','ai','personas', ...(params ? [params]: [])] as const;
    }

    
export const useListAiPersonasQueryOptions = <TData = Awaited<ReturnType<typeof listAiPersonas>>, TError = ErrorType<void>>(params?: MaybeRef<ListAiPersonasParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiPersonas>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiPersonasQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiPersonas>>> = ({ signal }) => listAiPersonas(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listAiPersonas>>, TError, TData> 
}

export type ListAiPersonasQueryResult = NonNullable<Awaited<ReturnType<typeof listAiPersonas>>>
export type ListAiPersonasQueryError = ErrorType<void>


/**
 * @summary List of AI Personas
 */

export function useListAiPersonas<TData = Awaited<ReturnType<typeof listAiPersonas>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListAiPersonasParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiPersonas>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListAiPersonasQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete AI Personas
 */
export const deleteAiPersonas = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/ai/personas/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAiPersonasMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiPersonas>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiPersonas>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAiPersonas'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiPersonas>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAiPersonas(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiPersonasMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiPersonas>>>
    
    export type DeleteAiPersonasMutationError = ErrorType<void>

    /**
 * @summary Delete AI Personas
 */
export const useDeleteAiPersonas = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiPersonas>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiPersonas>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAiPersonasMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get AI Personas Details
 */
export const getAiPersona = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<AiPersona>(
      {url: `/api/ai/personas/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetAiPersonaQueryKey = (id: MaybeRef<string>,) => {
    return ['api','ai','personas',id] as const;
    }

    
export const useGetAiPersonaQueryOptions = <TData = Awaited<ReturnType<typeof getAiPersona>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiPersona>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiPersonaQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiPersona>>> = ({ signal }) => getAiPersona(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getAiPersona>>, TError, TData> 
}

export type GetAiPersonaQueryResult = NonNullable<Awaited<ReturnType<typeof getAiPersona>>>
export type GetAiPersonaQueryError = ErrorType<void>


/**
 * @summary Get AI Personas Details
 */

export function useGetAiPersona<TData = Awaited<ReturnType<typeof getAiPersona>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiPersona>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAiPersonaQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update AI Personas
 */
export const updateAiPersona = (
    id: MaybeRef<string>,
    updateAiPersonaBody: MaybeRef<UpdateAiPersonaBody>,
 ) => {
      id = unref(id);
updateAiPersonaBody = unref(updateAiPersonaBody);
      
      return axiosClient<AiPersona>(
      {url: `/api/ai/personas/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAiPersonaBody
    },
      );
    }
  


export const getUpdateAiPersonaMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiPersona>>, TError,{id: string;data: UpdateAiPersonaBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAiPersona>>, TError,{id: string;data: UpdateAiPersonaBody}, TContext> => {
    
const mutationKey = ['updateAiPersona'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAiPersona>>, {id: string;data: UpdateAiPersonaBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAiPersona(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAiPersonaMutationResult = NonNullable<Awaited<ReturnType<typeof updateAiPersona>>>
    export type UpdateAiPersonaMutationBody = UpdateAiPersonaBody
    export type UpdateAiPersonaMutationError = ErrorType<void>

    /**
 * @summary Update AI Personas
 */
export const useUpdateAiPersona = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiPersona>>, TError,{id: string;data: UpdateAiPersonaBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAiPersona>>,
        TError,
        {id: string;data: UpdateAiPersonaBody},
        TContext
      > => {

      const mutationOptions = getUpdateAiPersonaMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Cancel AI Run
 */
export const cancelAiRun = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/ai/runs/${id}/cancel`, method: 'PUT'
    },
      );
    }
  


export const getCancelAiRunMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAiRun>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelAiRun>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['cancelAiRun'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelAiRun>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  cancelAiRun(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelAiRunMutationResult = NonNullable<Awaited<ReturnType<typeof cancelAiRun>>>
    
    export type CancelAiRunMutationError = ErrorType<void>

    /**
 * @summary Cancel AI Run
 */
export const useCancelAiRun = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAiRun>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof cancelAiRun>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCancelAiRunMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create AI Run
 */
export const createAiRun = (
    createAiRunBody: MaybeRef<CreateAiRunBody>,
 signal?: AbortSignal
) => {
      createAiRunBody = unref(createAiRunBody);
      
      return axiosClient<AiRun>(
      {url: `/api/ai/runs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAiRunBody, signal
    },
      );
    }
  


export const getCreateAiRunMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiRun>>, TError,{data: CreateAiRunBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAiRun>>, TError,{data: CreateAiRunBody}, TContext> => {
    
const mutationKey = ['createAiRun'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiRun>>, {data: CreateAiRunBody}> = (props) => {
          const {data} = props ?? {};

          return  createAiRun(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAiRunMutationResult = NonNullable<Awaited<ReturnType<typeof createAiRun>>>
    export type CreateAiRunMutationBody = CreateAiRunBody
    export type CreateAiRunMutationError = ErrorType<void>

    /**
 * @summary Create AI Run
 */
export const useCreateAiRun = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiRun>>, TError,{data: CreateAiRunBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createAiRun>>,
        TError,
        {data: CreateAiRunBody},
        TContext
      > => {

      const mutationOptions = getCreateAiRunMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of AI Runs
 */
export const listAiRuns = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<PaginatedAiRuns>(
      {url: `/api/ai/runs`, method: 'GET', signal
    },
      );
    }
  

const getListAiRunsQueryKey = () => {
    return ['api','ai','runs'] as const;
    }

    
export const useListAiRunsQueryOptions = <TData = Awaited<ReturnType<typeof listAiRuns>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiRuns>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiRunsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiRuns>>> = ({ signal }) => listAiRuns(signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listAiRuns>>, TError, TData> 
}

export type ListAiRunsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiRuns>>>
export type ListAiRunsQueryError = ErrorType<void>


/**
 * @summary List of AI Runs
 */

export function useListAiRuns<TData = Awaited<ReturnType<typeof listAiRuns>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiRuns>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListAiRunsQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete AI Run Details
 */
export const deleteAiRun = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/ai/runs/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAiRunMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiRun>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiRun>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAiRun'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiRun>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAiRun(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiRunMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiRun>>>
    
    export type DeleteAiRunMutationError = ErrorType<void>

    /**
 * @summary Delete AI Run Details
 */
export const useDeleteAiRun = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiRun>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiRun>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAiRunMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary AI Run Details
 */
export const getAiRun = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<AiRun>(
      {url: `/api/ai/runs/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetAiRunQueryKey = (id: MaybeRef<string>,) => {
    return ['api','ai','runs',id] as const;
    }

    
export const useGetAiRunQueryOptions = <TData = Awaited<ReturnType<typeof getAiRun>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiRun>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiRunQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiRun>>> = ({ signal }) => getAiRun(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getAiRun>>, TError, TData> 
}

export type GetAiRunQueryResult = NonNullable<Awaited<ReturnType<typeof getAiRun>>>
export type GetAiRunQueryError = ErrorType<void>


/**
 * @summary AI Run Details
 */

export function useGetAiRun<TData = Awaited<ReturnType<typeof getAiRun>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiRun>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAiRunQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update AI Run
 */
export const updateAiRun = (
    id: MaybeRef<string>,
    updateAiRunBody: MaybeRef<UpdateAiRunBody>,
 ) => {
      id = unref(id);
updateAiRunBody = unref(updateAiRunBody);
      
      return axiosClient<AiRun>(
      {url: `/api/ai/runs/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAiRunBody
    },
      );
    }
  


export const getUpdateAiRunMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiRun>>, TError,{id: string;data: UpdateAiRunBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAiRun>>, TError,{id: string;data: UpdateAiRunBody}, TContext> => {
    
const mutationKey = ['updateAiRun'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAiRun>>, {id: string;data: UpdateAiRunBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAiRun(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAiRunMutationResult = NonNullable<Awaited<ReturnType<typeof updateAiRun>>>
    export type UpdateAiRunMutationBody = UpdateAiRunBody
    export type UpdateAiRunMutationError = ErrorType<void>

    /**
 * @summary Update AI Run
 */
export const useUpdateAiRun = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiRun>>, TError,{id: string;data: UpdateAiRunBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAiRun>>,
        TError,
        {id: string;data: UpdateAiRunBody},
        TContext
      > => {

      const mutationOptions = getUpdateAiRunMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Cancel AI Run
 */
export const retryAiRun = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/ai/runs/${id}/retry`, method: 'PUT'
    },
      );
    }
  


export const getRetryAiRunMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryAiRun>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof retryAiRun>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['retryAiRun'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryAiRun>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  retryAiRun(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RetryAiRunMutationResult = NonNullable<Awaited<ReturnType<typeof retryAiRun>>>
    
    export type RetryAiRunMutationError = ErrorType<void>

    /**
 * @summary Cancel AI Run
 */
export const useRetryAiRun = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryAiRun>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof retryAiRun>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getRetryAiRunMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create AI SpeechRecognition
 */
export const createSpeechRecognition = (
    createSpeechRecognitionBody: MaybeRef<CreateSpeechRecognitionBody>,
 signal?: AbortSignal
) => {
      createSpeechRecognitionBody = unref(createSpeechRecognitionBody);
      
      return axiosClient<AiSpeechRecognition>(
      {url: `/api/ai/speech_recognitions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSpeechRecognitionBody, signal
    },
      );
    }
  


export const getCreateSpeechRecognitionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSpeechRecognition>>, TError,{data: CreateSpeechRecognitionBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSpeechRecognition>>, TError,{data: CreateSpeechRecognitionBody}, TContext> => {
    
const mutationKey = ['createSpeechRecognition'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSpeechRecognition>>, {data: CreateSpeechRecognitionBody}> = (props) => {
          const {data} = props ?? {};

          return  createSpeechRecognition(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSpeechRecognitionMutationResult = NonNullable<Awaited<ReturnType<typeof createSpeechRecognition>>>
    export type CreateSpeechRecognitionMutationBody = CreateSpeechRecognitionBody
    export type CreateSpeechRecognitionMutationError = ErrorType<void>

    /**
 * @summary Create AI SpeechRecognition
 */
export const useCreateSpeechRecognition = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSpeechRecognition>>, TError,{data: CreateSpeechRecognitionBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createSpeechRecognition>>,
        TError,
        {data: CreateSpeechRecognitionBody},
        TContext
      > => {

      const mutationOptions = getCreateSpeechRecognitionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of AI SpeechRecognition
 */
export const listAiSpeechRecognition = (
    params?: MaybeRef<ListAiSpeechRecognitionParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedAiSpeechRecognitions>(
      {url: `/api/ai/speech_recognitions`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListAiSpeechRecognitionQueryKey = (params?: MaybeRef<ListAiSpeechRecognitionParams>,) => {
    return ['api','ai','speech_recognitions', ...(params ? [params]: [])] as const;
    }

    
export const useListAiSpeechRecognitionQueryOptions = <TData = Awaited<ReturnType<typeof listAiSpeechRecognition>>, TError = ErrorType<void>>(params?: MaybeRef<ListAiSpeechRecognitionParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiSpeechRecognition>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiSpeechRecognitionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiSpeechRecognition>>> = ({ signal }) => listAiSpeechRecognition(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listAiSpeechRecognition>>, TError, TData> 
}

export type ListAiSpeechRecognitionQueryResult = NonNullable<Awaited<ReturnType<typeof listAiSpeechRecognition>>>
export type ListAiSpeechRecognitionQueryError = ErrorType<void>


/**
 * @summary List of AI SpeechRecognition
 */

export function useListAiSpeechRecognition<TData = Awaited<ReturnType<typeof listAiSpeechRecognition>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListAiSpeechRecognitionParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiSpeechRecognition>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListAiSpeechRecognitionQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete AI SpeechRecognition
 */
export const deleteSpeechRecognition = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/ai/speech_recognitions/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteSpeechRecognitionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSpeechRecognition>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteSpeechRecognition>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteSpeechRecognition'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSpeechRecognition>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteSpeechRecognition(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSpeechRecognitionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSpeechRecognition>>>
    
    export type DeleteSpeechRecognitionMutationError = ErrorType<void>

    /**
 * @summary Delete AI SpeechRecognition
 */
export const useDeleteSpeechRecognition = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSpeechRecognition>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteSpeechRecognition>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteSpeechRecognitionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary AI SpeechRecognition Details
 */
export const getAiSpeechRecognition = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<AiSpeechRecognition>(
      {url: `/api/ai/speech_recognitions/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetAiSpeechRecognitionQueryKey = (id: MaybeRef<string>,) => {
    return ['api','ai','speech_recognitions',id] as const;
    }

    
export const useGetAiSpeechRecognitionQueryOptions = <TData = Awaited<ReturnType<typeof getAiSpeechRecognition>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiSpeechRecognition>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiSpeechRecognitionQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiSpeechRecognition>>> = ({ signal }) => getAiSpeechRecognition(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getAiSpeechRecognition>>, TError, TData> 
}

export type GetAiSpeechRecognitionQueryResult = NonNullable<Awaited<ReturnType<typeof getAiSpeechRecognition>>>
export type GetAiSpeechRecognitionQueryError = ErrorType<void>


/**
 * @summary AI SpeechRecognition Details
 */

export function useGetAiSpeechRecognition<TData = Awaited<ReturnType<typeof getAiSpeechRecognition>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiSpeechRecognition>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAiSpeechRecognitionQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List of Apps
 */
export const listApps = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<App[]>(
      {url: `/api/apps`, method: 'GET', signal
    },
      );
    }
  

const getListAppsQueryKey = () => {
    return ['api','apps'] as const;
    }

    
export const useListAppsQueryOptions = <TData = Awaited<ReturnType<typeof listApps>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApps>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAppsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listApps>>> = ({ signal }) => listApps(signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listApps>>, TError, TData> 
}

export type ListAppsQueryResult = NonNullable<Awaited<ReturnType<typeof listApps>>>
export type ListAppsQueryError = ErrorType<unknown>


/**
 * @summary List of Apps
 */

export function useListApps<TData = Awaited<ReturnType<typeof listApps>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApps>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListAppsQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary File Details
 */
export const getAudioRecorderFile = (
    id: MaybeRef<string>,
    params?: MaybeRef<GetAudioRecorderFileParams>,
 signal?: AbortSignal
) => {
      id = unref(id);
params = unref(params);
      
      return axiosClient<AudioRecorderFile>(
      {url: `/api/audio_recorder/files/${id}`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getGetAudioRecorderFileQueryKey = (id: MaybeRef<string>,
    params?: MaybeRef<GetAudioRecorderFileParams>,) => {
    return ['api','audio_recorder','files',id, ...(params ? [params]: [])] as const;
    }

    
export const useGetAudioRecorderFileQueryOptions = <TData = Awaited<ReturnType<typeof getAudioRecorderFile>>, TError = ErrorType<void>>(id: MaybeRef<string>,
    params?: MaybeRef<GetAudioRecorderFileParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAudioRecorderFile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAudioRecorderFileQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAudioRecorderFile>>> = ({ signal }) => getAudioRecorderFile(id,params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getAudioRecorderFile>>, TError, TData> 
}

export type GetAudioRecorderFileQueryResult = NonNullable<Awaited<ReturnType<typeof getAudioRecorderFile>>>
export type GetAudioRecorderFileQueryError = ErrorType<void>


/**
 * @summary File Details
 */

export function useGetAudioRecorderFile<TData = Awaited<ReturnType<typeof getAudioRecorderFile>>, TError = ErrorType<void>>(
 id: MaybeRef<string>,
    params?: MaybeRef<GetAudioRecorderFileParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAudioRecorderFile>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAudioRecorderFileQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update File
 */
export const updateAudioRecorderFile = (
    id: MaybeRef<string>,
    updateAudioRecorderFileBody: MaybeRef<UpdateAudioRecorderFileBody>,
 ) => {
      id = unref(id);
updateAudioRecorderFileBody = unref(updateAudioRecorderFileBody);
      
      return axiosClient<AudioRecorderFile>(
      {url: `/api/audio_recorder/files/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAudioRecorderFileBody
    },
      );
    }
  


export const getUpdateAudioRecorderFileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAudioRecorderFile>>, TError,{id: string;data: UpdateAudioRecorderFileBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAudioRecorderFile>>, TError,{id: string;data: UpdateAudioRecorderFileBody}, TContext> => {
    
const mutationKey = ['updateAudioRecorderFile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAudioRecorderFile>>, {id: string;data: UpdateAudioRecorderFileBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAudioRecorderFile(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAudioRecorderFileMutationResult = NonNullable<Awaited<ReturnType<typeof updateAudioRecorderFile>>>
    export type UpdateAudioRecorderFileMutationBody = UpdateAudioRecorderFileBody
    export type UpdateAudioRecorderFileMutationError = ErrorType<void>

    /**
 * @summary Update File
 */
export const useUpdateAudioRecorderFile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAudioRecorderFile>>, TError,{id: string;data: UpdateAudioRecorderFileBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAudioRecorderFile>>,
        TError,
        {id: string;data: UpdateAudioRecorderFileBody},
        TContext
      > => {

      const mutationOptions = getUpdateAudioRecorderFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create Audio Recording
 */
export const createAudioRecording = (
    createAudioRecordingBody: MaybeRef<CreateAudioRecordingBody>,
 signal?: AbortSignal
) => {
      createAudioRecordingBody = unref(createAudioRecordingBody);
      
      return axiosClient<AudioRecording>(
      {url: `/api/audio_recordings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAudioRecordingBody, signal
    },
      );
    }
  


export const getCreateAudioRecordingMutationOptions = <TError = ErrorType<void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAudioRecording>>, TError,{data: CreateAudioRecordingBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAudioRecording>>, TError,{data: CreateAudioRecordingBody}, TContext> => {
    
const mutationKey = ['createAudioRecording'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAudioRecording>>, {data: CreateAudioRecordingBody}> = (props) => {
          const {data} = props ?? {};

          return  createAudioRecording(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAudioRecordingMutationResult = NonNullable<Awaited<ReturnType<typeof createAudioRecording>>>
    export type CreateAudioRecordingMutationBody = CreateAudioRecordingBody
    export type CreateAudioRecordingMutationError = ErrorType<void | ValidationError>

    /**
 * @summary Create Audio Recording
 */
export const useCreateAudioRecording = <TError = ErrorType<void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAudioRecording>>, TError,{data: CreateAudioRecordingBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createAudioRecording>>,
        TError,
        {data: CreateAudioRecordingBody},
        TContext
      > => {

      const mutationOptions = getCreateAudioRecordingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Delete Audio Recording
 */
export const deleteAudioRecording = (
    recordingId: MaybeRef<string>,
 ) => {
      recordingId = unref(recordingId);
      
      return axiosClient<void>(
      {url: `/api/audio_recordings/${recordingId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAudioRecordingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAudioRecording>>, TError,{recordingId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAudioRecording>>, TError,{recordingId: string}, TContext> => {
    
const mutationKey = ['deleteAudioRecording'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAudioRecording>>, {recordingId: string}> = (props) => {
          const {recordingId} = props ?? {};

          return  deleteAudioRecording(recordingId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAudioRecordingMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAudioRecording>>>
    
    export type DeleteAudioRecordingMutationError = ErrorType<void>

    /**
 * @summary Delete Audio Recording
 */
export const useDeleteAudioRecording = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAudioRecording>>, TError,{recordingId: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAudioRecording>>,
        TError,
        {recordingId: string},
        TContext
      > => {

      const mutationOptions = getDeleteAudioRecordingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Audio Recording Details
 */
export const getAudioRecording = (
    recordingId: MaybeRef<string>,
 signal?: AbortSignal
) => {
      recordingId = unref(recordingId);
      
      return axiosClient<AudioRecording>(
      {url: `/api/audio_recordings/${recordingId}`, method: 'GET', signal
    },
      );
    }
  

const getGetAudioRecordingQueryKey = (recordingId: MaybeRef<string>,) => {
    return ['api','audio_recordings',recordingId] as const;
    }

    
export const useGetAudioRecordingQueryOptions = <TData = Awaited<ReturnType<typeof getAudioRecording>>, TError = ErrorType<void>>(recordingId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAudioRecording>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAudioRecordingQueryKey(recordingId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAudioRecording>>> = ({ signal }) => getAudioRecording(recordingId, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getAudioRecording>>, TError, TData> 
}

export type GetAudioRecordingQueryResult = NonNullable<Awaited<ReturnType<typeof getAudioRecording>>>
export type GetAudioRecordingQueryError = ErrorType<void>


/**
 * @summary Audio Recording Details
 */

export function useGetAudioRecording<TData = Awaited<ReturnType<typeof getAudioRecording>>, TError = ErrorType<void>>(
 recordingId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAudioRecording>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAudioRecordingQueryOptions(recordingId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update Audio Recording
 */
export const updateAudioRecording = (
    recordingId: MaybeRef<string>,
    updateAudioRecordingBody: MaybeRef<UpdateAudioRecordingBody>,
 ) => {
      recordingId = unref(recordingId);
updateAudioRecordingBody = unref(updateAudioRecordingBody);
      
      return axiosClient<AudioRecording>(
      {url: `/api/audio_recordings/${recordingId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAudioRecordingBody
    },
      );
    }
  


export const getUpdateAudioRecordingMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAudioRecording>>, TError,{recordingId: string;data: UpdateAudioRecordingBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAudioRecording>>, TError,{recordingId: string;data: UpdateAudioRecordingBody}, TContext> => {
    
const mutationKey = ['updateAudioRecording'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAudioRecording>>, {recordingId: string;data: UpdateAudioRecordingBody}> = (props) => {
          const {recordingId,data} = props ?? {};

          return  updateAudioRecording(recordingId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAudioRecordingMutationResult = NonNullable<Awaited<ReturnType<typeof updateAudioRecording>>>
    export type UpdateAudioRecordingMutationBody = UpdateAudioRecordingBody
    export type UpdateAudioRecordingMutationError = ErrorType<void>

    /**
 * @summary Update Audio Recording
 */
export const useUpdateAudioRecording = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAudioRecording>>, TError,{recordingId: string;data: UpdateAudioRecordingBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAudioRecording>>,
        TError,
        {recordingId: string;data: UpdateAudioRecordingBody},
        TContext
      > => {

      const mutationOptions = getUpdateAudioRecordingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Check Bookmark Status
 */
export const checkBookmark = (
    params: MaybeRef<CheckBookmarkParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<BookmarkStatus>(
      {url: `/api/bookmarks/check`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getCheckBookmarkQueryKey = (params: MaybeRef<CheckBookmarkParams>,) => {
    return ['api','bookmarks','check', ...(params ? [params]: [])] as const;
    }

    
export const useCheckBookmarkQueryOptions = <TData = Awaited<ReturnType<typeof checkBookmark>>, TError = ErrorType<void>>(params: MaybeRef<CheckBookmarkParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkBookmark>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getCheckBookmarkQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkBookmark>>> = ({ signal }) => checkBookmark(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof checkBookmark>>, TError, TData> 
}

export type CheckBookmarkQueryResult = NonNullable<Awaited<ReturnType<typeof checkBookmark>>>
export type CheckBookmarkQueryError = ErrorType<void>


/**
 * @summary Check Bookmark Status
 */

export function useCheckBookmark<TData = Awaited<ReturnType<typeof checkBookmark>>, TError = ErrorType<void>>(
 params: MaybeRef<CheckBookmarkParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof checkBookmark>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useCheckBookmarkQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete Bookmark
 */
export const deleteBookmark = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/bookmarks/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteBookmarkMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBookmark>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteBookmark>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteBookmark'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBookmark>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteBookmark(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBookmarkMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBookmark>>>
    
    export type DeleteBookmarkMutationError = ErrorType<void>

    /**
 * @summary Delete Bookmark
 */
export const useDeleteBookmark = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBookmark>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteBookmark>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteBookmarkMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Bookmarks
 */
export const listBookmarks = (
    params?: MaybeRef<ListBookmarksParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedBookmarks>(
      {url: `/api/bookmarks`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListBookmarksQueryKey = (params?: MaybeRef<ListBookmarksParams>,) => {
    return ['api','bookmarks', ...(params ? [params]: [])] as const;
    }

    
export const useListBookmarksQueryOptions = <TData = Awaited<ReturnType<typeof listBookmarks>>, TError = ErrorType<void>>(params?: MaybeRef<ListBookmarksParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBookmarks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListBookmarksQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBookmarks>>> = ({ signal }) => listBookmarks(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listBookmarks>>, TError, TData> 
}

export type ListBookmarksQueryResult = NonNullable<Awaited<ReturnType<typeof listBookmarks>>>
export type ListBookmarksQueryError = ErrorType<void>


/**
 * @summary List of Bookmarks
 */

export function useListBookmarks<TData = Awaited<ReturnType<typeof listBookmarks>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListBookmarksParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBookmarks>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListBookmarksQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Toggle Bookmark
 */
export const toggleBookmark = (
    params: MaybeRef<ToggleBookmarkParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<BookmarkStatus>(
      {url: `/api/bookmarks/toggle`, method: 'POST',
        params: unref(params), signal
    },
      );
    }
  


export const getToggleBookmarkMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleBookmark>>, TError,{params: ToggleBookmarkParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof toggleBookmark>>, TError,{params: ToggleBookmarkParams}, TContext> => {
    
const mutationKey = ['toggleBookmark'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleBookmark>>, {params: ToggleBookmarkParams}> = (props) => {
          const {params} = props ?? {};

          return  toggleBookmark(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ToggleBookmarkMutationResult = NonNullable<Awaited<ReturnType<typeof toggleBookmark>>>
    
    export type ToggleBookmarkMutationError = ErrorType<void>

    /**
 * @summary Toggle Bookmark
 */
export const useToggleBookmark = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleBookmark>>, TError,{params: ToggleBookmarkParams}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof toggleBookmark>>,
        TError,
        {params: ToggleBookmarkParams},
        TContext
      > => {

      const mutationOptions = getToggleBookmarkMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create Card
 */
export const createClassroomScreenCard = (
    pageId: MaybeRef<string>,
    createClassroomScreenCardBody: MaybeRef<CreateClassroomScreenCardBody>,
 signal?: AbortSignal
) => {
      pageId = unref(pageId);
createClassroomScreenCardBody = unref(createClassroomScreenCardBody);
      
      return axiosClient<ClassroomScreenCard>(
      {url: `/api/teaching_board/pages/${pageId}/cards`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createClassroomScreenCardBody, signal
    },
      );
    }
  


export const getCreateClassroomScreenCardMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClassroomScreenCard>>, TError,{pageId: string;data: CreateClassroomScreenCardBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createClassroomScreenCard>>, TError,{pageId: string;data: CreateClassroomScreenCardBody}, TContext> => {
    
const mutationKey = ['createClassroomScreenCard'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createClassroomScreenCard>>, {pageId: string;data: CreateClassroomScreenCardBody}> = (props) => {
          const {pageId,data} = props ?? {};

          return  createClassroomScreenCard(pageId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateClassroomScreenCardMutationResult = NonNullable<Awaited<ReturnType<typeof createClassroomScreenCard>>>
    export type CreateClassroomScreenCardMutationBody = CreateClassroomScreenCardBody
    export type CreateClassroomScreenCardMutationError = ErrorType<void>

    /**
 * @summary Create Card
 */
export const useCreateClassroomScreenCard = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClassroomScreenCard>>, TError,{pageId: string;data: CreateClassroomScreenCardBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createClassroomScreenCard>>,
        TError,
        {pageId: string;data: CreateClassroomScreenCardBody},
        TContext
      > => {

      const mutationOptions = getCreateClassroomScreenCardMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Cards
 */
export const listClassroomScreenCards = (
    pageId: MaybeRef<string>,
 signal?: AbortSignal
) => {
      pageId = unref(pageId);
      
      return axiosClient<ClassroomPages>(
      {url: `/api/teaching_board/pages/${pageId}/cards`, method: 'GET', signal
    },
      );
    }
  

const getListClassroomScreenCardsQueryKey = (pageId: MaybeRef<string>,) => {
    return ['api','teaching_board','pages',pageId,'cards'] as const;
    }

    
export const useListClassroomScreenCardsQueryOptions = <TData = Awaited<ReturnType<typeof listClassroomScreenCards>>, TError = ErrorType<void>>(pageId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClassroomScreenCards>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListClassroomScreenCardsQueryKey(pageId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listClassroomScreenCards>>> = ({ signal }) => listClassroomScreenCards(pageId, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listClassroomScreenCards>>, TError, TData> 
}

export type ListClassroomScreenCardsQueryResult = NonNullable<Awaited<ReturnType<typeof listClassroomScreenCards>>>
export type ListClassroomScreenCardsQueryError = ErrorType<void>


/**
 * @summary List of Cards
 */

export function useListClassroomScreenCards<TData = Awaited<ReturnType<typeof listClassroomScreenCards>>, TError = ErrorType<void>>(
 pageId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClassroomScreenCards>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListClassroomScreenCardsQueryOptions(pageId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete Card
 */
export const deleteClassroomScreenCard = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/teaching_board/cards/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteClassroomScreenCardMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClassroomScreenCard>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteClassroomScreenCard>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteClassroomScreenCard'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteClassroomScreenCard>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteClassroomScreenCard(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteClassroomScreenCardMutationResult = NonNullable<Awaited<ReturnType<typeof deleteClassroomScreenCard>>>
    
    export type DeleteClassroomScreenCardMutationError = ErrorType<void>

    /**
 * @summary Delete Card
 */
export const useDeleteClassroomScreenCard = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClassroomScreenCard>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteClassroomScreenCard>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteClassroomScreenCardMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Card Details
 */
export const getClassroomScreenCard = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<ClassroomScreenCard>(
      {url: `/api/teaching_board/cards/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetClassroomScreenCardQueryKey = (id: MaybeRef<string>,) => {
    return ['api','teaching_board','cards',id] as const;
    }

    
export const useGetClassroomScreenCardQueryOptions = <TData = Awaited<ReturnType<typeof getClassroomScreenCard>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClassroomScreenCard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetClassroomScreenCardQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClassroomScreenCard>>> = ({ signal }) => getClassroomScreenCard(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getClassroomScreenCard>>, TError, TData> 
}

export type GetClassroomScreenCardQueryResult = NonNullable<Awaited<ReturnType<typeof getClassroomScreenCard>>>
export type GetClassroomScreenCardQueryError = ErrorType<void>


/**
 * @summary Card Details
 */

export function useGetClassroomScreenCard<TData = Awaited<ReturnType<typeof getClassroomScreenCard>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClassroomScreenCard>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClassroomScreenCardQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update Card
 */
export const updateClassroomScreenCard = (
    id: MaybeRef<string>,
    updateClassroomScreenCardBody: MaybeRef<UpdateClassroomScreenCardBody>,
 ) => {
      id = unref(id);
updateClassroomScreenCardBody = unref(updateClassroomScreenCardBody);
      
      return axiosClient<ClassroomScreenCard>(
      {url: `/api/teaching_board/cards/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateClassroomScreenCardBody
    },
      );
    }
  


export const getUpdateClassroomScreenCardMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateClassroomScreenCard>>, TError,{id: string;data: UpdateClassroomScreenCardBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateClassroomScreenCard>>, TError,{id: string;data: UpdateClassroomScreenCardBody}, TContext> => {
    
const mutationKey = ['updateClassroomScreenCard'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateClassroomScreenCard>>, {id: string;data: UpdateClassroomScreenCardBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateClassroomScreenCard(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateClassroomScreenCardMutationResult = NonNullable<Awaited<ReturnType<typeof updateClassroomScreenCard>>>
    export type UpdateClassroomScreenCardMutationBody = UpdateClassroomScreenCardBody
    export type UpdateClassroomScreenCardMutationError = ErrorType<void>

    /**
 * @summary Update Card
 */
export const useUpdateClassroomScreenCard = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateClassroomScreenCard>>, TError,{id: string;data: UpdateClassroomScreenCardBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateClassroomScreenCard>>,
        TError,
        {id: string;data: UpdateClassroomScreenCardBody},
        TContext
      > => {

      const mutationOptions = getUpdateClassroomScreenCardMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Duplicate Card
 */
export const duplicateCard = (
    cardId: MaybeRef<string>,
 ) => {
      cardId = unref(cardId);
      
      return axiosClient<void>(
      {url: `/api/teaching_board/cards/${cardId}/duplicate`, method: 'PATCH'
    },
      );
    }
  


export const getDuplicateCardMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateCard>>, TError,{cardId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof duplicateCard>>, TError,{cardId: string}, TContext> => {
    
const mutationKey = ['duplicateCard'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateCard>>, {cardId: string}> = (props) => {
          const {cardId} = props ?? {};

          return  duplicateCard(cardId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DuplicateCardMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateCard>>>
    
    export type DuplicateCardMutationError = ErrorType<unknown>

    /**
 * @summary Duplicate Card
 */
export const useDuplicateCard = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateCard>>, TError,{cardId: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof duplicateCard>>,
        TError,
        {cardId: string},
        TContext
      > => {

      const mutationOptions = getDuplicateCardMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create Page
 */
export const createClassroomScreenPage = (
    screenId: MaybeRef<string>,
    createClassroomScreenPageBody: MaybeRef<CreateClassroomScreenPageBody>,
 signal?: AbortSignal
) => {
      screenId = unref(screenId);
createClassroomScreenPageBody = unref(createClassroomScreenPageBody);
      
      return axiosClient<ClassroomScreenPage>(
      {url: `/api/teaching_board/screens/${screenId}/pages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createClassroomScreenPageBody, signal
    },
      );
    }
  


export const getCreateClassroomScreenPageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClassroomScreenPage>>, TError,{screenId: string;data: CreateClassroomScreenPageBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createClassroomScreenPage>>, TError,{screenId: string;data: CreateClassroomScreenPageBody}, TContext> => {
    
const mutationKey = ['createClassroomScreenPage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createClassroomScreenPage>>, {screenId: string;data: CreateClassroomScreenPageBody}> = (props) => {
          const {screenId,data} = props ?? {};

          return  createClassroomScreenPage(screenId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateClassroomScreenPageMutationResult = NonNullable<Awaited<ReturnType<typeof createClassroomScreenPage>>>
    export type CreateClassroomScreenPageMutationBody = CreateClassroomScreenPageBody
    export type CreateClassroomScreenPageMutationError = ErrorType<void>

    /**
 * @summary Create Page
 */
export const useCreateClassroomScreenPage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClassroomScreenPage>>, TError,{screenId: string;data: CreateClassroomScreenPageBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createClassroomScreenPage>>,
        TError,
        {screenId: string;data: CreateClassroomScreenPageBody},
        TContext
      > => {

      const mutationOptions = getCreateClassroomScreenPageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Pages
 */
export const listClassroomScreenPages = (
    screenId: MaybeRef<string>,
 signal?: AbortSignal
) => {
      screenId = unref(screenId);
      
      return axiosClient<ClassroomPages>(
      {url: `/api/teaching_board/screens/${screenId}/pages`, method: 'GET', signal
    },
      );
    }
  

const getListClassroomScreenPagesQueryKey = (screenId: MaybeRef<string>,) => {
    return ['api','teaching_board','screens',screenId,'pages'] as const;
    }

    
export const useListClassroomScreenPagesQueryOptions = <TData = Awaited<ReturnType<typeof listClassroomScreenPages>>, TError = ErrorType<void>>(screenId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClassroomScreenPages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListClassroomScreenPagesQueryKey(screenId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listClassroomScreenPages>>> = ({ signal }) => listClassroomScreenPages(screenId, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listClassroomScreenPages>>, TError, TData> 
}

export type ListClassroomScreenPagesQueryResult = NonNullable<Awaited<ReturnType<typeof listClassroomScreenPages>>>
export type ListClassroomScreenPagesQueryError = ErrorType<void>


/**
 * @summary List of Pages
 */

export function useListClassroomScreenPages<TData = Awaited<ReturnType<typeof listClassroomScreenPages>>, TError = ErrorType<void>>(
 screenId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClassroomScreenPages>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListClassroomScreenPagesQueryOptions(screenId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete Page
 */
export const deleteClassroomScreenPage = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/teaching_board/pages/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteClassroomScreenPageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClassroomScreenPage>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteClassroomScreenPage>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteClassroomScreenPage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteClassroomScreenPage>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteClassroomScreenPage(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteClassroomScreenPageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteClassroomScreenPage>>>
    
    export type DeleteClassroomScreenPageMutationError = ErrorType<void>

    /**
 * @summary Delete Page
 */
export const useDeleteClassroomScreenPage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClassroomScreenPage>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteClassroomScreenPage>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteClassroomScreenPageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Page Details
 */
export const getClassroomScreenPage = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<ClassroomScreenPage>(
      {url: `/api/teaching_board/pages/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetClassroomScreenPageQueryKey = (id: MaybeRef<string>,) => {
    return ['api','teaching_board','pages',id] as const;
    }

    
export const useGetClassroomScreenPageQueryOptions = <TData = Awaited<ReturnType<typeof getClassroomScreenPage>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClassroomScreenPage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetClassroomScreenPageQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClassroomScreenPage>>> = ({ signal }) => getClassroomScreenPage(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getClassroomScreenPage>>, TError, TData> 
}

export type GetClassroomScreenPageQueryResult = NonNullable<Awaited<ReturnType<typeof getClassroomScreenPage>>>
export type GetClassroomScreenPageQueryError = ErrorType<void>


/**
 * @summary Page Details
 */

export function useGetClassroomScreenPage<TData = Awaited<ReturnType<typeof getClassroomScreenPage>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClassroomScreenPage>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClassroomScreenPageQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update Page
 */
export const updateClassroomScreenPage = (
    id: MaybeRef<string>,
    updateClassroomScreenPageBody: MaybeRef<UpdateClassroomScreenPageBody>,
 ) => {
      id = unref(id);
updateClassroomScreenPageBody = unref(updateClassroomScreenPageBody);
      
      return axiosClient<ClassroomScreenPage>(
      {url: `/api/teaching_board/pages/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateClassroomScreenPageBody
    },
      );
    }
  


export const getUpdateClassroomScreenPageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateClassroomScreenPage>>, TError,{id: string;data: UpdateClassroomScreenPageBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateClassroomScreenPage>>, TError,{id: string;data: UpdateClassroomScreenPageBody}, TContext> => {
    
const mutationKey = ['updateClassroomScreenPage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateClassroomScreenPage>>, {id: string;data: UpdateClassroomScreenPageBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateClassroomScreenPage(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateClassroomScreenPageMutationResult = NonNullable<Awaited<ReturnType<typeof updateClassroomScreenPage>>>
    export type UpdateClassroomScreenPageMutationBody = UpdateClassroomScreenPageBody
    export type UpdateClassroomScreenPageMutationError = ErrorType<void>

    /**
 * @summary Update Page
 */
export const useUpdateClassroomScreenPage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateClassroomScreenPage>>, TError,{id: string;data: UpdateClassroomScreenPageBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateClassroomScreenPage>>,
        TError,
        {id: string;data: UpdateClassroomScreenPageBody},
        TContext
      > => {

      const mutationOptions = getUpdateClassroomScreenPageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Move Page
 */
export const moveClassroomScreenPage = (
    pageId: MaybeRef<string>,
    moveClassroomScreenPageBody: MaybeRef<MoveClassroomScreenPageBody>,
 ) => {
      pageId = unref(pageId);
moveClassroomScreenPageBody = unref(moveClassroomScreenPageBody);
      
      return axiosClient<ClassroomScreenPage>(
      {url: `/api/teaching_board/pages/${pageId}/move`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: moveClassroomScreenPageBody
    },
      );
    }
  


export const getMoveClassroomScreenPageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveClassroomScreenPage>>, TError,{pageId: string;data: MoveClassroomScreenPageBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moveClassroomScreenPage>>, TError,{pageId: string;data: MoveClassroomScreenPageBody}, TContext> => {
    
const mutationKey = ['moveClassroomScreenPage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveClassroomScreenPage>>, {pageId: string;data: MoveClassroomScreenPageBody}> = (props) => {
          const {pageId,data} = props ?? {};

          return  moveClassroomScreenPage(pageId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MoveClassroomScreenPageMutationResult = NonNullable<Awaited<ReturnType<typeof moveClassroomScreenPage>>>
    export type MoveClassroomScreenPageMutationBody = MoveClassroomScreenPageBody
    export type MoveClassroomScreenPageMutationError = ErrorType<void>

    /**
 * @summary Move Page
 */
export const useMoveClassroomScreenPage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveClassroomScreenPage>>, TError,{pageId: string;data: MoveClassroomScreenPageBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof moveClassroomScreenPage>>,
        TError,
        {pageId: string;data: MoveClassroomScreenPageBody},
        TContext
      > => {

      const mutationOptions = getMoveClassroomScreenPageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create Screen
 */
export const createClassroomScreen = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<ClassroomScreenScreen>(
      {url: `/api/teaching_board/screens`, method: 'POST', signal
    },
      );
    }
  


export const getCreateClassroomScreenMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClassroomScreen>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createClassroomScreen>>, TError,void, TContext> => {
    
const mutationKey = ['createClassroomScreen'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createClassroomScreen>>, void> = () => {
          

          return  createClassroomScreen()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateClassroomScreenMutationResult = NonNullable<Awaited<ReturnType<typeof createClassroomScreen>>>
    
    export type CreateClassroomScreenMutationError = ErrorType<void>

    /**
 * @summary Create Screen
 */
export const useCreateClassroomScreen = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClassroomScreen>>, TError,void, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createClassroomScreen>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getCreateClassroomScreenMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Screens
 */
export const listClassroomScreens = (
    params?: MaybeRef<ListClassroomScreensParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedClassroomScreens>(
      {url: `/api/teaching_board/screens`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListClassroomScreensQueryKey = (params?: MaybeRef<ListClassroomScreensParams>,) => {
    return ['api','teaching_board','screens', ...(params ? [params]: [])] as const;
    }

    
export const useListClassroomScreensQueryOptions = <TData = Awaited<ReturnType<typeof listClassroomScreens>>, TError = ErrorType<void>>(params?: MaybeRef<ListClassroomScreensParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClassroomScreens>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListClassroomScreensQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listClassroomScreens>>> = ({ signal }) => listClassroomScreens(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listClassroomScreens>>, TError, TData> 
}

export type ListClassroomScreensQueryResult = NonNullable<Awaited<ReturnType<typeof listClassroomScreens>>>
export type ListClassroomScreensQueryError = ErrorType<void>


/**
 * @summary List of Screens
 */

export function useListClassroomScreens<TData = Awaited<ReturnType<typeof listClassroomScreens>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListClassroomScreensParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClassroomScreens>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListClassroomScreensQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete Screen
 */
export const deleteClassroomScreen = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/teaching_board/screens/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteClassroomScreenMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClassroomScreen>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteClassroomScreen>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteClassroomScreen'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteClassroomScreen>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteClassroomScreen(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteClassroomScreenMutationResult = NonNullable<Awaited<ReturnType<typeof deleteClassroomScreen>>>
    
    export type DeleteClassroomScreenMutationError = ErrorType<void>

    /**
 * @summary Delete Screen
 */
export const useDeleteClassroomScreen = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClassroomScreen>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteClassroomScreen>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteClassroomScreenMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Screen Details
 */
export const getClassroomScreen = (
    id: MaybeRef<string>,
    params?: MaybeRef<GetClassroomScreenParams>,
 signal?: AbortSignal
) => {
      id = unref(id);
params = unref(params);
      
      return axiosClient<ClassroomScreenScreen>(
      {url: `/api/teaching_board/screens/${id}`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getGetClassroomScreenQueryKey = (id: MaybeRef<string>,
    params?: MaybeRef<GetClassroomScreenParams>,) => {
    return ['api','teaching_board','screens',id, ...(params ? [params]: [])] as const;
    }

    
export const useGetClassroomScreenQueryOptions = <TData = Awaited<ReturnType<typeof getClassroomScreen>>, TError = ErrorType<void>>(id: MaybeRef<string>,
    params?: MaybeRef<GetClassroomScreenParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClassroomScreen>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetClassroomScreenQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClassroomScreen>>> = ({ signal }) => getClassroomScreen(id,params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getClassroomScreen>>, TError, TData> 
}

export type GetClassroomScreenQueryResult = NonNullable<Awaited<ReturnType<typeof getClassroomScreen>>>
export type GetClassroomScreenQueryError = ErrorType<void>


/**
 * @summary Screen Details
 */

export function useGetClassroomScreen<TData = Awaited<ReturnType<typeof getClassroomScreen>>, TError = ErrorType<void>>(
 id: MaybeRef<string>,
    params?: MaybeRef<GetClassroomScreenParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClassroomScreen>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetClassroomScreenQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update Screen
 */
export const updateClassroomScreen = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<ClassroomScreenScreen>(
      {url: `/api/teaching_board/screens/${id}`, method: 'PUT'
    },
      );
    }
  


export const getUpdateClassroomScreenMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateClassroomScreen>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateClassroomScreen>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['updateClassroomScreen'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateClassroomScreen>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  updateClassroomScreen(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateClassroomScreenMutationResult = NonNullable<Awaited<ReturnType<typeof updateClassroomScreen>>>
    
    export type UpdateClassroomScreenMutationError = ErrorType<void>

    /**
 * @summary Update Screen
 */
export const useUpdateClassroomScreen = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateClassroomScreen>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateClassroomScreen>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getUpdateClassroomScreenMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Partner Entries
 */
export const getPartnerEntries = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<PaginatedPartnerEntries>(
      {url: `/api/cms/partner_entries`, method: 'GET', signal
    },
      );
    }
  

const getGetPartnerEntriesQueryKey = () => {
    return ['api','cms','partner_entries'] as const;
    }

    
export const useGetPartnerEntriesQueryOptions = <TData = Awaited<ReturnType<typeof getPartnerEntries>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnerEntries>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetPartnerEntriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartnerEntries>>> = ({ signal }) => getPartnerEntries(signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getPartnerEntries>>, TError, TData> 
}

export type GetPartnerEntriesQueryResult = NonNullable<Awaited<ReturnType<typeof getPartnerEntries>>>
export type GetPartnerEntriesQueryError = ErrorType<unknown>


/**
 * @summary List of Partner Entries
 */

export function useGetPartnerEntries<TData = Awaited<ReturnType<typeof getPartnerEntries>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnerEntries>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPartnerEntriesQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Partner Entry Details
 */
export const getPartnerEntry = (
    id: MaybeRef<number>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<PartnerEntry>(
      {url: `/api/cms/partner_entries/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetPartnerEntryQueryKey = (id: MaybeRef<number>,) => {
    return ['api','cms','partner_entries',id] as const;
    }

    
export const useGetPartnerEntryQueryOptions = <TData = Awaited<ReturnType<typeof getPartnerEntry>>, TError = ErrorType<StandardError>>(id: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnerEntry>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetPartnerEntryQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPartnerEntry>>> = ({ signal }) => getPartnerEntry(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getPartnerEntry>>, TError, TData> 
}

export type GetPartnerEntryQueryResult = NonNullable<Awaited<ReturnType<typeof getPartnerEntry>>>
export type GetPartnerEntryQueryError = ErrorType<StandardError>


/**
 * @summary Partner Entry Details
 */

export function useGetPartnerEntry<TData = Awaited<ReturnType<typeof getPartnerEntry>>, TError = ErrorType<StandardError>>(
 id: MaybeRef<number>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPartnerEntry>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPartnerEntryQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List of featured Collections
 */
export const listFeaturedCollections = (
    params?: MaybeRef<ListFeaturedCollectionsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<Collection[]>(
      {url: `/api/collections/featured`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListFeaturedCollectionsQueryKey = (params?: MaybeRef<ListFeaturedCollectionsParams>,) => {
    return ['api','collections','featured', ...(params ? [params]: [])] as const;
    }

    
export const useListFeaturedCollectionsQueryOptions = <TData = Awaited<ReturnType<typeof listFeaturedCollections>>, TError = ErrorType<unknown>>(params?: MaybeRef<ListFeaturedCollectionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeaturedCollections>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListFeaturedCollectionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFeaturedCollections>>> = ({ signal }) => listFeaturedCollections(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listFeaturedCollections>>, TError, TData> 
}

export type ListFeaturedCollectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listFeaturedCollections>>>
export type ListFeaturedCollectionsQueryError = ErrorType<unknown>


/**
 * @summary List of featured Collections
 */

export function useListFeaturedCollections<TData = Awaited<ReturnType<typeof listFeaturedCollections>>, TError = ErrorType<unknown>>(
 params?: MaybeRef<ListFeaturedCollectionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeaturedCollections>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListFeaturedCollectionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List of Collections
 */
export const listCollections = (
    params?: MaybeRef<ListCollectionsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<Collection[]>(
      {url: `/api/collections`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListCollectionsQueryKey = (params?: MaybeRef<ListCollectionsParams>,) => {
    return ['api','collections', ...(params ? [params]: [])] as const;
    }

    
export const useListCollectionsQueryOptions = <TData = Awaited<ReturnType<typeof listCollections>>, TError = ErrorType<unknown>>(params?: MaybeRef<ListCollectionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollections>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCollectionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCollections>>> = ({ signal }) => listCollections(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listCollections>>, TError, TData> 
}

export type ListCollectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listCollections>>>
export type ListCollectionsQueryError = ErrorType<unknown>


/**
 * @summary List of Collections
 */

export function useListCollections<TData = Awaited<ReturnType<typeof listCollections>>, TError = ErrorType<unknown>>(
 params?: MaybeRef<ListCollectionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollections>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListCollectionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List of recommended Collections
 */
export const listRecommendedCollections = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<Collection[]>(
      {url: `/api/collections/${id}/recommendations`, method: 'GET', signal
    },
      );
    }
  

const getListRecommendedCollectionsQueryKey = (id: MaybeRef<string>,) => {
    return ['api','collections',id,'recommendations'] as const;
    }

    
export const useListRecommendedCollectionsQueryOptions = <TData = Awaited<ReturnType<typeof listRecommendedCollections>>, TError = ErrorType<unknown>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecommendedCollections>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListRecommendedCollectionsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRecommendedCollections>>> = ({ signal }) => listRecommendedCollections(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listRecommendedCollections>>, TError, TData> 
}

export type ListRecommendedCollectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listRecommendedCollections>>>
export type ListRecommendedCollectionsQueryError = ErrorType<unknown>


/**
 * @summary List of recommended Collections
 */

export function useListRecommendedCollections<TData = Awaited<ReturnType<typeof listRecommendedCollections>>, TError = ErrorType<unknown>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecommendedCollections>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListRecommendedCollectionsQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Collection Details
 */
export const getCollection = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<Collection>(
      {url: `/api/collections/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetCollectionQueryKey = (id: MaybeRef<string>,) => {
    return ['api','collections',id] as const;
    }

    
export const useGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof getCollection>>, TError = ErrorType<StandardError>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollection>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCollectionQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCollection>>> = ({ signal }) => getCollection(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getCollection>>, TError, TData> 
}

export type GetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof getCollection>>>
export type GetCollectionQueryError = ErrorType<StandardError>


/**
 * @summary Collection Details
 */

export function useGetCollection<TData = Awaited<ReturnType<typeof getCollection>>, TError = ErrorType<StandardError>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollection>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetCollectionQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Create Daily User Visit
 */
export const createDailyUserVisit = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<void>(
      {url: `/api/daily_user_visits`, method: 'POST', signal
    },
      );
    }
  


export const getCreateDailyUserVisitMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDailyUserVisit>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createDailyUserVisit>>, TError,void, TContext> => {
    
const mutationKey = ['createDailyUserVisit'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDailyUserVisit>>, void> = () => {
          

          return  createDailyUserVisit()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateDailyUserVisitMutationResult = NonNullable<Awaited<ReturnType<typeof createDailyUserVisit>>>
    
    export type CreateDailyUserVisitMutationError = ErrorType<void>

    /**
 * @summary Create Daily User Visit
 */
export const useCreateDailyUserVisit = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDailyUserVisit>>, TError,void, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createDailyUserVisit>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getCreateDailyUserVisitMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Delete Discarded Items
 */
export const deleteDiscardedItems = (
    params?: MaybeRef<DeleteDiscardedItemsParams>,
 ) => {
      params = unref(params);
      
      return axiosClient<void>(
      {url: `/api/discarded_items`, method: 'DELETE',
        params: unref(params)
    },
      );
    }
  


export const getDeleteDiscardedItemsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDiscardedItems>>, TError,{params?: DeleteDiscardedItemsParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteDiscardedItems>>, TError,{params?: DeleteDiscardedItemsParams}, TContext> => {
    
const mutationKey = ['deleteDiscardedItems'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDiscardedItems>>, {params?: DeleteDiscardedItemsParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteDiscardedItems(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDiscardedItemsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDiscardedItems>>>
    
    export type DeleteDiscardedItemsMutationError = ErrorType<void>

    /**
 * @summary Delete Discarded Items
 */
export const useDeleteDiscardedItems = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDiscardedItems>>, TError,{params?: DeleteDiscardedItemsParams}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteDiscardedItems>>,
        TError,
        {params?: DeleteDiscardedItemsParams},
        TContext
      > => {

      const mutationOptions = getDeleteDiscardedItemsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Discarded Items
 */
export const listDiscardedItems = (
    params?: MaybeRef<ListDiscardedItemsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedItems>(
      {url: `/api/discarded_items`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListDiscardedItemsQueryKey = (params?: MaybeRef<ListDiscardedItemsParams>,) => {
    return ['api','discarded_items', ...(params ? [params]: [])] as const;
    }

    
export const useListDiscardedItemsQueryOptions = <TData = Awaited<ReturnType<typeof listDiscardedItems>>, TError = ErrorType<void>>(params?: MaybeRef<ListDiscardedItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDiscardedItems>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListDiscardedItemsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDiscardedItems>>> = ({ signal }) => listDiscardedItems(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listDiscardedItems>>, TError, TData> 
}

export type ListDiscardedItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listDiscardedItems>>>
export type ListDiscardedItemsQueryError = ErrorType<void>


/**
 * @summary List of Discarded Items
 */

export function useListDiscardedItems<TData = Awaited<ReturnType<typeof listDiscardedItems>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListDiscardedItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDiscardedItems>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListDiscardedItemsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Create File Attachement
 */
export const createFileSharingFileAttachment = (
    id: MaybeRef<string>,
    createFileSharingFileAttachmentBody: MaybeRef<CreateFileSharingFileAttachmentBody>,
 signal?: AbortSignal
) => {
      id = unref(id);
createFileSharingFileAttachmentBody = unref(createFileSharingFileAttachmentBody);
      
      return axiosClient<void>(
      {url: `/api/file_sharing/files/${id}/attachment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createFileSharingFileAttachmentBody, signal
    },
      );
    }
  


export const getCreateFileSharingFileAttachmentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFileSharingFileAttachment>>, TError,{id: string;data: CreateFileSharingFileAttachmentBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFileSharingFileAttachment>>, TError,{id: string;data: CreateFileSharingFileAttachmentBody}, TContext> => {
    
const mutationKey = ['createFileSharingFileAttachment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFileSharingFileAttachment>>, {id: string;data: CreateFileSharingFileAttachmentBody}> = (props) => {
          const {id,data} = props ?? {};

          return  createFileSharingFileAttachment(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateFileSharingFileAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof createFileSharingFileAttachment>>>
    export type CreateFileSharingFileAttachmentMutationBody = CreateFileSharingFileAttachmentBody
    export type CreateFileSharingFileAttachmentMutationError = ErrorType<void>

    /**
 * @summary Create File Attachement
 */
export const useCreateFileSharingFileAttachment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFileSharingFileAttachment>>, TError,{id: string;data: CreateFileSharingFileAttachmentBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createFileSharingFileAttachment>>,
        TError,
        {id: string;data: CreateFileSharingFileAttachmentBody},
        TContext
      > => {

      const mutationOptions = getCreateFileSharingFileAttachmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Delete File Attachment
 */
export const deleteFileSharingFileAttachment = (
    id: MaybeRef<string>,
    params: MaybeRef<DeleteFileSharingFileAttachmentParams>,
 ) => {
      id = unref(id);
params = unref(params);
      
      return axiosClient<void>(
      {url: `/api/file_sharing/files/${id}/attachment`, method: 'DELETE',
        params: unref(params)
    },
      );
    }
  


export const getDeleteFileSharingFileAttachmentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFileSharingFileAttachment>>, TError,{id: string;params: DeleteFileSharingFileAttachmentParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteFileSharingFileAttachment>>, TError,{id: string;params: DeleteFileSharingFileAttachmentParams}, TContext> => {
    
const mutationKey = ['deleteFileSharingFileAttachment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFileSharingFileAttachment>>, {id: string;params: DeleteFileSharingFileAttachmentParams}> = (props) => {
          const {id,params} = props ?? {};

          return  deleteFileSharingFileAttachment(id,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteFileSharingFileAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFileSharingFileAttachment>>>
    
    export type DeleteFileSharingFileAttachmentMutationError = ErrorType<void>

    /**
 * @summary Delete File Attachment
 */
export const useDeleteFileSharingFileAttachment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFileSharingFileAttachment>>, TError,{id: string;params: DeleteFileSharingFileAttachmentParams}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteFileSharingFileAttachment>>,
        TError,
        {id: string;params: DeleteFileSharingFileAttachmentParams},
        TContext
      > => {

      const mutationOptions = getDeleteFileSharingFileAttachmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Files
 */
export const listFileSharingFiles = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<PaginatedFileSharingFiles>(
      {url: `/api/file_sharing/files`, method: 'GET', signal
    },
      );
    }
  

const getListFileSharingFilesQueryKey = () => {
    return ['api','file_sharing','files'] as const;
    }

    
export const useListFileSharingFilesQueryOptions = <TData = Awaited<ReturnType<typeof listFileSharingFiles>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFileSharingFiles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListFileSharingFilesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFileSharingFiles>>> = ({ signal }) => listFileSharingFiles(signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listFileSharingFiles>>, TError, TData> 
}

export type ListFileSharingFilesQueryResult = NonNullable<Awaited<ReturnType<typeof listFileSharingFiles>>>
export type ListFileSharingFilesQueryError = ErrorType<void>


/**
 * @summary List of Files
 */

export function useListFileSharingFiles<TData = Awaited<ReturnType<typeof listFileSharingFiles>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFileSharingFiles>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListFileSharingFilesQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary File Details
 */
export const getFileSharingFile = (
    id: MaybeRef<string>,
    params?: MaybeRef<GetFileSharingFileParams>,
 signal?: AbortSignal
) => {
      id = unref(id);
params = unref(params);
      
      return axiosClient<FileSharingFile>(
      {url: `/api/file_sharing/files/${id}`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getGetFileSharingFileQueryKey = (id: MaybeRef<string>,
    params?: MaybeRef<GetFileSharingFileParams>,) => {
    return ['api','file_sharing','files',id, ...(params ? [params]: [])] as const;
    }

    
export const useGetFileSharingFileQueryOptions = <TData = Awaited<ReturnType<typeof getFileSharingFile>>, TError = ErrorType<void>>(id: MaybeRef<string>,
    params?: MaybeRef<GetFileSharingFileParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFileSharingFile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetFileSharingFileQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFileSharingFile>>> = ({ signal }) => getFileSharingFile(id,params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getFileSharingFile>>, TError, TData> 
}

export type GetFileSharingFileQueryResult = NonNullable<Awaited<ReturnType<typeof getFileSharingFile>>>
export type GetFileSharingFileQueryError = ErrorType<void>


/**
 * @summary File Details
 */

export function useGetFileSharingFile<TData = Awaited<ReturnType<typeof getFileSharingFile>>, TError = ErrorType<void>>(
 id: MaybeRef<string>,
    params?: MaybeRef<GetFileSharingFileParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFileSharingFile>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetFileSharingFileQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update File
 */
export const updateFileSharingFile = (
    id: MaybeRef<string>,
    updateFileSharingFileBody: MaybeRef<UpdateFileSharingFileBody>,
 ) => {
      id = unref(id);
updateFileSharingFileBody = unref(updateFileSharingFileBody);
      
      return axiosClient<FileSharingFile>(
      {url: `/api/file_sharing/files/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateFileSharingFileBody
    },
      );
    }
  


export const getUpdateFileSharingFileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFileSharingFile>>, TError,{id: string;data: UpdateFileSharingFileBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFileSharingFile>>, TError,{id: string;data: UpdateFileSharingFileBody}, TContext> => {
    
const mutationKey = ['updateFileSharingFile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFileSharingFile>>, {id: string;data: UpdateFileSharingFileBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateFileSharingFile(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateFileSharingFileMutationResult = NonNullable<Awaited<ReturnType<typeof updateFileSharingFile>>>
    export type UpdateFileSharingFileMutationBody = UpdateFileSharingFileBody
    export type UpdateFileSharingFileMutationError = ErrorType<void>

    /**
 * @summary Update File
 */
export const useUpdateFileSharingFile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFileSharingFile>>, TError,{id: string;data: UpdateFileSharingFileBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFileSharingFile>>,
        TError,
        {id: string;data: UpdateFileSharingFileBody},
        TContext
      > => {

      const mutationOptions = getUpdateFileSharingFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create Folder
 */
export const createFolder = (
    createFolderBody: MaybeRef<CreateFolderBody>,
 signal?: AbortSignal
) => {
      createFolderBody = unref(createFolderBody);
      
      return axiosClient<Folder>(
      {url: `/api/folders`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createFolderBody, signal
    },
      );
    }
  


export const getCreateFolderMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFolder>>, TError,{data: CreateFolderBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFolder>>, TError,{data: CreateFolderBody}, TContext> => {
    
const mutationKey = ['createFolder'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFolder>>, {data: CreateFolderBody}> = (props) => {
          const {data} = props ?? {};

          return  createFolder(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateFolderMutationResult = NonNullable<Awaited<ReturnType<typeof createFolder>>>
    export type CreateFolderMutationBody = CreateFolderBody
    export type CreateFolderMutationError = ErrorType<void>

    /**
 * @summary Create Folder
 */
export const useCreateFolder = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFolder>>, TError,{data: CreateFolderBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createFolder>>,
        TError,
        {data: CreateFolderBody},
        TContext
      > => {

      const mutationOptions = getCreateFolderMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Folders
 */
export const listFolders = (
    params?: MaybeRef<ListFoldersParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedFolders>(
      {url: `/api/folders`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListFoldersQueryKey = (params?: MaybeRef<ListFoldersParams>,) => {
    return ['api','folders', ...(params ? [params]: [])] as const;
    }

    
export const useListFoldersQueryOptions = <TData = Awaited<ReturnType<typeof listFolders>>, TError = ErrorType<void>>(params?: MaybeRef<ListFoldersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFolders>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListFoldersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFolders>>> = ({ signal }) => listFolders(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listFolders>>, TError, TData> 
}

export type ListFoldersQueryResult = NonNullable<Awaited<ReturnType<typeof listFolders>>>
export type ListFoldersQueryError = ErrorType<void>


/**
 * @summary List of Folders
 */

export function useListFolders<TData = Awaited<ReturnType<typeof listFolders>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListFoldersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFolders>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListFoldersQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete Folder
 */
export const deleteFolder = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/folders/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteFolderMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFolder>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteFolder>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteFolder'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFolder>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteFolder(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteFolderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFolder>>>
    
    export type DeleteFolderMutationError = ErrorType<void>

    /**
 * @summary Delete Folder
 */
export const useDeleteFolder = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFolder>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteFolder>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteFolderMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Folder Details
 */
export const getFolder = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<Folder>(
      {url: `/api/folders/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetFolderQueryKey = (id: MaybeRef<string>,) => {
    return ['api','folders',id] as const;
    }

    
export const useGetFolderQueryOptions = <TData = Awaited<ReturnType<typeof getFolder>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFolder>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetFolderQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFolder>>> = ({ signal }) => getFolder(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getFolder>>, TError, TData> 
}

export type GetFolderQueryResult = NonNullable<Awaited<ReturnType<typeof getFolder>>>
export type GetFolderQueryError = ErrorType<void>


/**
 * @summary Folder Details
 */

export function useGetFolder<TData = Awaited<ReturnType<typeof getFolder>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFolder>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetFolderQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update Folder
 */
export const updateFolder = (
    id: MaybeRef<string>,
    updateFolderBody: MaybeRef<UpdateFolderBody>,
 ) => {
      id = unref(id);
updateFolderBody = unref(updateFolderBody);
      
      return axiosClient<Folder>(
      {url: `/api/folders/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateFolderBody
    },
      );
    }
  


export const getUpdateFolderMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFolder>>, TError,{id: string;data: UpdateFolderBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFolder>>, TError,{id: string;data: UpdateFolderBody}, TContext> => {
    
const mutationKey = ['updateFolder'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFolder>>, {id: string;data: UpdateFolderBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateFolder(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateFolderMutationResult = NonNullable<Awaited<ReturnType<typeof updateFolder>>>
    export type UpdateFolderMutationBody = UpdateFolderBody
    export type UpdateFolderMutationError = ErrorType<void>

    /**
 * @summary Update Folder
 */
export const useUpdateFolder = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFolder>>, TError,{id: string;data: UpdateFolderBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFolder>>,
        TError,
        {id: string;data: UpdateFolderBody},
        TContext
      > => {

      const mutationOptions = getUpdateFolderMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create Image Attachment
 */
export const createImageAttachment = (
    createImageAttachmentBody: MaybeRef<CreateImageAttachmentBody>,
 signal?: AbortSignal
) => {
      createImageAttachmentBody = unref(createImageAttachmentBody);
      
      return axiosClient<ImageAttachment>(
      {url: `/api/image_attachments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createImageAttachmentBody, signal
    },
      );
    }
  


export const getCreateImageAttachmentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImageAttachment>>, TError,{data: CreateImageAttachmentBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createImageAttachment>>, TError,{data: CreateImageAttachmentBody}, TContext> => {
    
const mutationKey = ['createImageAttachment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createImageAttachment>>, {data: CreateImageAttachmentBody}> = (props) => {
          const {data} = props ?? {};

          return  createImageAttachment(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateImageAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof createImageAttachment>>>
    export type CreateImageAttachmentMutationBody = CreateImageAttachmentBody
    export type CreateImageAttachmentMutationError = ErrorType<void>

    /**
 * @summary Create Image Attachment
 */
export const useCreateImageAttachment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImageAttachment>>, TError,{data: CreateImageAttachmentBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createImageAttachment>>,
        TError,
        {data: CreateImageAttachmentBody},
        TContext
      > => {

      const mutationOptions = getCreateImageAttachmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Delete Image Attachment
 */
export const deleteImageAttachment = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/image_attachments/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteImageAttachmentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteImageAttachment>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteImageAttachment>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteImageAttachment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteImageAttachment>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteImageAttachment(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteImageAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteImageAttachment>>>
    
    export type DeleteImageAttachmentMutationError = ErrorType<void>

    /**
 * @summary Delete Image Attachment
 */
export const useDeleteImageAttachment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteImageAttachment>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteImageAttachment>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteImageAttachmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Show Image Attachment
 */
export const showImageAttachment = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<ImageAttachment>(
      {url: `/api/image_attachments/${id}`, method: 'GET', signal
    },
      );
    }
  

const getShowImageAttachmentQueryKey = (id: MaybeRef<string>,) => {
    return ['api','image_attachments',id] as const;
    }

    
export const useShowImageAttachmentQueryOptions = <TData = Awaited<ReturnType<typeof showImageAttachment>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showImageAttachment>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getShowImageAttachmentQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof showImageAttachment>>> = ({ signal }) => showImageAttachment(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof showImageAttachment>>, TError, TData> 
}

export type ShowImageAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof showImageAttachment>>>
export type ShowImageAttachmentQueryError = ErrorType<void>


/**
 * @summary Show Image Attachment
 */

export function useShowImageAttachment<TData = Awaited<ReturnType<typeof showImageAttachment>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showImageAttachment>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowImageAttachmentQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Create Item
 */
export const createItem = (
    itemCreateInput: MaybeRef<ItemCreateInput>,
 signal?: AbortSignal
) => {
      itemCreateInput = unref(itemCreateInput);
      
      return axiosClient<Item>(
      {url: `/api/items`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: itemCreateInput, signal
    },
      );
    }
  


export const getCreateItemMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createItem>>, TError,{data: ItemCreateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createItem>>, TError,{data: ItemCreateInput}, TContext> => {
    
const mutationKey = ['createItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createItem>>, {data: ItemCreateInput}> = (props) => {
          const {data} = props ?? {};

          return  createItem(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateItemMutationResult = NonNullable<Awaited<ReturnType<typeof createItem>>>
    export type CreateItemMutationBody = ItemCreateInput
    export type CreateItemMutationError = ErrorType<void>

    /**
 * @summary Create Item
 */
export const useCreateItem = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createItem>>, TError,{data: ItemCreateInput}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createItem>>,
        TError,
        {data: ItemCreateInput},
        TContext
      > => {

      const mutationOptions = getCreateItemMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Items
 */
export const listItems = (
    params: MaybeRef<ListItemsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedItems>(
      {url: `/api/items`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListItemsQueryKey = (params: MaybeRef<ListItemsParams>,) => {
    return ['api','items', ...(params ? [params]: [])] as const;
    }

    
export const useListItemsQueryOptions = <TData = Awaited<ReturnType<typeof listItems>>, TError = ErrorType<void>>(params: MaybeRef<ListItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listItems>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListItemsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listItems>>> = ({ signal }) => listItems(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listItems>>, TError, TData> 
}

export type ListItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listItems>>>
export type ListItemsQueryError = ErrorType<void>


/**
 * @summary List of Items
 */

export function useListItems<TData = Awaited<ReturnType<typeof listItems>>, TError = ErrorType<void>>(
 params: MaybeRef<ListItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listItems>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListItemsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update Item
 */
export const updateItem = (
    itemInput: MaybeRef<ItemInput>,
    params: MaybeRef<UpdateItemParams>,
 ) => {
      itemInput = unref(itemInput);
params = unref(params);
      
      return axiosClient<Item>(
      {url: `/api/items`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: itemInput,
        params: unref(params)
    },
      );
    }
  


export const getUpdateItemMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateItem>>, TError,{data: ItemInput;params: UpdateItemParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateItem>>, TError,{data: ItemInput;params: UpdateItemParams}, TContext> => {
    
const mutationKey = ['updateItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateItem>>, {data: ItemInput;params: UpdateItemParams}> = (props) => {
          const {data,params} = props ?? {};

          return  updateItem(data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateItem>>>
    export type UpdateItemMutationBody = ItemInput
    export type UpdateItemMutationError = ErrorType<void>

    /**
 * @summary Update Item
 */
export const useUpdateItem = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateItem>>, TError,{data: ItemInput;params: UpdateItemParams}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateItem>>,
        TError,
        {data: ItemInput;params: UpdateItemParams},
        TContext
      > => {

      const mutationOptions = getUpdateItemMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Duplicate Item
 */
export const duplicateItem = (
    params: MaybeRef<DuplicateItemParams>,
 ) => {
      params = unref(params);
      
      return axiosClient<void>(
      {url: `/api/items/duplicate`, method: 'PUT',
        params: unref(params)
    },
      );
    }
  


export const getDuplicateItemMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateItem>>, TError,{params: DuplicateItemParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof duplicateItem>>, TError,{params: DuplicateItemParams}, TContext> => {
    
const mutationKey = ['duplicateItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateItem>>, {params: DuplicateItemParams}> = (props) => {
          const {params} = props ?? {};

          return  duplicateItem(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DuplicateItemMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateItem>>>
    
    export type DuplicateItemMutationError = ErrorType<void>

    /**
 * @summary Duplicate Item
 */
export const useDuplicateItem = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateItem>>, TError,{params: DuplicateItemParams}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof duplicateItem>>,
        TError,
        {params: DuplicateItemParams},
        TContext
      > => {

      const mutationOptions = getDuplicateItemMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Move Item
 */
export const moveItem = (
    itemMoveInput: MaybeRef<ItemMoveInput>,
 ) => {
      itemMoveInput = unref(itemMoveInput);
      
      return axiosClient<void>(
      {url: `/api/items/move`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: itemMoveInput
    },
      );
    }
  


export const getMoveItemMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveItem>>, TError,{data: ItemMoveInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moveItem>>, TError,{data: ItemMoveInput}, TContext> => {
    
const mutationKey = ['moveItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveItem>>, {data: ItemMoveInput}> = (props) => {
          const {data} = props ?? {};

          return  moveItem(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MoveItemMutationResult = NonNullable<Awaited<ReturnType<typeof moveItem>>>
    export type MoveItemMutationBody = ItemMoveInput
    export type MoveItemMutationError = ErrorType<void>

    /**
 * @summary Move Item
 */
export const useMoveItem = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveItem>>, TError,{data: ItemMoveInput}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof moveItem>>,
        TError,
        {data: ItemMoveInput},
        TContext
      > => {

      const mutationOptions = getMoveItemMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of recently created Items
 */
export const listRecentlyCreatedItems = (
    params?: MaybeRef<ListRecentlyCreatedItemsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<Item[]>(
      {url: `/api/items/recently_created`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListRecentlyCreatedItemsQueryKey = (params?: MaybeRef<ListRecentlyCreatedItemsParams>,) => {
    return ['api','items','recently_created', ...(params ? [params]: [])] as const;
    }

    
export const useListRecentlyCreatedItemsQueryOptions = <TData = Awaited<ReturnType<typeof listRecentlyCreatedItems>>, TError = ErrorType<void>>(params?: MaybeRef<ListRecentlyCreatedItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecentlyCreatedItems>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListRecentlyCreatedItemsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRecentlyCreatedItems>>> = ({ signal }) => listRecentlyCreatedItems(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listRecentlyCreatedItems>>, TError, TData> 
}

export type ListRecentlyCreatedItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listRecentlyCreatedItems>>>
export type ListRecentlyCreatedItemsQueryError = ErrorType<void>


/**
 * @summary List of recently created Items
 */

export function useListRecentlyCreatedItems<TData = Awaited<ReturnType<typeof listRecentlyCreatedItems>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListRecentlyCreatedItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecentlyCreatedItems>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListRecentlyCreatedItemsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Remix Item
 */
export const remix = (
    params: MaybeRef<RemixParams>,
 ) => {
      params = unref(params);
      
      return axiosClient<void>(
      {url: `/api/items/remix`, method: 'PUT',
        params: unref(params)
    },
      );
    }
  


export const getRemixMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remix>>, TError,{params: RemixParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof remix>>, TError,{params: RemixParams}, TContext> => {
    
const mutationKey = ['remix'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof remix>>, {params: RemixParams}> = (props) => {
          const {params} = props ?? {};

          return  remix(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemixMutationResult = NonNullable<Awaited<ReturnType<typeof remix>>>
    
    export type RemixMutationError = ErrorType<void>

    /**
 * @summary Remix Item
 */
export const useRemix = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remix>>, TError,{params: RemixParams}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof remix>>,
        TError,
        {params: RemixParams},
        TContext
      > => {

      const mutationOptions = getRemixMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Remix Item Sync
 */
export const remixSync = (
    params: MaybeRef<RemixSyncParams>,
 ) => {
      params = unref(params);
      
      return axiosClient<Item>(
      {url: `/api/items/remix_sync`, method: 'PUT',
        params: unref(params)
    },
      );
    }
  


export const getRemixSyncMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remixSync>>, TError,{params: RemixSyncParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof remixSync>>, TError,{params: RemixSyncParams}, TContext> => {
    
const mutationKey = ['remixSync'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof remixSync>>, {params: RemixSyncParams}> = (props) => {
          const {params} = props ?? {};

          return  remixSync(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemixSyncMutationResult = NonNullable<Awaited<ReturnType<typeof remixSync>>>
    
    export type RemixSyncMutationError = ErrorType<void>

    /**
 * @summary Remix Item Sync
 */
export const useRemixSync = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remixSync>>, TError,{params: RemixSyncParams}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof remixSync>>,
        TError,
        {params: RemixSyncParams},
        TContext
      > => {

      const mutationOptions = getRemixSyncMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Search Items
 */
export const searchItems = (
    params?: MaybeRef<SearchItemsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedItems>(
      {url: `/api/items/search`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getSearchItemsQueryKey = (params?: MaybeRef<SearchItemsParams>,) => {
    return ['api','items','search', ...(params ? [params]: [])] as const;
    }

    
export const useSearchItemsQueryOptions = <TData = Awaited<ReturnType<typeof searchItems>>, TError = ErrorType<void>>(params?: MaybeRef<SearchItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchItems>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSearchItemsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchItems>>> = ({ signal }) => searchItems(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof searchItems>>, TError, TData> 
}

export type SearchItemsQueryResult = NonNullable<Awaited<ReturnType<typeof searchItems>>>
export type SearchItemsQueryError = ErrorType<void>


/**
 * @summary Search Items
 */

export function useSearchItems<TData = Awaited<ReturnType<typeof searchItems>>, TError = ErrorType<void>>(
 params?: MaybeRef<SearchItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchItems>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useSearchItemsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Item Details
 */
export const getItem = (
    id: MaybeRef<string>,
    params: MaybeRef<GetItemParams>,
 signal?: AbortSignal
) => {
      id = unref(id);
params = unref(params);
      
      return axiosClient<Item>(
      {url: `/api/items/${id}`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getGetItemQueryKey = (id: MaybeRef<string>,
    params: MaybeRef<GetItemParams>,) => {
    return ['api','items',id, ...(params ? [params]: [])] as const;
    }

    
export const useGetItemQueryOptions = <TData = Awaited<ReturnType<typeof getItem>>, TError = ErrorType<void>>(id: MaybeRef<string>,
    params: MaybeRef<GetItemParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getItem>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetItemQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getItem>>> = ({ signal }) => getItem(id,params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getItem>>, TError, TData> 
}

export type GetItemQueryResult = NonNullable<Awaited<ReturnType<typeof getItem>>>
export type GetItemQueryError = ErrorType<void>


/**
 * @summary Item Details
 */

export function useGetItem<TData = Awaited<ReturnType<typeof getItem>>, TError = ErrorType<void>>(
 id: MaybeRef<string>,
    params: MaybeRef<GetItemParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getItem>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetItemQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Toggle Discarded Item
 */
export const toggleDiscardedItem = (
    params: MaybeRef<ToggleDiscardedItemParams>,
 ) => {
      params = unref(params);
      
      return axiosClient<void>(
      {url: `/api/items/toggle_discard`, method: 'PUT',
        params: unref(params)
    },
      );
    }
  


export const getToggleDiscardedItemMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleDiscardedItem>>, TError,{params: ToggleDiscardedItemParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof toggleDiscardedItem>>, TError,{params: ToggleDiscardedItemParams}, TContext> => {
    
const mutationKey = ['toggleDiscardedItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleDiscardedItem>>, {params: ToggleDiscardedItemParams}> = (props) => {
          const {params} = props ?? {};

          return  toggleDiscardedItem(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ToggleDiscardedItemMutationResult = NonNullable<Awaited<ReturnType<typeof toggleDiscardedItem>>>
    
    export type ToggleDiscardedItemMutationError = ErrorType<void>

    /**
 * @summary Toggle Discarded Item
 */
export const useToggleDiscardedItem = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleDiscardedItem>>, TError,{params: ToggleDiscardedItemParams}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof toggleDiscardedItem>>,
        TError,
        {params: ToggleDiscardedItemParams},
        TContext
      > => {

      const mutationOptions = getToggleDiscardedItemMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Toggle Template Flag
 */
export const toggleTemplateItem = (
    params: MaybeRef<ToggleTemplateItemParams>,
 ) => {
      params = unref(params);
      
      return axiosClient<void>(
      {url: `/api/items/toggle_template`, method: 'PUT',
        params: unref(params)
    },
      );
    }
  


export const getToggleTemplateItemMutationOptions = <TError = ErrorType<void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleTemplateItem>>, TError,{params: ToggleTemplateItemParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof toggleTemplateItem>>, TError,{params: ToggleTemplateItemParams}, TContext> => {
    
const mutationKey = ['toggleTemplateItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleTemplateItem>>, {params: ToggleTemplateItemParams}> = (props) => {
          const {params} = props ?? {};

          return  toggleTemplateItem(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ToggleTemplateItemMutationResult = NonNullable<Awaited<ReturnType<typeof toggleTemplateItem>>>
    
    export type ToggleTemplateItemMutationError = ErrorType<void | ValidationError>

    /**
 * @summary Toggle Template Flag
 */
export const useToggleTemplateItem = <TError = ErrorType<void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleTemplateItem>>, TError,{params: ToggleTemplateItemParams}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof toggleTemplateItem>>,
        TError,
        {params: ToggleTemplateItemParams},
        TContext
      > => {

      const mutationOptions = getToggleTemplateItemMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create Link
 */
export const createLinkShortenerLink = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<LinkShortenerLink>(
      {url: `/api/link_shortener/links`, method: 'POST', signal
    },
      );
    }
  


export const getCreateLinkShortenerLinkMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLinkShortenerLink>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createLinkShortenerLink>>, TError,void, TContext> => {
    
const mutationKey = ['createLinkShortenerLink'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLinkShortenerLink>>, void> = () => {
          

          return  createLinkShortenerLink()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateLinkShortenerLinkMutationResult = NonNullable<Awaited<ReturnType<typeof createLinkShortenerLink>>>
    
    export type CreateLinkShortenerLinkMutationError = ErrorType<void>

    /**
 * @summary Create Link
 */
export const useCreateLinkShortenerLink = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLinkShortenerLink>>, TError,void, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createLinkShortenerLink>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getCreateLinkShortenerLinkMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Links
 */
export const listLinkShortenerLinks = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<PaginatedLinkShortenerLinks>(
      {url: `/api/link_shortener/links`, method: 'GET', signal
    },
      );
    }
  

const getListLinkShortenerLinksQueryKey = () => {
    return ['api','link_shortener','links'] as const;
    }

    
export const useListLinkShortenerLinksQueryOptions = <TData = Awaited<ReturnType<typeof listLinkShortenerLinks>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLinkShortenerLinks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListLinkShortenerLinksQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLinkShortenerLinks>>> = ({ signal }) => listLinkShortenerLinks(signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listLinkShortenerLinks>>, TError, TData> 
}

export type ListLinkShortenerLinksQueryResult = NonNullable<Awaited<ReturnType<typeof listLinkShortenerLinks>>>
export type ListLinkShortenerLinksQueryError = ErrorType<void>


/**
 * @summary List of Links
 */

export function useListLinkShortenerLinks<TData = Awaited<ReturnType<typeof listLinkShortenerLinks>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLinkShortenerLinks>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListLinkShortenerLinksQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete Video Recorder File
 */
export const deleteVideoRecorderFile = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/video_recorder/files/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteVideoRecorderFileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVideoRecorderFile>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteVideoRecorderFile>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteVideoRecorderFile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVideoRecorderFile>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteVideoRecorderFile(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteVideoRecorderFileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVideoRecorderFile>>>
    
    export type DeleteVideoRecorderFileMutationError = ErrorType<void>

    /**
 * @summary Delete Video Recorder File
 */
export const useDeleteVideoRecorderFile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVideoRecorderFile>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteVideoRecorderFile>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteVideoRecorderFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Show File
 */
export const showVideoRecorderFile = (
    id: MaybeRef<string>,
    params?: MaybeRef<ShowVideoRecorderFileParams>,
 signal?: AbortSignal
) => {
      id = unref(id);
params = unref(params);
      
      return axiosClient<VideoRecorderFile>(
      {url: `/api/video_recorder/files/${id}`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getShowVideoRecorderFileQueryKey = (id: MaybeRef<string>,
    params?: MaybeRef<ShowVideoRecorderFileParams>,) => {
    return ['api','video_recorder','files',id, ...(params ? [params]: [])] as const;
    }

    
export const useShowVideoRecorderFileQueryOptions = <TData = Awaited<ReturnType<typeof showVideoRecorderFile>>, TError = ErrorType<void>>(id: MaybeRef<string>,
    params?: MaybeRef<ShowVideoRecorderFileParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showVideoRecorderFile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getShowVideoRecorderFileQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof showVideoRecorderFile>>> = ({ signal }) => showVideoRecorderFile(id,params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof showVideoRecorderFile>>, TError, TData> 
}

export type ShowVideoRecorderFileQueryResult = NonNullable<Awaited<ReturnType<typeof showVideoRecorderFile>>>
export type ShowVideoRecorderFileQueryError = ErrorType<void>


/**
 * @summary Show File
 */

export function useShowVideoRecorderFile<TData = Awaited<ReturnType<typeof showVideoRecorderFile>>, TError = ErrorType<void>>(
 id: MaybeRef<string>,
    params?: MaybeRef<ShowVideoRecorderFileParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showVideoRecorderFile>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowVideoRecorderFileQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update File
 */
export const updateVideoRecorderFile = (
    id: MaybeRef<string>,
    updateVideoRecorderFileBody: MaybeRef<UpdateVideoRecorderFileBody>,
 ) => {
      id = unref(id);
updateVideoRecorderFileBody = unref(updateVideoRecorderFileBody);
      
      return axiosClient<VideoRecorderFile>(
      {url: `/api/video_recorder/files/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateVideoRecorderFileBody
    },
      );
    }
  


export const getUpdateVideoRecorderFileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVideoRecorderFile>>, TError,{id: string;data: UpdateVideoRecorderFileBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVideoRecorderFile>>, TError,{id: string;data: UpdateVideoRecorderFileBody}, TContext> => {
    
const mutationKey = ['updateVideoRecorderFile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVideoRecorderFile>>, {id: string;data: UpdateVideoRecorderFileBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateVideoRecorderFile(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateVideoRecorderFileMutationResult = NonNullable<Awaited<ReturnType<typeof updateVideoRecorderFile>>>
    export type UpdateVideoRecorderFileMutationBody = UpdateVideoRecorderFileBody
    export type UpdateVideoRecorderFileMutationError = ErrorType<void>

    /**
 * @summary Update File
 */
export const useUpdateVideoRecorderFile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVideoRecorderFile>>, TError,{id: string;data: UpdateVideoRecorderFileBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateVideoRecorderFile>>,
        TError,
        {id: string;data: UpdateVideoRecorderFileBody},
        TContext
      > => {

      const mutationOptions = getUpdateVideoRecorderFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Link Details
 */
export const getLinkShortenerLink = (
    id: MaybeRef<string>,
    params?: MaybeRef<GetLinkShortenerLinkParams>,
 signal?: AbortSignal
) => {
      id = unref(id);
params = unref(params);
      
      return axiosClient<LinkShortenerLink>(
      {url: `/api/link_shortener/links/${id}`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getGetLinkShortenerLinkQueryKey = (id: MaybeRef<string>,
    params?: MaybeRef<GetLinkShortenerLinkParams>,) => {
    return ['api','link_shortener','links',id, ...(params ? [params]: [])] as const;
    }

    
export const useGetLinkShortenerLinkQueryOptions = <TData = Awaited<ReturnType<typeof getLinkShortenerLink>>, TError = ErrorType<StandardError | void>>(id: MaybeRef<string>,
    params?: MaybeRef<GetLinkShortenerLinkParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkShortenerLink>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetLinkShortenerLinkQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLinkShortenerLink>>> = ({ signal }) => getLinkShortenerLink(id,params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getLinkShortenerLink>>, TError, TData> 
}

export type GetLinkShortenerLinkQueryResult = NonNullable<Awaited<ReturnType<typeof getLinkShortenerLink>>>
export type GetLinkShortenerLinkQueryError = ErrorType<StandardError | void>


/**
 * @summary Link Details
 */

export function useGetLinkShortenerLink<TData = Awaited<ReturnType<typeof getLinkShortenerLink>>, TError = ErrorType<StandardError | void>>(
 id: MaybeRef<string>,
    params?: MaybeRef<GetLinkShortenerLinkParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkShortenerLink>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetLinkShortenerLinkQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update Link
 */
export const updateLinkShortenerLink = (
    id: MaybeRef<string>,
    updateLinkShortenerLinkBody: MaybeRef<UpdateLinkShortenerLinkBody>,
 ) => {
      id = unref(id);
updateLinkShortenerLinkBody = unref(updateLinkShortenerLinkBody);
      
      return axiosClient<LinkShortenerLink>(
      {url: `/api/link_shortener/links/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateLinkShortenerLinkBody
    },
      );
    }
  


export const getUpdateLinkShortenerLinkMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLinkShortenerLink>>, TError,{id: string;data: UpdateLinkShortenerLinkBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateLinkShortenerLink>>, TError,{id: string;data: UpdateLinkShortenerLinkBody}, TContext> => {
    
const mutationKey = ['updateLinkShortenerLink'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLinkShortenerLink>>, {id: string;data: UpdateLinkShortenerLinkBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateLinkShortenerLink(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateLinkShortenerLinkMutationResult = NonNullable<Awaited<ReturnType<typeof updateLinkShortenerLink>>>
    export type UpdateLinkShortenerLinkMutationBody = UpdateLinkShortenerLinkBody
    export type UpdateLinkShortenerLinkMutationError = ErrorType<void>

    /**
 * @summary Update Link
 */
export const useUpdateLinkShortenerLink = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLinkShortenerLink>>, TError,{id: string;data: UpdateLinkShortenerLinkBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateLinkShortenerLink>>,
        TError,
        {id: string;data: UpdateLinkShortenerLinkBody},
        TContext
      > => {

      const mutationOptions = getUpdateLinkShortenerLinkMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Materials
 */
export const listMaterials = (
    params?: MaybeRef<ListMaterialsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedMaterials>(
      {url: `/api/materials`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListMaterialsQueryKey = (params?: MaybeRef<ListMaterialsParams>,) => {
    return ['api','materials', ...(params ? [params]: [])] as const;
    }

    
export const useListMaterialsQueryOptions = <TData = Awaited<ReturnType<typeof listMaterials>>, TError = ErrorType<unknown>>(params?: MaybeRef<ListMaterialsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMaterials>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListMaterialsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMaterials>>> = ({ signal }) => listMaterials(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listMaterials>>, TError, TData> 
}

export type ListMaterialsQueryResult = NonNullable<Awaited<ReturnType<typeof listMaterials>>>
export type ListMaterialsQueryError = ErrorType<unknown>


/**
 * @summary List of Materials
 */

export function useListMaterials<TData = Awaited<ReturnType<typeof listMaterials>>, TError = ErrorType<unknown>>(
 params?: MaybeRef<ListMaterialsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMaterials>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListMaterialsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Search Materials
 */
export const searchMaterials = (
    params: MaybeRef<SearchMaterialsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedItems>(
      {url: `/api/materials/search`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getSearchMaterialsQueryKey = (params: MaybeRef<SearchMaterialsParams>,) => {
    return ['api','materials','search', ...(params ? [params]: [])] as const;
    }

    
export const useSearchMaterialsQueryOptions = <TData = Awaited<ReturnType<typeof searchMaterials>>, TError = ErrorType<StandardError>>(params: MaybeRef<SearchMaterialsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchMaterials>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSearchMaterialsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchMaterials>>> = ({ signal }) => searchMaterials(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof searchMaterials>>, TError, TData> 
}

export type SearchMaterialsQueryResult = NonNullable<Awaited<ReturnType<typeof searchMaterials>>>
export type SearchMaterialsQueryError = ErrorType<StandardError>


/**
 * @summary Search Materials
 */

export function useSearchMaterials<TData = Awaited<ReturnType<typeof searchMaterials>>, TError = ErrorType<StandardError>>(
 params: MaybeRef<SearchMaterialsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchMaterials>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useSearchMaterialsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Create Owner File
 */
export const createOwnerFile = (
    createOwnerFileBody: MaybeRef<CreateOwnerFileBody>,
 signal?: AbortSignal
) => {
      createOwnerFileBody = unref(createOwnerFileBody);
      
      return axiosClient<OwnerFile>(
      {url: `/api/owner_files`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOwnerFileBody, signal
    },
      );
    }
  


export const getCreateOwnerFileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOwnerFile>>, TError,{data: CreateOwnerFileBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createOwnerFile>>, TError,{data: CreateOwnerFileBody}, TContext> => {
    
const mutationKey = ['createOwnerFile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOwnerFile>>, {data: CreateOwnerFileBody}> = (props) => {
          const {data} = props ?? {};

          return  createOwnerFile(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateOwnerFileMutationResult = NonNullable<Awaited<ReturnType<typeof createOwnerFile>>>
    export type CreateOwnerFileMutationBody = CreateOwnerFileBody
    export type CreateOwnerFileMutationError = ErrorType<void>

    /**
 * @summary Create Owner File
 */
export const useCreateOwnerFile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOwnerFile>>, TError,{data: CreateOwnerFileBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createOwnerFile>>,
        TError,
        {data: CreateOwnerFileBody},
        TContext
      > => {

      const mutationOptions = getCreateOwnerFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Delete Owner File
 */
export const deleteOwnerFile = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/owner_files/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteOwnerFileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOwnerFile>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteOwnerFile>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteOwnerFile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOwnerFile>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteOwnerFile(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteOwnerFileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOwnerFile>>>
    
    export type DeleteOwnerFileMutationError = ErrorType<void>

    /**
 * @summary Delete Owner File
 */
export const useDeleteOwnerFile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOwnerFile>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteOwnerFile>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteOwnerFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Show Owner File
 */
export const showOwnerFile = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<OwnerFile>(
      {url: `/api/owner_files/${id}`, method: 'GET', signal
    },
      );
    }
  

const getShowOwnerFileQueryKey = (id: MaybeRef<string>,) => {
    return ['api','owner_files',id] as const;
    }

    
export const useShowOwnerFileQueryOptions = <TData = Awaited<ReturnType<typeof showOwnerFile>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showOwnerFile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getShowOwnerFileQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof showOwnerFile>>> = ({ signal }) => showOwnerFile(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof showOwnerFile>>, TError, TData> 
}

export type ShowOwnerFileQueryResult = NonNullable<Awaited<ReturnType<typeof showOwnerFile>>>
export type ShowOwnerFileQueryError = ErrorType<void>


/**
 * @summary Show Owner File
 */

export function useShowOwnerFile<TData = Awaited<ReturnType<typeof showOwnerFile>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showOwnerFile>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowOwnerFileQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Create Board
 */
export const createPinboardBoard = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<PinboardBoard>(
      {url: `/api/pinboard/boards`, method: 'POST', signal
    },
      );
    }
  


export const getCreatePinboardBoardMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPinboardBoard>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPinboardBoard>>, TError,void, TContext> => {
    
const mutationKey = ['createPinboardBoard'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPinboardBoard>>, void> = () => {
          

          return  createPinboardBoard()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePinboardBoardMutationResult = NonNullable<Awaited<ReturnType<typeof createPinboardBoard>>>
    
    export type CreatePinboardBoardMutationError = ErrorType<void>

    /**
 * @summary Create Board
 */
export const useCreatePinboardBoard = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPinboardBoard>>, TError,void, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createPinboardBoard>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getCreatePinboardBoardMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Delete Board
 */
export const deletePinboardBoard = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/pinboard/boards/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeletePinboardBoardMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePinboardBoard>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePinboardBoard>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deletePinboardBoard'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePinboardBoard>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deletePinboardBoard(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePinboardBoardMutationResult = NonNullable<Awaited<ReturnType<typeof deletePinboardBoard>>>
    
    export type DeletePinboardBoardMutationError = ErrorType<void>

    /**
 * @summary Delete Board
 */
export const useDeletePinboardBoard = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePinboardBoard>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deletePinboardBoard>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeletePinboardBoardMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Board Details
 */
export const getPinboardBoard = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<PinboardBoard>(
      {url: `/api/pinboard/boards/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetPinboardBoardQueryKey = (id: MaybeRef<string>,) => {
    return ['api','pinboard','boards',id] as const;
    }

    
export const useGetPinboardBoardQueryOptions = <TData = Awaited<ReturnType<typeof getPinboardBoard>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPinboardBoard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetPinboardBoardQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPinboardBoard>>> = ({ signal }) => getPinboardBoard(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getPinboardBoard>>, TError, TData> 
}

export type GetPinboardBoardQueryResult = NonNullable<Awaited<ReturnType<typeof getPinboardBoard>>>
export type GetPinboardBoardQueryError = ErrorType<void>


/**
 * @summary Board Details
 */

export function useGetPinboardBoard<TData = Awaited<ReturnType<typeof getPinboardBoard>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPinboardBoard>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPinboardBoardQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update Board
 */
export const updatePinboardBoard = (
    id: MaybeRef<string>,
    updatePinboardBoardBody: MaybeRef<UpdatePinboardBoardBody>,
 ) => {
      id = unref(id);
updatePinboardBoardBody = unref(updatePinboardBoardBody);
      
      return axiosClient<PinboardBoard>(
      {url: `/api/pinboard/boards/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePinboardBoardBody
    },
      );
    }
  


export const getUpdatePinboardBoardMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePinboardBoard>>, TError,{id: string;data: UpdatePinboardBoardBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePinboardBoard>>, TError,{id: string;data: UpdatePinboardBoardBody}, TContext> => {
    
const mutationKey = ['updatePinboardBoard'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePinboardBoard>>, {id: string;data: UpdatePinboardBoardBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePinboardBoard(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePinboardBoardMutationResult = NonNullable<Awaited<ReturnType<typeof updatePinboardBoard>>>
    export type UpdatePinboardBoardMutationBody = UpdatePinboardBoardBody
    export type UpdatePinboardBoardMutationError = ErrorType<void>

    /**
 * @summary Update Board
 */
export const useUpdatePinboardBoard = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePinboardBoard>>, TError,{id: string;data: UpdatePinboardBoardBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updatePinboardBoard>>,
        TError,
        {id: string;data: UpdatePinboardBoardBody},
        TContext
      > => {

      const mutationOptions = getUpdatePinboardBoardMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create ProjectItem
 */
export const createProjectItem = (
    projectItemInput: MaybeRef<ProjectItemInput>,
 signal?: AbortSignal
) => {
      projectItemInput = unref(projectItemInput);
      
      return axiosClient<ProjectItem>(
      {url: `/api/project_items`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: projectItemInput, signal
    },
      );
    }
  


export const getCreateProjectItemMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectItem>>, TError,{data: ProjectItemInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createProjectItem>>, TError,{data: ProjectItemInput}, TContext> => {
    
const mutationKey = ['createProjectItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProjectItem>>, {data: ProjectItemInput}> = (props) => {
          const {data} = props ?? {};

          return  createProjectItem(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectItemMutationResult = NonNullable<Awaited<ReturnType<typeof createProjectItem>>>
    export type CreateProjectItemMutationBody = ProjectItemInput
    export type CreateProjectItemMutationError = ErrorType<void>

    /**
 * @summary Create ProjectItem
 */
export const useCreateProjectItem = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProjectItem>>, TError,{data: ProjectItemInput}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createProjectItem>>,
        TError,
        {data: ProjectItemInput},
        TContext
      > => {

      const mutationOptions = getCreateProjectItemMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List ProjectItems
 */
export const listProjectItems = (
    params?: MaybeRef<ListProjectItemsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedProjectItems>(
      {url: `/api/project_items`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListProjectItemsQueryKey = (params?: MaybeRef<ListProjectItemsParams>,) => {
    return ['api','project_items', ...(params ? [params]: [])] as const;
    }

    
export const useListProjectItemsQueryOptions = <TData = Awaited<ReturnType<typeof listProjectItems>>, TError = ErrorType<void>>(params?: MaybeRef<ListProjectItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectItems>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListProjectItemsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjectItems>>> = ({ signal }) => listProjectItems(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listProjectItems>>, TError, TData> 
}

export type ListProjectItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listProjectItems>>>
export type ListProjectItemsQueryError = ErrorType<void>


/**
 * @summary List ProjectItems
 */

export function useListProjectItems<TData = Awaited<ReturnType<typeof listProjectItems>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListProjectItemsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjectItems>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListProjectItemsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete ProjectItem
 */
export const deleteProjectItem = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/project_items/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteProjectItemMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectItem>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProjectItem>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteProjectItem'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProjectItem>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteProjectItem(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProjectItem>>>
    
    export type DeleteProjectItemMutationError = ErrorType<void>

    /**
 * @summary Delete ProjectItem
 */
export const useDeleteProjectItem = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProjectItem>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteProjectItem>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteProjectItemMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary ProjectItem Detail
 */
export const getProjectItem = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<ProjectItem>(
      {url: `/api/project_items/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetProjectItemQueryKey = (id: MaybeRef<string>,) => {
    return ['api','project_items',id] as const;
    }

    
export const useGetProjectItemQueryOptions = <TData = Awaited<ReturnType<typeof getProjectItem>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectItem>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetProjectItemQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectItem>>> = ({ signal }) => getProjectItem(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getProjectItem>>, TError, TData> 
}

export type GetProjectItemQueryResult = NonNullable<Awaited<ReturnType<typeof getProjectItem>>>
export type GetProjectItemQueryError = ErrorType<void>


/**
 * @summary ProjectItem Detail
 */

export function useGetProjectItem<TData = Awaited<ReturnType<typeof getProjectItem>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProjectItem>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetProjectItemQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List of Pupil Activities
 */
export const listPupilActivities = (
    params?: MaybeRef<ListPupilActivitiesParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedPupilActivities>(
      {url: `/api/pupil_activities`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListPupilActivitiesQueryKey = (params?: MaybeRef<ListPupilActivitiesParams>,) => {
    return ['api','pupil_activities', ...(params ? [params]: [])] as const;
    }

    
export const useListPupilActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof listPupilActivities>>, TError = ErrorType<void>>(params?: MaybeRef<ListPupilActivitiesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPupilActivities>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListPupilActivitiesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPupilActivities>>> = ({ signal }) => listPupilActivities(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listPupilActivities>>, TError, TData> 
}

export type ListPupilActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof listPupilActivities>>>
export type ListPupilActivitiesQueryError = ErrorType<void>


/**
 * @summary List of Pupil Activities
 */

export function useListPupilActivities<TData = Awaited<ReturnType<typeof listPupilActivities>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListPupilActivitiesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPupilActivities>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListPupilActivitiesQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Assignment Details
 */
export const getPupilFeedbackAssignment = (
    id: MaybeRef<string>,
    params?: MaybeRef<GetPupilFeedbackAssignmentParams>,
 signal?: AbortSignal
) => {
      id = unref(id);
params = unref(params);
      
      return axiosClient<PupilFeedbackAssignment>(
      {url: `/api/pupil_feedback/assignments/${id}`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getGetPupilFeedbackAssignmentQueryKey = (id: MaybeRef<string>,
    params?: MaybeRef<GetPupilFeedbackAssignmentParams>,) => {
    return ['api','pupil_feedback','assignments',id, ...(params ? [params]: [])] as const;
    }

    
export const useGetPupilFeedbackAssignmentQueryOptions = <TData = Awaited<ReturnType<typeof getPupilFeedbackAssignment>>, TError = ErrorType<void>>(id: MaybeRef<string>,
    params?: MaybeRef<GetPupilFeedbackAssignmentParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPupilFeedbackAssignment>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetPupilFeedbackAssignmentQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPupilFeedbackAssignment>>> = ({ signal }) => getPupilFeedbackAssignment(id,params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getPupilFeedbackAssignment>>, TError, TData> 
}

export type GetPupilFeedbackAssignmentQueryResult = NonNullable<Awaited<ReturnType<typeof getPupilFeedbackAssignment>>>
export type GetPupilFeedbackAssignmentQueryError = ErrorType<void>


/**
 * @summary Assignment Details
 */

export function useGetPupilFeedbackAssignment<TData = Awaited<ReturnType<typeof getPupilFeedbackAssignment>>, TError = ErrorType<void>>(
 id: MaybeRef<string>,
    params?: MaybeRef<GetPupilFeedbackAssignmentParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPupilFeedbackAssignment>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPupilFeedbackAssignmentQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update Assignment
 */
export const updatePupilFeedbackAssignment = (
    id: MaybeRef<string>,
    updatePupilFeedbackAssignmentBody: MaybeRef<UpdatePupilFeedbackAssignmentBody>,
 ) => {
      id = unref(id);
updatePupilFeedbackAssignmentBody = unref(updatePupilFeedbackAssignmentBody);
      
      return axiosClient<PupilFeedbackAssignment>(
      {url: `/api/pupil_feedback/assignments/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePupilFeedbackAssignmentBody
    },
      );
    }
  


export const getUpdatePupilFeedbackAssignmentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePupilFeedbackAssignment>>, TError,{id: string;data: UpdatePupilFeedbackAssignmentBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updatePupilFeedbackAssignment>>, TError,{id: string;data: UpdatePupilFeedbackAssignmentBody}, TContext> => {
    
const mutationKey = ['updatePupilFeedbackAssignment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePupilFeedbackAssignment>>, {id: string;data: UpdatePupilFeedbackAssignmentBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePupilFeedbackAssignment(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePupilFeedbackAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof updatePupilFeedbackAssignment>>>
    export type UpdatePupilFeedbackAssignmentMutationBody = UpdatePupilFeedbackAssignmentBody
    export type UpdatePupilFeedbackAssignmentMutationError = ErrorType<void>

    /**
 * @summary Update Assignment
 */
export const useUpdatePupilFeedbackAssignment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePupilFeedbackAssignment>>, TError,{id: string;data: UpdatePupilFeedbackAssignmentBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updatePupilFeedbackAssignment>>,
        TError,
        {id: string;data: UpdatePupilFeedbackAssignmentBody},
        TContext
      > => {

      const mutationOptions = getUpdatePupilFeedbackAssignmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create a Pupil Feedback Feedback
 */
export const createPupilFeedbackFeedback = (
    responseId: MaybeRef<string>,
    createPupilFeedbackFeedbackBody: MaybeRef<CreatePupilFeedbackFeedbackBody>,
 signal?: AbortSignal
) => {
      responseId = unref(responseId);
createPupilFeedbackFeedbackBody = unref(createPupilFeedbackFeedbackBody);
      
      return axiosClient<PupilFeedbackFeedback>(
      {url: `/api/pupil_feedback/responses/${responseId}/feedbacks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPupilFeedbackFeedbackBody, signal
    },
      );
    }
  


export const getCreatePupilFeedbackFeedbackMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPupilFeedbackFeedback>>, TError,{responseId: string;data: CreatePupilFeedbackFeedbackBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPupilFeedbackFeedback>>, TError,{responseId: string;data: CreatePupilFeedbackFeedbackBody}, TContext> => {
    
const mutationKey = ['createPupilFeedbackFeedback'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPupilFeedbackFeedback>>, {responseId: string;data: CreatePupilFeedbackFeedbackBody}> = (props) => {
          const {responseId,data} = props ?? {};

          return  createPupilFeedbackFeedback(responseId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePupilFeedbackFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof createPupilFeedbackFeedback>>>
    export type CreatePupilFeedbackFeedbackMutationBody = CreatePupilFeedbackFeedbackBody
    export type CreatePupilFeedbackFeedbackMutationError = ErrorType<unknown>

    /**
 * @summary Create a Pupil Feedback Feedback
 */
export const useCreatePupilFeedbackFeedback = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPupilFeedbackFeedback>>, TError,{responseId: string;data: CreatePupilFeedbackFeedbackBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createPupilFeedbackFeedback>>,
        TError,
        {responseId: string;data: CreatePupilFeedbackFeedbackBody},
        TContext
      > => {

      const mutationOptions = getCreatePupilFeedbackFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Finalize Feedback
 */
export const finalizePupilFeedbackFeedback = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<PupilFeedbackFeedback>(
      {url: `/api/pupil_feedback/feedbacks/${id}/finalize`, method: 'PATCH'
    },
      );
    }
  


export const getFinalizePupilFeedbackFeedbackMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finalizePupilFeedbackFeedback>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof finalizePupilFeedbackFeedback>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['finalizePupilFeedbackFeedback'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finalizePupilFeedbackFeedback>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  finalizePupilFeedbackFeedback(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FinalizePupilFeedbackFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof finalizePupilFeedbackFeedback>>>
    
    export type FinalizePupilFeedbackFeedbackMutationError = ErrorType<void>

    /**
 * @summary Finalize Feedback
 */
export const useFinalizePupilFeedbackFeedback = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finalizePupilFeedbackFeedback>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof finalizePupilFeedbackFeedback>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getFinalizePupilFeedbackFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create a Pupil Feedback Response
 */
export const createPupilFeedbackResponse = (
    assignmentId: MaybeRef<string>,
    createPupilFeedbackResponseBody: MaybeRef<CreatePupilFeedbackResponseBody>,
 signal?: AbortSignal
) => {
      assignmentId = unref(assignmentId);
createPupilFeedbackResponseBody = unref(createPupilFeedbackResponseBody);
      
      return axiosClient<PupilFeedbackResponse>(
      {url: `/api/pupil_feedback/assignments/${assignmentId}/responses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPupilFeedbackResponseBody, signal
    },
      );
    }
  


export const getCreatePupilFeedbackResponseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPupilFeedbackResponse>>, TError,{assignmentId: string;data: CreatePupilFeedbackResponseBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPupilFeedbackResponse>>, TError,{assignmentId: string;data: CreatePupilFeedbackResponseBody}, TContext> => {
    
const mutationKey = ['createPupilFeedbackResponse'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPupilFeedbackResponse>>, {assignmentId: string;data: CreatePupilFeedbackResponseBody}> = (props) => {
          const {assignmentId,data} = props ?? {};

          return  createPupilFeedbackResponse(assignmentId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePupilFeedbackResponseMutationResult = NonNullable<Awaited<ReturnType<typeof createPupilFeedbackResponse>>>
    export type CreatePupilFeedbackResponseMutationBody = CreatePupilFeedbackResponseBody
    export type CreatePupilFeedbackResponseMutationError = ErrorType<unknown>

    /**
 * @summary Create a Pupil Feedback Response
 */
export const useCreatePupilFeedbackResponse = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPupilFeedbackResponse>>, TError,{assignmentId: string;data: CreatePupilFeedbackResponseBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createPupilFeedbackResponse>>,
        TError,
        {assignmentId: string;data: CreatePupilFeedbackResponseBody},
        TContext
      > => {

      const mutationOptions = getCreatePupilFeedbackResponseMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Pupil Feedback Responses
 */
export const listPupilFeedbackResponses = (
    assignmentId: MaybeRef<string>,
    params?: MaybeRef<ListPupilFeedbackResponsesParams>,
 signal?: AbortSignal
) => {
      assignmentId = unref(assignmentId);
params = unref(params);
      
      return axiosClient<PupilFeedbackResponses>(
      {url: `/api/pupil_feedback/assignments/${assignmentId}/responses`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListPupilFeedbackResponsesQueryKey = (assignmentId: MaybeRef<string>,
    params?: MaybeRef<ListPupilFeedbackResponsesParams>,) => {
    return ['api','pupil_feedback','assignments',assignmentId,'responses', ...(params ? [params]: [])] as const;
    }

    
export const useListPupilFeedbackResponsesQueryOptions = <TData = Awaited<ReturnType<typeof listPupilFeedbackResponses>>, TError = ErrorType<void>>(assignmentId: MaybeRef<string>,
    params?: MaybeRef<ListPupilFeedbackResponsesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPupilFeedbackResponses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListPupilFeedbackResponsesQueryKey(assignmentId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPupilFeedbackResponses>>> = ({ signal }) => listPupilFeedbackResponses(assignmentId,params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listPupilFeedbackResponses>>, TError, TData> 
}

export type ListPupilFeedbackResponsesQueryResult = NonNullable<Awaited<ReturnType<typeof listPupilFeedbackResponses>>>
export type ListPupilFeedbackResponsesQueryError = ErrorType<void>


/**
 * @summary List of Pupil Feedback Responses
 */

export function useListPupilFeedbackResponses<TData = Awaited<ReturnType<typeof listPupilFeedbackResponses>>, TError = ErrorType<void>>(
 assignmentId: MaybeRef<string>,
    params?: MaybeRef<ListPupilFeedbackResponsesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPupilFeedbackResponses>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListPupilFeedbackResponsesQueryOptions(assignmentId,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete Response
 */
export const deletePupilFeedbackResponse = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/pupil_feedback/responses/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeletePupilFeedbackResponseMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePupilFeedbackResponse>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePupilFeedbackResponse>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deletePupilFeedbackResponse'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePupilFeedbackResponse>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deletePupilFeedbackResponse(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePupilFeedbackResponseMutationResult = NonNullable<Awaited<ReturnType<typeof deletePupilFeedbackResponse>>>
    
    export type DeletePupilFeedbackResponseMutationError = ErrorType<void>

    /**
 * @summary Delete Response
 */
export const useDeletePupilFeedbackResponse = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePupilFeedbackResponse>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deletePupilFeedbackResponse>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeletePupilFeedbackResponseMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get a Pupil Feedback Response
 */
export const getPupilFeedbackResponse = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<PupilFeedbackResponse>(
      {url: `/api/pupil_feedback/responses/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetPupilFeedbackResponseQueryKey = (id: MaybeRef<string>,) => {
    return ['api','pupil_feedback','responses',id] as const;
    }

    
export const useGetPupilFeedbackResponseQueryOptions = <TData = Awaited<ReturnType<typeof getPupilFeedbackResponse>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPupilFeedbackResponse>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetPupilFeedbackResponseQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPupilFeedbackResponse>>> = ({ signal }) => getPupilFeedbackResponse(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getPupilFeedbackResponse>>, TError, TData> 
}

export type GetPupilFeedbackResponseQueryResult = NonNullable<Awaited<ReturnType<typeof getPupilFeedbackResponse>>>
export type GetPupilFeedbackResponseQueryError = ErrorType<void>


/**
 * @summary Get a Pupil Feedback Response
 */

export function useGetPupilFeedbackResponse<TData = Awaited<ReturnType<typeof getPupilFeedbackResponse>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPupilFeedbackResponse>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPupilFeedbackResponseQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Create SchoolClass
 */
export const createSchoolClass = (
    createSchoolClassBody: MaybeRef<CreateSchoolClassBody>,
 signal?: AbortSignal
) => {
      createSchoolClassBody = unref(createSchoolClassBody);
      
      return axiosClient<SchoolClass>(
      {url: `/api/school_classes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSchoolClassBody, signal
    },
      );
    }
  


export const getCreateSchoolClassMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchoolClass>>, TError,{data: CreateSchoolClassBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSchoolClass>>, TError,{data: CreateSchoolClassBody}, TContext> => {
    
const mutationKey = ['createSchoolClass'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSchoolClass>>, {data: CreateSchoolClassBody}> = (props) => {
          const {data} = props ?? {};

          return  createSchoolClass(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSchoolClassMutationResult = NonNullable<Awaited<ReturnType<typeof createSchoolClass>>>
    export type CreateSchoolClassMutationBody = CreateSchoolClassBody
    export type CreateSchoolClassMutationError = ErrorType<void>

    /**
 * @summary Create SchoolClass
 */
export const useCreateSchoolClass = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSchoolClass>>, TError,{data: CreateSchoolClassBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createSchoolClass>>,
        TError,
        {data: CreateSchoolClassBody},
        TContext
      > => {

      const mutationOptions = getCreateSchoolClassMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of SchoolClasses
 */
export const listSchoolClasses = (
    params?: MaybeRef<ListSchoolClassesParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedSchoolClasses>(
      {url: `/api/school_classes`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListSchoolClassesQueryKey = (params?: MaybeRef<ListSchoolClassesParams>,) => {
    return ['api','school_classes', ...(params ? [params]: [])] as const;
    }

    
export const useListSchoolClassesQueryOptions = <TData = Awaited<ReturnType<typeof listSchoolClasses>>, TError = ErrorType<void>>(params?: MaybeRef<ListSchoolClassesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolClasses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListSchoolClassesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSchoolClasses>>> = ({ signal }) => listSchoolClasses(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listSchoolClasses>>, TError, TData> 
}

export type ListSchoolClassesQueryResult = NonNullable<Awaited<ReturnType<typeof listSchoolClasses>>>
export type ListSchoolClassesQueryError = ErrorType<void>


/**
 * @summary List of SchoolClasses
 */

export function useListSchoolClasses<TData = Awaited<ReturnType<typeof listSchoolClasses>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListSchoolClassesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSchoolClasses>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListSchoolClassesQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete SchoolClass
 */
export const deleteSchoolClass = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/school_classes/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteSchoolClassMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSchoolClass>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteSchoolClass>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteSchoolClass'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSchoolClass>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteSchoolClass(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSchoolClassMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSchoolClass>>>
    
    export type DeleteSchoolClassMutationError = ErrorType<void>

    /**
 * @summary Delete SchoolClass
 */
export const useDeleteSchoolClass = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSchoolClass>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteSchoolClass>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteSchoolClassMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary SchoolClass Details
 */
export const getSchoolClass = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<SchoolClass>(
      {url: `/api/school_classes/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetSchoolClassQueryKey = (id: MaybeRef<string>,) => {
    return ['api','school_classes',id] as const;
    }

    
export const useGetSchoolClassQueryOptions = <TData = Awaited<ReturnType<typeof getSchoolClass>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolClass>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetSchoolClassQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchoolClass>>> = ({ signal }) => getSchoolClass(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getSchoolClass>>, TError, TData> 
}

export type GetSchoolClassQueryResult = NonNullable<Awaited<ReturnType<typeof getSchoolClass>>>
export type GetSchoolClassQueryError = ErrorType<void>


/**
 * @summary SchoolClass Details
 */

export function useGetSchoolClass<TData = Awaited<ReturnType<typeof getSchoolClass>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchoolClass>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetSchoolClassQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update SchoolClass
 */
export const updateSchoolClass = (
    id: MaybeRef<string>,
    updateSchoolClassBody: MaybeRef<UpdateSchoolClassBody>,
 ) => {
      id = unref(id);
updateSchoolClassBody = unref(updateSchoolClassBody);
      
      return axiosClient<SchoolClass>(
      {url: `/api/school_classes/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateSchoolClassBody
    },
      );
    }
  


export const getUpdateSchoolClassMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchoolClass>>, TError,{id: string;data: UpdateSchoolClassBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateSchoolClass>>, TError,{id: string;data: UpdateSchoolClassBody}, TContext> => {
    
const mutationKey = ['updateSchoolClass'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSchoolClass>>, {id: string;data: UpdateSchoolClassBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSchoolClass(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSchoolClassMutationResult = NonNullable<Awaited<ReturnType<typeof updateSchoolClass>>>
    export type UpdateSchoolClassMutationBody = UpdateSchoolClassBody
    export type UpdateSchoolClassMutationError = ErrorType<void>

    /**
 * @summary Update SchoolClass
 */
export const useUpdateSchoolClass = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSchoolClass>>, TError,{id: string;data: UpdateSchoolClassBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateSchoolClass>>,
        TError,
        {id: string;data: UpdateSchoolClassBody},
        TContext
      > => {

      const mutationOptions = getUpdateSchoolClassMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create Project
 */
export const createProject = (
    id: MaybeRef<string>,
    createProjectBody: MaybeRef<CreateProjectBody>,
 signal?: AbortSignal
) => {
      id = unref(id);
createProjectBody = unref(createProjectBody);
      
      return axiosClient<Project>(
      {url: `/api/school_classes/${id}/projects`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createProjectBody, signal
    },
      );
    }
  


export const getCreateProjectMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,{id: string;data: CreateProjectBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,{id: string;data: CreateProjectBody}, TContext> => {
    
const mutationKey = ['createProject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProject>>, {id: string;data: CreateProjectBody}> = (props) => {
          const {id,data} = props ?? {};

          return  createProject(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof createProject>>>
    export type CreateProjectMutationBody = CreateProjectBody
    export type CreateProjectMutationError = ErrorType<void>

    /**
 * @summary Create Project
 */
export const useCreateProject = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProject>>, TError,{id: string;data: CreateProjectBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createProject>>,
        TError,
        {id: string;data: CreateProjectBody},
        TContext
      > => {

      const mutationOptions = getCreateProjectMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Projects
 */
export const listProjects = (
    id: MaybeRef<string>,
    params?: MaybeRef<ListProjectsParams>,
 signal?: AbortSignal
) => {
      id = unref(id);
params = unref(params);
      
      return axiosClient<PaginatedProjects>(
      {url: `/api/school_classes/${id}/projects`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListProjectsQueryKey = (id: MaybeRef<string>,
    params?: MaybeRef<ListProjectsParams>,) => {
    return ['api','school_classes',id,'projects', ...(params ? [params]: [])] as const;
    }

    
export const useListProjectsQueryOptions = <TData = Awaited<ReturnType<typeof listProjects>>, TError = ErrorType<void>>(id: MaybeRef<string>,
    params?: MaybeRef<ListProjectsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListProjectsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjects>>> = ({ signal }) => listProjects(id,params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData> 
}

export type ListProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof listProjects>>>
export type ListProjectsQueryError = ErrorType<void>


/**
 * @summary List of Projects
 */

export function useListProjects<TData = Awaited<ReturnType<typeof listProjects>>, TError = ErrorType<void>>(
 id: MaybeRef<string>,
    params?: MaybeRef<ListProjectsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProjects>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListProjectsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete Project
 */
export const deleteProject = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/projects/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteProjectMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteProject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProject>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteProject(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProjectMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProject>>>
    
    export type DeleteProjectMutationError = ErrorType<void>

    /**
 * @summary Delete Project
 */
export const useDeleteProject = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProject>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteProject>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteProjectMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Project Details
 */
export const getProject = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<Project>(
      {url: `/api/projects/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetProjectQueryKey = (id: MaybeRef<string>,) => {
    return ['api','projects',id] as const;
    }

    
export const useGetProjectQueryOptions = <TData = Awaited<ReturnType<typeof getProject>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetProjectQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProject>>> = ({ signal }) => getProject(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData> 
}

export type GetProjectQueryResult = NonNullable<Awaited<ReturnType<typeof getProject>>>
export type GetProjectQueryError = ErrorType<void>


/**
 * @summary Project Details
 */

export function useGetProject<TData = Awaited<ReturnType<typeof getProject>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProject>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetProjectQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update Project
 */
export const updateProject = (
    id: MaybeRef<string>,
    updateProjectBody: MaybeRef<UpdateProjectBody>,
 ) => {
      id = unref(id);
updateProjectBody = unref(updateProjectBody);
      
      return axiosClient<void>(
      {url: `/api/projects/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateProjectBody
    },
      );
    }
  


export const getUpdateProjectMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{id: string;data: UpdateProjectBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{id: string;data: UpdateProjectBody}, TContext> => {
    
const mutationKey = ['updateProject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProject>>, {id: string;data: UpdateProjectBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateProject(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof updateProject>>>
    export type UpdateProjectMutationBody = UpdateProjectBody
    export type UpdateProjectMutationError = ErrorType<void>

    /**
 * @summary Update Project
 */
export const useUpdateProject = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProject>>, TError,{id: string;data: UpdateProjectBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateProject>>,
        TError,
        {id: string;data: UpdateProjectBody},
        TContext
      > => {

      const mutationOptions = getUpdateProjectMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Finish Project
 */
export const finishProject = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/projects/${id}/finish`, method: 'PUT'
    },
      );
    }
  


export const getFinishProjectMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishProject>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof finishProject>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['finishProject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finishProject>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  finishProject(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FinishProjectMutationResult = NonNullable<Awaited<ReturnType<typeof finishProject>>>
    
    export type FinishProjectMutationError = ErrorType<void>

    /**
 * @summary Finish Project
 */
export const useFinishProject = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finishProject>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof finishProject>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getFinishProjectMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Pause Project
 */
export const pauseProject = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/projects/${id}/pause`, method: 'PUT'
    },
      );
    }
  


export const getPauseProjectMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pauseProject>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof pauseProject>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['pauseProject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pauseProject>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  pauseProject(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PauseProjectMutationResult = NonNullable<Awaited<ReturnType<typeof pauseProject>>>
    
    export type PauseProjectMutationError = ErrorType<void>

    /**
 * @summary Pause Project
 */
export const usePauseProject = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pauseProject>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof pauseProject>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPauseProjectMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Resume Project
 */
export const resumeProject = (
    id: MaybeRef<string>,
    resumeProjectBody: MaybeRef<ResumeProjectBody>,
 ) => {
      id = unref(id);
resumeProjectBody = unref(resumeProjectBody);
      
      return axiosClient<void>(
      {url: `/api/projects/${id}/resume`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: resumeProjectBody
    },
      );
    }
  


export const getResumeProjectMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeProject>>, TError,{id: string;data: ResumeProjectBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof resumeProject>>, TError,{id: string;data: ResumeProjectBody}, TContext> => {
    
const mutationKey = ['resumeProject'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resumeProject>>, {id: string;data: ResumeProjectBody}> = (props) => {
          const {id,data} = props ?? {};

          return  resumeProject(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResumeProjectMutationResult = NonNullable<Awaited<ReturnType<typeof resumeProject>>>
    export type ResumeProjectMutationBody = ResumeProjectBody
    export type ResumeProjectMutationError = ErrorType<void>

    /**
 * @summary Resume Project
 */
export const useResumeProject = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeProject>>, TError,{id: string;data: ResumeProjectBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof resumeProject>>,
        TError,
        {id: string;data: ResumeProjectBody},
        TContext
      > => {

      const mutationOptions = getResumeProjectMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create Pupil
 */
export const createPupil = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<Author>(
      {url: `/api/school_classes/${id}/pupils`, method: 'POST', signal
    },
      );
    }
  


export const getCreatePupilMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPupil>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPupil>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['createPupil'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPupil>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  createPupil(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePupilMutationResult = NonNullable<Awaited<ReturnType<typeof createPupil>>>
    
    export type CreatePupilMutationError = ErrorType<void>

    /**
 * @summary Create Pupil
 */
export const useCreatePupil = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPupil>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createPupil>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCreatePupilMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Pupils
 */
export const listPupils = (
    id: MaybeRef<string>,
    params?: MaybeRef<ListPupilsParams>,
 signal?: AbortSignal
) => {
      id = unref(id);
params = unref(params);
      
      return axiosClient<Author[]>(
      {url: `/api/school_classes/${id}/pupils`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListPupilsQueryKey = (id: MaybeRef<string>,
    params?: MaybeRef<ListPupilsParams>,) => {
    return ['api','school_classes',id,'pupils', ...(params ? [params]: [])] as const;
    }

    
export const useListPupilsQueryOptions = <TData = Awaited<ReturnType<typeof listPupils>>, TError = ErrorType<void>>(id: MaybeRef<string>,
    params?: MaybeRef<ListPupilsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPupils>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListPupilsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPupils>>> = ({ signal }) => listPupils(id,params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listPupils>>, TError, TData> 
}

export type ListPupilsQueryResult = NonNullable<Awaited<ReturnType<typeof listPupils>>>
export type ListPupilsQueryError = ErrorType<void>


/**
 * @summary List of Pupils
 */

export function useListPupils<TData = Awaited<ReturnType<typeof listPupils>>, TError = ErrorType<void>>(
 id: MaybeRef<string>,
    params?: MaybeRef<ListPupilsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPupils>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListPupilsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Deactivate Pupil
 */
export const deactivatePupil = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/pupils/${id}/deactivate`, method: 'PUT'
    },
      );
    }
  


export const getDeactivatePupilMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivatePupil>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deactivatePupil>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deactivatePupil'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivatePupil>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deactivatePupil(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeactivatePupilMutationResult = NonNullable<Awaited<ReturnType<typeof deactivatePupil>>>
    
    export type DeactivatePupilMutationError = ErrorType<void>

    /**
 * @summary Deactivate Pupil
 */
export const useDeactivatePupil = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivatePupil>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deactivatePupil>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeactivatePupilMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Delete Pupil
 */
export const deletePupil = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/pupils/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeletePupilMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePupil>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePupil>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deletePupil'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePupil>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deletePupil(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePupilMutationResult = NonNullable<Awaited<ReturnType<typeof deletePupil>>>
    
    export type DeletePupilMutationError = ErrorType<void>

    /**
 * @summary Delete Pupil
 */
export const useDeletePupil = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePupil>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deletePupil>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeletePupilMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Pupil Details
 */
export const getPupil = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<Author>(
      {url: `/api/pupils/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetPupilQueryKey = (id: MaybeRef<string>,) => {
    return ['api','pupils',id] as const;
    }

    
export const useGetPupilQueryOptions = <TData = Awaited<ReturnType<typeof getPupil>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPupil>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetPupilQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPupil>>> = ({ signal }) => getPupil(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getPupil>>, TError, TData> 
}

export type GetPupilQueryResult = NonNullable<Awaited<ReturnType<typeof getPupil>>>
export type GetPupilQueryError = ErrorType<void>


/**
 * @summary Pupil Details
 */

export function useGetPupil<TData = Awaited<ReturnType<typeof getPupil>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPupil>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPupilQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Reactivate Pupil
 */
export const reactivatePupil = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/pupils/${id}/reactivate`, method: 'PUT'
    },
      );
    }
  


export const getReactivatePupilMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivatePupil>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reactivatePupil>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['reactivatePupil'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reactivatePupil>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  reactivatePupil(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReactivatePupilMutationResult = NonNullable<Awaited<ReturnType<typeof reactivatePupil>>>
    
    export type ReactivatePupilMutationError = ErrorType<void>

    /**
 * @summary Reactivate Pupil
 */
export const useReactivatePupil = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivatePupil>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof reactivatePupil>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getReactivatePupilMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Regenerate Pupil Token
 */
export const regenerateTokenPupil = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/pupils/${id}/regenerate_token`, method: 'PUT'
    },
      );
    }
  


export const getRegenerateTokenPupilMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateTokenPupil>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof regenerateTokenPupil>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['regenerateTokenPupil'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateTokenPupil>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  regenerateTokenPupil(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegenerateTokenPupilMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateTokenPupil>>>
    
    export type RegenerateTokenPupilMutationError = ErrorType<void>

    /**
 * @summary Regenerate Pupil Token
 */
export const useRegenerateTokenPupil = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateTokenPupil>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof regenerateTokenPupil>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getRegenerateTokenPupilMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create File
 */
export const createScreenRecorderFile = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<ScreenRecorderFile>(
      {url: `/api/screen_recorder/files`, method: 'POST', signal
    },
      );
    }
  


export const getCreateScreenRecorderFileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScreenRecorderFile>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createScreenRecorderFile>>, TError,void, TContext> => {
    
const mutationKey = ['createScreenRecorderFile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createScreenRecorderFile>>, void> = () => {
          

          return  createScreenRecorderFile()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateScreenRecorderFileMutationResult = NonNullable<Awaited<ReturnType<typeof createScreenRecorderFile>>>
    
    export type CreateScreenRecorderFileMutationError = ErrorType<void>

    /**
 * @summary Create File
 */
export const useCreateScreenRecorderFile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createScreenRecorderFile>>, TError,void, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createScreenRecorderFile>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getCreateScreenRecorderFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Files
 */
export const listScreenRecorderFiles = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<PaginatedScreenRecorderFiles>(
      {url: `/api/screen_recorder/files`, method: 'GET', signal
    },
      );
    }
  

const getListScreenRecorderFilesQueryKey = () => {
    return ['api','screen_recorder','files'] as const;
    }

    
export const useListScreenRecorderFilesQueryOptions = <TData = Awaited<ReturnType<typeof listScreenRecorderFiles>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScreenRecorderFiles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListScreenRecorderFilesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listScreenRecorderFiles>>> = ({ signal }) => listScreenRecorderFiles(signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listScreenRecorderFiles>>, TError, TData> 
}

export type ListScreenRecorderFilesQueryResult = NonNullable<Awaited<ReturnType<typeof listScreenRecorderFiles>>>
export type ListScreenRecorderFilesQueryError = ErrorType<void>


/**
 * @summary List of Files
 */

export function useListScreenRecorderFiles<TData = Awaited<ReturnType<typeof listScreenRecorderFiles>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listScreenRecorderFiles>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListScreenRecorderFilesQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete File
 */
export const deleteScreenRecorderFile = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/screen_recorder/files/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteScreenRecorderFileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteScreenRecorderFile>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteScreenRecorderFile>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteScreenRecorderFile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteScreenRecorderFile>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteScreenRecorderFile(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteScreenRecorderFileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteScreenRecorderFile>>>
    
    export type DeleteScreenRecorderFileMutationError = ErrorType<void>

    /**
 * @summary Delete File
 */
export const useDeleteScreenRecorderFile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteScreenRecorderFile>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteScreenRecorderFile>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteScreenRecorderFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary File Details
 */
export const getScreenRecorderFile = (
    id: MaybeRef<string>,
    params?: MaybeRef<GetScreenRecorderFileParams>,
 signal?: AbortSignal
) => {
      id = unref(id);
params = unref(params);
      
      return axiosClient<ScreenRecorderFile>(
      {url: `/api/screen_recorder/files/${id}`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getGetScreenRecorderFileQueryKey = (id: MaybeRef<string>,
    params?: MaybeRef<GetScreenRecorderFileParams>,) => {
    return ['api','screen_recorder','files',id, ...(params ? [params]: [])] as const;
    }

    
export const useGetScreenRecorderFileQueryOptions = <TData = Awaited<ReturnType<typeof getScreenRecorderFile>>, TError = ErrorType<void>>(id: MaybeRef<string>,
    params?: MaybeRef<GetScreenRecorderFileParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScreenRecorderFile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetScreenRecorderFileQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScreenRecorderFile>>> = ({ signal }) => getScreenRecorderFile(id,params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getScreenRecorderFile>>, TError, TData> 
}

export type GetScreenRecorderFileQueryResult = NonNullable<Awaited<ReturnType<typeof getScreenRecorderFile>>>
export type GetScreenRecorderFileQueryError = ErrorType<void>


/**
 * @summary File Details
 */

export function useGetScreenRecorderFile<TData = Awaited<ReturnType<typeof getScreenRecorderFile>>, TError = ErrorType<void>>(
 id: MaybeRef<string>,
    params?: MaybeRef<GetScreenRecorderFileParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScreenRecorderFile>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetScreenRecorderFileQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update File
 */
export const updateScreenRecorderFile = (
    id: MaybeRef<string>,
    updateScreenRecorderFileBody: MaybeRef<UpdateScreenRecorderFileBody>,
 ) => {
      id = unref(id);
updateScreenRecorderFileBody = unref(updateScreenRecorderFileBody);
      
      return axiosClient<ScreenRecorderFile>(
      {url: `/api/screen_recorder/files/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateScreenRecorderFileBody
    },
      );
    }
  


export const getUpdateScreenRecorderFileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScreenRecorderFile>>, TError,{id: string;data: UpdateScreenRecorderFileBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateScreenRecorderFile>>, TError,{id: string;data: UpdateScreenRecorderFileBody}, TContext> => {
    
const mutationKey = ['updateScreenRecorderFile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateScreenRecorderFile>>, {id: string;data: UpdateScreenRecorderFileBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateScreenRecorderFile(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateScreenRecorderFileMutationResult = NonNullable<Awaited<ReturnType<typeof updateScreenRecorderFile>>>
    export type UpdateScreenRecorderFileMutationBody = UpdateScreenRecorderFileBody
    export type UpdateScreenRecorderFileMutationError = ErrorType<void>

    /**
 * @summary Update File
 */
export const useUpdateScreenRecorderFile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateScreenRecorderFile>>, TError,{id: string;data: UpdateScreenRecorderFileBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateScreenRecorderFile>>,
        TError,
        {id: string;data: UpdateScreenRecorderFileBody},
        TContext
      > => {

      const mutationOptions = getUpdateScreenRecorderFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Search
 */
export const search = (
    params?: MaybeRef<SearchParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<Search>(
      {url: `/api/searches`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getSearchQueryKey = (params?: MaybeRef<SearchParams>,) => {
    return ['api','searches', ...(params ? [params]: [])] as const;
    }

    
export const useSearchQueryOptions = <TData = Awaited<ReturnType<typeof search>>, TError = ErrorType<unknown>>(params?: MaybeRef<SearchParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof search>>> = ({ signal }) => search(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData> 
}

export type SearchQueryResult = NonNullable<Awaited<ReturnType<typeof search>>>
export type SearchQueryError = ErrorType<unknown>


/**
 * @summary Search
 */

export function useSearch<TData = Awaited<ReturnType<typeof search>>, TError = ErrorType<unknown>>(
 params?: MaybeRef<SearchParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useSearchQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Logout Session
 */
export const deleteSession = (
    
 ) => {
      
      
      return axiosClient<Message>(
      {url: `/api/sessions`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteSessionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSession>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteSession>>, TError,void, TContext> => {
    
const mutationKey = ['deleteSession'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSession>>, void> = () => {
          

          return  deleteSession()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSessionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSession>>>
    
    export type DeleteSessionMutationError = ErrorType<void>

    /**
 * @summary Logout Session
 */
export const useDeleteSession = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSession>>, TError,void, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteSession>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getDeleteSessionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary enter incognito mode
 */
export const enterIncognito = (
    toolsUserId: MaybeRef<string>,
 signal?: AbortSignal
) => {
      toolsUserId = unref(toolsUserId);
      
      return axiosClient<void>(
      {url: `/api/sessions/incognito/${toolsUserId}`, method: 'POST', signal
    },
      );
    }
  


export const getEnterIncognitoMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enterIncognito>>, TError,{toolsUserId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof enterIncognito>>, TError,{toolsUserId: string}, TContext> => {
    
const mutationKey = ['enterIncognito'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enterIncognito>>, {toolsUserId: string}> = (props) => {
          const {toolsUserId} = props ?? {};

          return  enterIncognito(toolsUserId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EnterIncognitoMutationResult = NonNullable<Awaited<ReturnType<typeof enterIncognito>>>
    
    export type EnterIncognitoMutationError = ErrorType<void>

    /**
 * @summary enter incognito mode
 */
export const useEnterIncognito = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enterIncognito>>, TError,{toolsUserId: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof enterIncognito>>,
        TError,
        {toolsUserId: string},
        TContext
      > => {

      const mutationOptions = getEnterIncognitoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Exit Incognito Mode
 */
export const exitIncognitoMode = (
    
 ) => {
      
      
      return axiosClient<void>(
      {url: `/api/sessions/incognito`, method: 'DELETE'
    },
      );
    }
  


export const getExitIncognitoModeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exitIncognitoMode>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exitIncognitoMode>>, TError,void, TContext> => {
    
const mutationKey = ['exitIncognitoMode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exitIncognitoMode>>, void> = () => {
          

          return  exitIncognitoMode()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExitIncognitoModeMutationResult = NonNullable<Awaited<ReturnType<typeof exitIncognitoMode>>>
    
    export type ExitIncognitoModeMutationError = ErrorType<void>

    /**
 * @summary Exit Incognito Mode
 */
export const useExitIncognitoMode = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exitIncognitoMode>>, TError,void, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof exitIncognitoMode>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getExitIncognitoModeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create Survey Question
 */
export const createSurveyQuestion = (
    surveyId: MaybeRef<string>,
    createSurveyQuestionBody: MaybeRef<CreateSurveyQuestionBody>,
 signal?: AbortSignal
) => {
      surveyId = unref(surveyId);
createSurveyQuestionBody = unref(createSurveyQuestionBody);
      
      return axiosClient<SurveyQuestion>(
      {url: `/api/surveys/surveys/${surveyId}/questions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSurveyQuestionBody, signal
    },
      );
    }
  


export const getCreateSurveyQuestionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSurveyQuestion>>, TError,{surveyId: string;data: CreateSurveyQuestionBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSurveyQuestion>>, TError,{surveyId: string;data: CreateSurveyQuestionBody}, TContext> => {
    
const mutationKey = ['createSurveyQuestion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSurveyQuestion>>, {surveyId: string;data: CreateSurveyQuestionBody}> = (props) => {
          const {surveyId,data} = props ?? {};

          return  createSurveyQuestion(surveyId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSurveyQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof createSurveyQuestion>>>
    export type CreateSurveyQuestionMutationBody = CreateSurveyQuestionBody
    export type CreateSurveyQuestionMutationError = ErrorType<void>

    /**
 * @summary Create Survey Question
 */
export const useCreateSurveyQuestion = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSurveyQuestion>>, TError,{surveyId: string;data: CreateSurveyQuestionBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createSurveyQuestion>>,
        TError,
        {surveyId: string;data: CreateSurveyQuestionBody},
        TContext
      > => {

      const mutationOptions = getCreateSurveyQuestionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Delete Survey Question
 */
export const deleteSurveyQuestion = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/surveys/questions/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteSurveyQuestionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSurveyQuestion>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteSurveyQuestion>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteSurveyQuestion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSurveyQuestion>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteSurveyQuestion(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSurveyQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSurveyQuestion>>>
    
    export type DeleteSurveyQuestionMutationError = ErrorType<void>

    /**
 * @summary Delete Survey Question
 */
export const useDeleteSurveyQuestion = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSurveyQuestion>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteSurveyQuestion>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteSurveyQuestionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Survey Question Details
 */
export const getSurveyQuestion = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<SurveyQuestion>(
      {url: `/api/surveys/questions/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetSurveyQuestionQueryKey = (id: MaybeRef<string>,) => {
    return ['api','surveys','questions',id] as const;
    }

    
export const useGetSurveyQuestionQueryOptions = <TData = Awaited<ReturnType<typeof getSurveyQuestion>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyQuestion>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetSurveyQuestionQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSurveyQuestion>>> = ({ signal }) => getSurveyQuestion(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getSurveyQuestion>>, TError, TData> 
}

export type GetSurveyQuestionQueryResult = NonNullable<Awaited<ReturnType<typeof getSurveyQuestion>>>
export type GetSurveyQuestionQueryError = ErrorType<void>


/**
 * @summary Survey Question Details
 */

export function useGetSurveyQuestion<TData = Awaited<ReturnType<typeof getSurveyQuestion>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyQuestion>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetSurveyQuestionQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update Survey Question
 */
export const updateSurveyQuestion = (
    id: MaybeRef<string>,
    updateSurveyQuestionBody: MaybeRef<UpdateSurveyQuestionBody>,
 ) => {
      id = unref(id);
updateSurveyQuestionBody = unref(updateSurveyQuestionBody);
      
      return axiosClient<SurveyQuestion>(
      {url: `/api/surveys/questions/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateSurveyQuestionBody
    },
      );
    }
  


export const getUpdateSurveyQuestionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSurveyQuestion>>, TError,{id: string;data: UpdateSurveyQuestionBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateSurveyQuestion>>, TError,{id: string;data: UpdateSurveyQuestionBody}, TContext> => {
    
const mutationKey = ['updateSurveyQuestion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSurveyQuestion>>, {id: string;data: UpdateSurveyQuestionBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSurveyQuestion(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSurveyQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof updateSurveyQuestion>>>
    export type UpdateSurveyQuestionMutationBody = UpdateSurveyQuestionBody
    export type UpdateSurveyQuestionMutationError = ErrorType<void>

    /**
 * @summary Update Survey Question
 */
export const useUpdateSurveyQuestion = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSurveyQuestion>>, TError,{id: string;data: UpdateSurveyQuestionBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateSurveyQuestion>>,
        TError,
        {id: string;data: UpdateSurveyQuestionBody},
        TContext
      > => {

      const mutationOptions = getUpdateSurveyQuestionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Move Survey Question
 */
export const moveSurveyQuestion = (
    id: MaybeRef<string>,
    moveSurveyQuestionBody: MaybeRef<MoveSurveyQuestionBody>,
 ) => {
      id = unref(id);
moveSurveyQuestionBody = unref(moveSurveyQuestionBody);
      
      return axiosClient<SurveyQuestion>(
      {url: `/api/surveys/questions/${id}/move`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: moveSurveyQuestionBody
    },
      );
    }
  


export const getMoveSurveyQuestionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveSurveyQuestion>>, TError,{id: string;data: MoveSurveyQuestionBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moveSurveyQuestion>>, TError,{id: string;data: MoveSurveyQuestionBody}, TContext> => {
    
const mutationKey = ['moveSurveyQuestion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveSurveyQuestion>>, {id: string;data: MoveSurveyQuestionBody}> = (props) => {
          const {id,data} = props ?? {};

          return  moveSurveyQuestion(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MoveSurveyQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof moveSurveyQuestion>>>
    export type MoveSurveyQuestionMutationBody = MoveSurveyQuestionBody
    export type MoveSurveyQuestionMutationError = ErrorType<void>

    /**
 * @summary Move Survey Question
 */
export const useMoveSurveyQuestion = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveSurveyQuestion>>, TError,{id: string;data: MoveSurveyQuestionBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof moveSurveyQuestion>>,
        TError,
        {id: string;data: MoveSurveyQuestionBody},
        TContext
      > => {

      const mutationOptions = getMoveSurveyQuestionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create Survey Response
 */
export const createSurveyResponse = (
    surveyId: MaybeRef<string>,
    createSurveyResponseBody: MaybeRef<CreateSurveyResponseBody>,
 signal?: AbortSignal
) => {
      surveyId = unref(surveyId);
createSurveyResponseBody = unref(createSurveyResponseBody);
      
      return axiosClient<SurveyResponse>(
      {url: `/api/surveys/surveys/${surveyId}/responses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSurveyResponseBody, signal
    },
      );
    }
  


export const getCreateSurveyResponseMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSurveyResponse>>, TError,{surveyId: string;data: CreateSurveyResponseBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSurveyResponse>>, TError,{surveyId: string;data: CreateSurveyResponseBody}, TContext> => {
    
const mutationKey = ['createSurveyResponse'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSurveyResponse>>, {surveyId: string;data: CreateSurveyResponseBody}> = (props) => {
          const {surveyId,data} = props ?? {};

          return  createSurveyResponse(surveyId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSurveyResponseMutationResult = NonNullable<Awaited<ReturnType<typeof createSurveyResponse>>>
    export type CreateSurveyResponseMutationBody = CreateSurveyResponseBody
    export type CreateSurveyResponseMutationError = ErrorType<void>

    /**
 * @summary Create Survey Response
 */
export const useCreateSurveyResponse = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSurveyResponse>>, TError,{surveyId: string;data: CreateSurveyResponseBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createSurveyResponse>>,
        TError,
        {surveyId: string;data: CreateSurveyResponseBody},
        TContext
      > => {

      const mutationOptions = getCreateSurveyResponseMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Survey Responses
 */
export const surveyResponses = (
    surveyId: MaybeRef<string>,
    params?: MaybeRef<SurveyResponsesParams>,
 signal?: AbortSignal
) => {
      surveyId = unref(surveyId);
params = unref(params);
      
      return axiosClient<PaginatedSurveyResponses>(
      {url: `/api/surveys/surveys/${surveyId}/responses`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getSurveyResponsesQueryKey = (surveyId: MaybeRef<string>,
    params?: MaybeRef<SurveyResponsesParams>,) => {
    return ['api','surveys','surveys',surveyId,'responses', ...(params ? [params]: [])] as const;
    }

    
export const useSurveyResponsesQueryOptions = <TData = Awaited<ReturnType<typeof surveyResponses>>, TError = ErrorType<void>>(surveyId: MaybeRef<string>,
    params?: MaybeRef<SurveyResponsesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveyResponses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSurveyResponsesQueryKey(surveyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof surveyResponses>>> = ({ signal }) => surveyResponses(surveyId,params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof surveyResponses>>, TError, TData> 
}

export type SurveyResponsesQueryResult = NonNullable<Awaited<ReturnType<typeof surveyResponses>>>
export type SurveyResponsesQueryError = ErrorType<void>


/**
 * @summary List of Survey Responses
 */

export function useSurveyResponses<TData = Awaited<ReturnType<typeof surveyResponses>>, TError = ErrorType<void>>(
 surveyId: MaybeRef<string>,
    params?: MaybeRef<SurveyResponsesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveyResponses>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useSurveyResponsesQueryOptions(surveyId,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Survey Response Details
 */
export const getSurveyResponse = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<SurveyResponse>(
      {url: `/api/surveys/responses/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetSurveyResponseQueryKey = (id: MaybeRef<string>,) => {
    return ['api','surveys','responses',id] as const;
    }

    
export const useGetSurveyResponseQueryOptions = <TData = Awaited<ReturnType<typeof getSurveyResponse>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyResponse>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetSurveyResponseQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSurveyResponse>>> = ({ signal }) => getSurveyResponse(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getSurveyResponse>>, TError, TData> 
}

export type GetSurveyResponseQueryResult = NonNullable<Awaited<ReturnType<typeof getSurveyResponse>>>
export type GetSurveyResponseQueryError = ErrorType<void>


/**
 * @summary Survey Response Details
 */

export function useGetSurveyResponse<TData = Awaited<ReturnType<typeof getSurveyResponse>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurveyResponse>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetSurveyResponseQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Survey Results
 */
export const surveyResults = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<SurveyResults>(
      {url: `/api/surveys/surveys/${id}/results`, method: 'GET', signal
    },
      );
    }
  

const getSurveyResultsQueryKey = (id: MaybeRef<string>,) => {
    return ['api','surveys','surveys',id,'results'] as const;
    }

    
export const useSurveyResultsQueryOptions = <TData = Awaited<ReturnType<typeof surveyResults>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveyResults>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSurveyResultsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof surveyResults>>> = ({ signal }) => surveyResults(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof surveyResults>>, TError, TData> 
}

export type SurveyResultsQueryResult = NonNullable<Awaited<ReturnType<typeof surveyResults>>>
export type SurveyResultsQueryError = ErrorType<void>


/**
 * @summary Survey Results
 */

export function useSurveyResults<TData = Awaited<ReturnType<typeof surveyResults>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof surveyResults>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useSurveyResultsQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Survey Details
 */
export const getSurvey = (
    id: MaybeRef<string>,
    params?: MaybeRef<GetSurveyParams>,
 signal?: AbortSignal
) => {
      id = unref(id);
params = unref(params);
      
      return axiosClient<Survey>(
      {url: `/api/surveys/surveys/${id}`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getGetSurveyQueryKey = (id: MaybeRef<string>,
    params?: MaybeRef<GetSurveyParams>,) => {
    return ['api','surveys','surveys',id, ...(params ? [params]: [])] as const;
    }

    
export const useGetSurveyQueryOptions = <TData = Awaited<ReturnType<typeof getSurvey>>, TError = ErrorType<void>>(id: MaybeRef<string>,
    params?: MaybeRef<GetSurveyParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetSurveyQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSurvey>>> = ({ signal }) => getSurvey(id,params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getSurvey>>, TError, TData> 
}

export type GetSurveyQueryResult = NonNullable<Awaited<ReturnType<typeof getSurvey>>>
export type GetSurveyQueryError = ErrorType<void>


/**
 * @summary Survey Details
 */

export function useGetSurvey<TData = Awaited<ReturnType<typeof getSurvey>>, TError = ErrorType<void>>(
 id: MaybeRef<string>,
    params?: MaybeRef<GetSurveyParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSurvey>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetSurveyQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update Survey
 */
export const updateSurvey = (
    id: MaybeRef<string>,
    updateSurveyBody: MaybeRef<UpdateSurveyBody>,
 ) => {
      id = unref(id);
updateSurveyBody = unref(updateSurveyBody);
      
      return axiosClient<Survey>(
      {url: `/api/surveys/surveys/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateSurveyBody
    },
      );
    }
  


export const getUpdateSurveyMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSurvey>>, TError,{id: string;data: UpdateSurveyBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateSurvey>>, TError,{id: string;data: UpdateSurveyBody}, TContext> => {
    
const mutationKey = ['updateSurvey'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSurvey>>, {id: string;data: UpdateSurveyBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSurvey(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSurveyMutationResult = NonNullable<Awaited<ReturnType<typeof updateSurvey>>>
    export type UpdateSurveyMutationBody = UpdateSurveyBody
    export type UpdateSurveyMutationError = ErrorType<void>

    /**
 * @summary Update Survey
 */
export const useUpdateSurvey = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSurvey>>, TError,{id: string;data: UpdateSurveyBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateSurvey>>,
        TError,
        {id: string;data: UpdateSurveyBody},
        TContext
      > => {

      const mutationOptions = getUpdateSurveyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create Template
 */
export const createTemplate = (
    params: MaybeRef<CreateTemplateParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<void>(
      {url: `/api/templates`, method: 'POST',
        params: unref(params), signal
    },
      );
    }
  


export const getCreateTemplateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTemplate>>, TError,{params: CreateTemplateParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createTemplate>>, TError,{params: CreateTemplateParams}, TContext> => {
    
const mutationKey = ['createTemplate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTemplate>>, {params: CreateTemplateParams}> = (props) => {
          const {params} = props ?? {};

          return  createTemplate(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof createTemplate>>>
    
    export type CreateTemplateMutationError = ErrorType<void>

    /**
 * @summary Create Template
 */
export const useCreateTemplate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTemplate>>, TError,{params: CreateTemplateParams}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createTemplate>>,
        TError,
        {params: CreateTemplateParams},
        TContext
      > => {

      const mutationOptions = getCreateTemplateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Templates
 */
export const listTemplates = (
    params: MaybeRef<ListTemplatesParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<Template[]>(
      {url: `/api/templates`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListTemplatesQueryKey = (params: MaybeRef<ListTemplatesParams>,) => {
    return ['api','templates', ...(params ? [params]: [])] as const;
    }

    
export const useListTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof listTemplates>>, TError = ErrorType<void>>(params: MaybeRef<ListTemplatesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListTemplatesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTemplates>>> = ({ signal }) => listTemplates(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData> 
}

export type ListTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listTemplates>>>
export type ListTemplatesQueryError = ErrorType<void>


/**
 * @summary List of Templates
 */

export function useListTemplates<TData = Awaited<ReturnType<typeof listTemplates>>, TError = ErrorType<void>>(
 params: MaybeRef<ListTemplatesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListTemplatesQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Create Document
 */
export const createTextEditorDocument = (
    createTextEditorDocumentBody: MaybeRef<CreateTextEditorDocumentBody>,
 signal?: AbortSignal
) => {
      createTextEditorDocumentBody = unref(createTextEditorDocumentBody);
      
      return axiosClient<TextEditorDocument>(
      {url: `/api/text_editor/documents`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTextEditorDocumentBody, signal
    },
      );
    }
  


export const getCreateTextEditorDocumentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTextEditorDocument>>, TError,{data: CreateTextEditorDocumentBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createTextEditorDocument>>, TError,{data: CreateTextEditorDocumentBody}, TContext> => {
    
const mutationKey = ['createTextEditorDocument'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTextEditorDocument>>, {data: CreateTextEditorDocumentBody}> = (props) => {
          const {data} = props ?? {};

          return  createTextEditorDocument(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateTextEditorDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof createTextEditorDocument>>>
    export type CreateTextEditorDocumentMutationBody = CreateTextEditorDocumentBody
    export type CreateTextEditorDocumentMutationError = ErrorType<void>

    /**
 * @summary Create Document
 */
export const useCreateTextEditorDocument = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTextEditorDocument>>, TError,{data: CreateTextEditorDocumentBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createTextEditorDocument>>,
        TError,
        {data: CreateTextEditorDocumentBody},
        TContext
      > => {

      const mutationOptions = getCreateTextEditorDocumentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Documents
 */
export const listTextEditorDocuments = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<PaginatedTextEditorDocuments>(
      {url: `/api/text_editor/documents`, method: 'GET', signal
    },
      );
    }
  

const getListTextEditorDocumentsQueryKey = () => {
    return ['api','text_editor','documents'] as const;
    }

    
export const useListTextEditorDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listTextEditorDocuments>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTextEditorDocuments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListTextEditorDocumentsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTextEditorDocuments>>> = ({ signal }) => listTextEditorDocuments(signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listTextEditorDocuments>>, TError, TData> 
}

export type ListTextEditorDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listTextEditorDocuments>>>
export type ListTextEditorDocumentsQueryError = ErrorType<void>


/**
 * @summary List of Documents
 */

export function useListTextEditorDocuments<TData = Awaited<ReturnType<typeof listTextEditorDocuments>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTextEditorDocuments>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListTextEditorDocumentsQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete Document
 */
export const deleteTextEditorDocument = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/text_editor/documents/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteTextEditorDocumentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTextEditorDocument>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteTextEditorDocument>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteTextEditorDocument'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTextEditorDocument>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteTextEditorDocument(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTextEditorDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTextEditorDocument>>>
    
    export type DeleteTextEditorDocumentMutationError = ErrorType<void>

    /**
 * @summary Delete Document
 */
export const useDeleteTextEditorDocument = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTextEditorDocument>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteTextEditorDocument>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteTextEditorDocumentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get Document
 */
export const getTestEditorDocument = (
    id: MaybeRef<string>,
    params?: MaybeRef<GetTestEditorDocumentParams>,
 signal?: AbortSignal
) => {
      id = unref(id);
params = unref(params);
      
      return axiosClient<TextEditorDocument>(
      {url: `/api/text_editor/documents/${id}`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getGetTestEditorDocumentQueryKey = (id: MaybeRef<string>,
    params?: MaybeRef<GetTestEditorDocumentParams>,) => {
    return ['api','text_editor','documents',id, ...(params ? [params]: [])] as const;
    }

    
export const useGetTestEditorDocumentQueryOptions = <TData = Awaited<ReturnType<typeof getTestEditorDocument>>, TError = ErrorType<void>>(id: MaybeRef<string>,
    params?: MaybeRef<GetTestEditorDocumentParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTestEditorDocument>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetTestEditorDocumentQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTestEditorDocument>>> = ({ signal }) => getTestEditorDocument(id,params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getTestEditorDocument>>, TError, TData> 
}

export type GetTestEditorDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof getTestEditorDocument>>>
export type GetTestEditorDocumentQueryError = ErrorType<void>


/**
 * @summary Get Document
 */

export function useGetTestEditorDocument<TData = Awaited<ReturnType<typeof getTestEditorDocument>>, TError = ErrorType<void>>(
 id: MaybeRef<string>,
    params?: MaybeRef<GetTestEditorDocumentParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTestEditorDocument>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetTestEditorDocumentQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update Document
 */
export const updateTextEditorDocument = (
    id: MaybeRef<string>,
    updateTextEditorDocumentBody: MaybeRef<UpdateTextEditorDocumentBody>,
 ) => {
      id = unref(id);
updateTextEditorDocumentBody = unref(updateTextEditorDocumentBody);
      
      return axiosClient<TextEditorDocument>(
      {url: `/api/text_editor/documents/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateTextEditorDocumentBody
    },
      );
    }
  


export const getUpdateTextEditorDocumentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTextEditorDocument>>, TError,{id: string;data: UpdateTextEditorDocumentBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateTextEditorDocument>>, TError,{id: string;data: UpdateTextEditorDocumentBody}, TContext> => {
    
const mutationKey = ['updateTextEditorDocument'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTextEditorDocument>>, {id: string;data: UpdateTextEditorDocumentBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTextEditorDocument(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateTextEditorDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof updateTextEditorDocument>>>
    export type UpdateTextEditorDocumentMutationBody = UpdateTextEditorDocumentBody
    export type UpdateTextEditorDocumentMutationError = ErrorType<void>

    /**
 * @summary Update Document
 */
export const useUpdateTextEditorDocument = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTextEditorDocument>>, TError,{id: string;data: UpdateTextEditorDocumentBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateTextEditorDocument>>,
        TError,
        {id: string;data: UpdateTextEditorDocumentBody},
        TContext
      > => {

      const mutationOptions = getUpdateTextEditorDocumentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Worksheets
 */
export const listToTeachWorksheets = (
    params?: MaybeRef<ListToTeachWorksheetsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedToTeachWorksheets>(
      {url: `/api/to_teach/worksheets`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListToTeachWorksheetsQueryKey = (params?: MaybeRef<ListToTeachWorksheetsParams>,) => {
    return ['api','to_teach','worksheets', ...(params ? [params]: [])] as const;
    }

    
export const useListToTeachWorksheetsQueryOptions = <TData = Awaited<ReturnType<typeof listToTeachWorksheets>>, TError = ErrorType<unknown>>(params?: MaybeRef<ListToTeachWorksheetsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listToTeachWorksheets>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListToTeachWorksheetsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listToTeachWorksheets>>> = ({ signal }) => listToTeachWorksheets(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listToTeachWorksheets>>, TError, TData> 
}

export type ListToTeachWorksheetsQueryResult = NonNullable<Awaited<ReturnType<typeof listToTeachWorksheets>>>
export type ListToTeachWorksheetsQueryError = ErrorType<unknown>


/**
 * @summary List of Worksheets
 */

export function useListToTeachWorksheets<TData = Awaited<ReturnType<typeof listToTeachWorksheets>>, TError = ErrorType<unknown>>(
 params?: MaybeRef<ListToTeachWorksheetsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listToTeachWorksheets>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListToTeachWorksheetsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary All User Limits
 */
export const allLimits = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<UserLimits>(
      {url: `/api/user_limits/all`, method: 'GET', signal
    },
      );
    }
  

const getAllLimitsQueryKey = () => {
    return ['api','user_limits','all'] as const;
    }

    
export const useAllLimitsQueryOptions = <TData = Awaited<ReturnType<typeof allLimits>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allLimits>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getAllLimitsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof allLimits>>> = ({ signal }) => allLimits(signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof allLimits>>, TError, TData> 
}

export type AllLimitsQueryResult = NonNullable<Awaited<ReturnType<typeof allLimits>>>
export type AllLimitsQueryError = ErrorType<void>


/**
 * @summary All User Limits
 */

export function useAllLimits<TData = Awaited<ReturnType<typeof allLimits>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allLimits>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useAllLimitsQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary List of Users Limits
 */
export const limits = (
    params: MaybeRef<LimitsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<UserLimit>(
      {url: `/api/user_limits`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getLimitsQueryKey = (params: MaybeRef<LimitsParams>,) => {
    return ['api','user_limits', ...(params ? [params]: [])] as const;
    }

    
export const useLimitsQueryOptions = <TData = Awaited<ReturnType<typeof limits>>, TError = ErrorType<void>>(params: MaybeRef<LimitsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof limits>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getLimitsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof limits>>> = ({ signal }) => limits(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof limits>>, TError, TData> 
}

export type LimitsQueryResult = NonNullable<Awaited<ReturnType<typeof limits>>>
export type LimitsQueryError = ErrorType<void>


/**
 * @summary List of Users Limits
 */

export function useLimits<TData = Awaited<ReturnType<typeof limits>>, TError = ErrorType<void>>(
 params: MaybeRef<LimitsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof limits>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useLimitsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Create UserPdf
 */
export const createUserPdf = (
    createUserPdfBody: MaybeRef<CreateUserPdfBody>,
 signal?: AbortSignal
) => {
      createUserPdfBody = unref(createUserPdfBody);
      
      return axiosClient<UserPdf>(
      {url: `/api/user_pdfs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserPdfBody, signal
    },
      );
    }
  


export const getCreateUserPdfMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserPdf>>, TError,{data: CreateUserPdfBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createUserPdf>>, TError,{data: CreateUserPdfBody}, TContext> => {
    
const mutationKey = ['createUserPdf'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserPdf>>, {data: CreateUserPdfBody}> = (props) => {
          const {data} = props ?? {};

          return  createUserPdf(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateUserPdfMutationResult = NonNullable<Awaited<ReturnType<typeof createUserPdf>>>
    export type CreateUserPdfMutationBody = CreateUserPdfBody
    export type CreateUserPdfMutationError = ErrorType<void>

    /**
 * @summary Create UserPdf
 */
export const useCreateUserPdf = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserPdf>>, TError,{data: CreateUserPdfBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createUserPdf>>,
        TError,
        {data: CreateUserPdfBody},
        TContext
      > => {

      const mutationOptions = getCreateUserPdfMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Partner Tools Users
 */
export const listApprovedToolsUsers = (
    params?: MaybeRef<ListApprovedToolsUsersParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<ToolsUser[]>(
      {url: `/api/tools-users/approved`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListApprovedToolsUsersQueryKey = (params?: MaybeRef<ListApprovedToolsUsersParams>,) => {
    return ['api','tools-users','approved', ...(params ? [params]: [])] as const;
    }

    
export const useListApprovedToolsUsersQueryOptions = <TData = Awaited<ReturnType<typeof listApprovedToolsUsers>>, TError = ErrorType<unknown>>(params?: MaybeRef<ListApprovedToolsUsersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApprovedToolsUsers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListApprovedToolsUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listApprovedToolsUsers>>> = ({ signal }) => listApprovedToolsUsers(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listApprovedToolsUsers>>, TError, TData> 
}

export type ListApprovedToolsUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listApprovedToolsUsers>>>
export type ListApprovedToolsUsersQueryError = ErrorType<unknown>


/**
 * @summary List of Partner Tools Users
 */

export function useListApprovedToolsUsers<TData = Awaited<ReturnType<typeof listApprovedToolsUsers>>, TError = ErrorType<unknown>>(
 params?: MaybeRef<ListApprovedToolsUsersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listApprovedToolsUsers>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListApprovedToolsUsersQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Current Tools User Details
 */
export const getCurrentToolsUser = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<ToolsUser>(
      {url: `/api/tools-users/current`, method: 'GET', signal
    },
      );
    }
  

const getGetCurrentToolsUserQueryKey = () => {
    return ['api','tools-users','current'] as const;
    }

    
export const useGetCurrentToolsUserQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentToolsUser>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentToolsUser>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCurrentToolsUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentToolsUser>>> = ({ signal }) => getCurrentToolsUser(signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getCurrentToolsUser>>, TError, TData> 
}

export type GetCurrentToolsUserQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentToolsUser>>>
export type GetCurrentToolsUserQueryError = ErrorType<unknown>


/**
 * @summary Current Tools User Details
 */

export function useGetCurrentToolsUser<TData = Awaited<ReturnType<typeof getCurrentToolsUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentToolsUser>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetCurrentToolsUserQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update Tools User
 */
export const updateToolsUser = (
    userId: MaybeRef<string>,
    updateToolsUserBody: MaybeRef<UpdateToolsUserBody>,
 ) => {
      userId = unref(userId);
updateToolsUserBody = unref(updateToolsUserBody);
      
      return axiosClient<ToolsUser>(
      {url: `/api/tools-users/${userId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateToolsUserBody
    },
      );
    }
  


export const getUpdateToolsUserMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateToolsUser>>, TError,{userId: string;data: UpdateToolsUserBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateToolsUser>>, TError,{userId: string;data: UpdateToolsUserBody}, TContext> => {
    
const mutationKey = ['updateToolsUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateToolsUser>>, {userId: string;data: UpdateToolsUserBody}> = (props) => {
          const {userId,data} = props ?? {};

          return  updateToolsUser(userId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateToolsUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateToolsUser>>>
    export type UpdateToolsUserMutationBody = UpdateToolsUserBody
    export type UpdateToolsUserMutationError = ErrorType<void>

    /**
 * @summary Update Tools User
 */
export const useUpdateToolsUser = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateToolsUser>>, TError,{userId: string;data: UpdateToolsUserBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateToolsUser>>,
        TError,
        {userId: string;data: UpdateToolsUserBody},
        TContext
      > => {

      const mutationOptions = getUpdateToolsUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create File
 */
export const createVideoRecorderFile = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<VideoRecorderFile>(
      {url: `/api/video_recorder/files`, method: 'POST', signal
    },
      );
    }
  


export const getCreateVideoRecorderFileMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVideoRecorderFile>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createVideoRecorderFile>>, TError,void, TContext> => {
    
const mutationKey = ['createVideoRecorderFile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVideoRecorderFile>>, void> = () => {
          

          return  createVideoRecorderFile()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateVideoRecorderFileMutationResult = NonNullable<Awaited<ReturnType<typeof createVideoRecorderFile>>>
    
    export type CreateVideoRecorderFileMutationError = ErrorType<void>

    /**
 * @summary Create File
 */
export const useCreateVideoRecorderFile = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVideoRecorderFile>>, TError,void, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createVideoRecorderFile>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getCreateVideoRecorderFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Files
 */
export const listVideoRecorderFiles = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<PaginatedVideoRecorderFiles>(
      {url: `/api/video_recorder/files`, method: 'GET', signal
    },
      );
    }
  

const getListVideoRecorderFilesQueryKey = () => {
    return ['api','video_recorder','files'] as const;
    }

    
export const useListVideoRecorderFilesQueryOptions = <TData = Awaited<ReturnType<typeof listVideoRecorderFiles>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVideoRecorderFiles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListVideoRecorderFilesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVideoRecorderFiles>>> = ({ signal }) => listVideoRecorderFiles(signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listVideoRecorderFiles>>, TError, TData> 
}

export type ListVideoRecorderFilesQueryResult = NonNullable<Awaited<ReturnType<typeof listVideoRecorderFiles>>>
export type ListVideoRecorderFilesQueryError = ErrorType<void>


/**
 * @summary List of Files
 */

export function useListVideoRecorderFiles<TData = Awaited<ReturnType<typeof listVideoRecorderFiles>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVideoRecorderFiles>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListVideoRecorderFilesQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary create visitor
 */
export const createVisitor = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<void>(
      {url: `/api/visitor`, method: 'POST', signal
    },
      );
    }
  


export const getCreateVisitorMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVisitor>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createVisitor>>, TError,void, TContext> => {
    
const mutationKey = ['createVisitor'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVisitor>>, void> = () => {
          

          return  createVisitor()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateVisitorMutationResult = NonNullable<Awaited<ReturnType<typeof createVisitor>>>
    
    export type CreateVisitorMutationError = ErrorType<unknown>

    /**
 * @summary create visitor
 */
export const useCreateVisitor = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVisitor>>, TError,void, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createVisitor>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getCreateVisitorMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create Page
 */
export const createWebsitePage = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<WebsitePage>(
      {url: `/api/website/pages`, method: 'POST', signal
    },
      );
    }
  


export const getCreateWebsitePageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWebsitePage>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createWebsitePage>>, TError,void, TContext> => {
    
const mutationKey = ['createWebsitePage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWebsitePage>>, void> = () => {
          

          return  createWebsitePage()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateWebsitePageMutationResult = NonNullable<Awaited<ReturnType<typeof createWebsitePage>>>
    
    export type CreateWebsitePageMutationError = ErrorType<void>

    /**
 * @summary Create Page
 */
export const useCreateWebsitePage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWebsitePage>>, TError,void, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createWebsitePage>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getCreateWebsitePageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Pages
 */
export const listWebsitePages = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<PaginatedWebsitePages>(
      {url: `/api/website/pages`, method: 'GET', signal
    },
      );
    }
  

const getListWebsitePagesQueryKey = () => {
    return ['api','website','pages'] as const;
    }

    
export const useListWebsitePagesQueryOptions = <TData = Awaited<ReturnType<typeof listWebsitePages>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWebsitePages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListWebsitePagesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWebsitePages>>> = ({ signal }) => listWebsitePages(signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listWebsitePages>>, TError, TData> 
}

export type ListWebsitePagesQueryResult = NonNullable<Awaited<ReturnType<typeof listWebsitePages>>>
export type ListWebsitePagesQueryError = ErrorType<void>


/**
 * @summary List of Pages
 */

export function useListWebsitePages<TData = Awaited<ReturnType<typeof listWebsitePages>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWebsitePages>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListWebsitePagesQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete Page
 */
export const deleteWebsitePage = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/website/pages/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteWebsitePageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWebsitePage>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteWebsitePage>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteWebsitePage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWebsitePage>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteWebsitePage(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteWebsitePageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWebsitePage>>>
    
    export type DeleteWebsitePageMutationError = ErrorType<void>

    /**
 * @summary Delete Page
 */
export const useDeleteWebsitePage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWebsitePage>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteWebsitePage>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteWebsitePageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Page Details
 */
export const getWebsitePage = (
    id: MaybeRef<string>,
    params?: MaybeRef<GetWebsitePageParams>,
 signal?: AbortSignal
) => {
      id = unref(id);
params = unref(params);
      
      return axiosClient<WebsitePage>(
      {url: `/api/website/pages/${id}`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getGetWebsitePageQueryKey = (id: MaybeRef<string>,
    params?: MaybeRef<GetWebsitePageParams>,) => {
    return ['api','website','pages',id, ...(params ? [params]: [])] as const;
    }

    
export const useGetWebsitePageQueryOptions = <TData = Awaited<ReturnType<typeof getWebsitePage>>, TError = ErrorType<void>>(id: MaybeRef<string>,
    params?: MaybeRef<GetWebsitePageParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebsitePage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetWebsitePageQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebsitePage>>> = ({ signal }) => getWebsitePage(id,params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getWebsitePage>>, TError, TData> 
}

export type GetWebsitePageQueryResult = NonNullable<Awaited<ReturnType<typeof getWebsitePage>>>
export type GetWebsitePageQueryError = ErrorType<void>


/**
 * @summary Page Details
 */

export function useGetWebsitePage<TData = Awaited<ReturnType<typeof getWebsitePage>>, TError = ErrorType<void>>(
 id: MaybeRef<string>,
    params?: MaybeRef<GetWebsitePageParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebsitePage>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetWebsitePageQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update Page
 */
export const updateWebsitePage = (
    id: MaybeRef<string>,
    updateWebsitePageBody: MaybeRef<UpdateWebsitePageBody>,
 ) => {
      id = unref(id);
updateWebsitePageBody = unref(updateWebsitePageBody);
      
      return axiosClient<WebsitePage>(
      {url: `/api/website/pages/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateWebsitePageBody
    },
      );
    }
  


export const getUpdateWebsitePageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWebsitePage>>, TError,{id: string;data: UpdateWebsitePageBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateWebsitePage>>, TError,{id: string;data: UpdateWebsitePageBody}, TContext> => {
    
const mutationKey = ['updateWebsitePage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWebsitePage>>, {id: string;data: UpdateWebsitePageBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateWebsitePage(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWebsitePageMutationResult = NonNullable<Awaited<ReturnType<typeof updateWebsitePage>>>
    export type UpdateWebsitePageMutationBody = UpdateWebsitePageBody
    export type UpdateWebsitePageMutationError = ErrorType<void>

    /**
 * @summary Update Page
 */
export const useUpdateWebsitePage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWebsitePage>>, TError,{id: string;data: UpdateWebsitePageBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateWebsitePage>>,
        TError,
        {id: string;data: UpdateWebsitePageBody},
        TContext
      > => {

      const mutationOptions = getUpdateWebsitePageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Add Word to WordCloud
 */
export const addWordCloudWord = (
    id: MaybeRef<string>,
    addWordCloudWordBody: MaybeRef<AddWordCloudWordBody>,
 ) => {
      id = unref(id);
addWordCloudWordBody = unref(addWordCloudWordBody);
      
      return axiosClient<WordCloud>(
      {url: `/api/word_clouds/word_clouds/${id}/add_word`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: addWordCloudWordBody
    },
      );
    }
  


export const getAddWordCloudWordMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addWordCloudWord>>, TError,{id: string;data: AddWordCloudWordBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addWordCloudWord>>, TError,{id: string;data: AddWordCloudWordBody}, TContext> => {
    
const mutationKey = ['addWordCloudWord'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addWordCloudWord>>, {id: string;data: AddWordCloudWordBody}> = (props) => {
          const {id,data} = props ?? {};

          return  addWordCloudWord(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddWordCloudWordMutationResult = NonNullable<Awaited<ReturnType<typeof addWordCloudWord>>>
    export type AddWordCloudWordMutationBody = AddWordCloudWordBody
    export type AddWordCloudWordMutationError = ErrorType<void>

    /**
 * @summary Add Word to WordCloud
 */
export const useAddWordCloudWord = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addWordCloudWord>>, TError,{id: string;data: AddWordCloudWordBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof addWordCloudWord>>,
        TError,
        {id: string;data: AddWordCloudWordBody},
        TContext
      > => {

      const mutationOptions = getAddWordCloudWordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create WordCloud
 */
export const createWordCloud = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosClient<WordCloud>(
      {url: `/api/word_clouds/word_clouds`, method: 'POST', signal
    },
      );
    }
  


export const getCreateWordCloudMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWordCloud>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createWordCloud>>, TError,void, TContext> => {
    
const mutationKey = ['createWordCloud'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWordCloud>>, void> = () => {
          

          return  createWordCloud()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateWordCloudMutationResult = NonNullable<Awaited<ReturnType<typeof createWordCloud>>>
    
    export type CreateWordCloudMutationError = ErrorType<void>

    /**
 * @summary Create WordCloud
 */
export const useCreateWordCloud = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWordCloud>>, TError,void, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createWordCloud>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getCreateWordCloudMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of WordClouds
 */
export const listWordClouds = (
    params?: MaybeRef<ListWordCloudsParams>,
 signal?: AbortSignal
) => {
      params = unref(params);
      
      return axiosClient<PaginatedWordClouds>(
      {url: `/api/word_clouds/word_clouds`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListWordCloudsQueryKey = (params?: MaybeRef<ListWordCloudsParams>,) => {
    return ['api','word_clouds','word_clouds', ...(params ? [params]: [])] as const;
    }

    
export const useListWordCloudsQueryOptions = <TData = Awaited<ReturnType<typeof listWordClouds>>, TError = ErrorType<void>>(params?: MaybeRef<ListWordCloudsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWordClouds>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListWordCloudsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWordClouds>>> = ({ signal }) => listWordClouds(params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listWordClouds>>, TError, TData> 
}

export type ListWordCloudsQueryResult = NonNullable<Awaited<ReturnType<typeof listWordClouds>>>
export type ListWordCloudsQueryError = ErrorType<void>


/**
 * @summary List of WordClouds
 */

export function useListWordClouds<TData = Awaited<ReturnType<typeof listWordClouds>>, TError = ErrorType<void>>(
 params?: MaybeRef<ListWordCloudsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWordClouds>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListWordCloudsQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete WordCloud
 */
export const deleteWordCloud = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/word_clouds/word_clouds/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteWordCloudMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWordCloud>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteWordCloud>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteWordCloud'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWordCloud>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteWordCloud(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteWordCloudMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWordCloud>>>
    
    export type DeleteWordCloudMutationError = ErrorType<void>

    /**
 * @summary Delete WordCloud
 */
export const useDeleteWordCloud = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWordCloud>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteWordCloud>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteWordCloudMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary WordCloud Details
 */
export const getWordCloud = (
    id: MaybeRef<string>,
    params?: MaybeRef<GetWordCloudParams>,
 signal?: AbortSignal
) => {
      id = unref(id);
params = unref(params);
      
      return axiosClient<WordCloud>(
      {url: `/api/word_clouds/word_clouds/${id}`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getGetWordCloudQueryKey = (id: MaybeRef<string>,
    params?: MaybeRef<GetWordCloudParams>,) => {
    return ['api','word_clouds','word_clouds',id, ...(params ? [params]: [])] as const;
    }

    
export const useGetWordCloudQueryOptions = <TData = Awaited<ReturnType<typeof getWordCloud>>, TError = ErrorType<void>>(id: MaybeRef<string>,
    params?: MaybeRef<GetWordCloudParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWordCloud>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetWordCloudQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWordCloud>>> = ({ signal }) => getWordCloud(id,params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getWordCloud>>, TError, TData> 
}

export type GetWordCloudQueryResult = NonNullable<Awaited<ReturnType<typeof getWordCloud>>>
export type GetWordCloudQueryError = ErrorType<void>


/**
 * @summary WordCloud Details
 */

export function useGetWordCloud<TData = Awaited<ReturnType<typeof getWordCloud>>, TError = ErrorType<void>>(
 id: MaybeRef<string>,
    params?: MaybeRef<GetWordCloudParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWordCloud>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetWordCloudQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update WordCloud
 */
export const updateWordCloud = (
    id: MaybeRef<string>,
    updateWordCloudBody: MaybeRef<UpdateWordCloudBody>,
 ) => {
      id = unref(id);
updateWordCloudBody = unref(updateWordCloudBody);
      
      return axiosClient<WordCloud>(
      {url: `/api/word_clouds/word_clouds/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateWordCloudBody
    },
      );
    }
  


export const getUpdateWordCloudMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWordCloud>>, TError,{id: string;data: UpdateWordCloudBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateWordCloud>>, TError,{id: string;data: UpdateWordCloudBody}, TContext> => {
    
const mutationKey = ['updateWordCloud'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWordCloud>>, {id: string;data: UpdateWordCloudBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateWordCloud(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWordCloudMutationResult = NonNullable<Awaited<ReturnType<typeof updateWordCloud>>>
    export type UpdateWordCloudMutationBody = UpdateWordCloudBody
    export type UpdateWordCloudMutationError = ErrorType<void>

    /**
 * @summary Update WordCloud
 */
export const useUpdateWordCloud = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWordCloud>>, TError,{id: string;data: UpdateWordCloudBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateWordCloud>>,
        TError,
        {id: string;data: UpdateWordCloudBody},
        TContext
      > => {

      const mutationOptions = getUpdateWordCloudMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create Answer Option
 */
export const createAnswerOption = (
    blockId: MaybeRef<string>,
    createAnswerOptionBody: MaybeRef<CreateAnswerOptionBody>,
 signal?: AbortSignal
) => {
      blockId = unref(blockId);
createAnswerOptionBody = unref(createAnswerOptionBody);
      
      return axiosClient<WorksheetAnswerOption>(
      {url: `/api/worksheet/blocks/${blockId}/answer_options`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAnswerOptionBody, signal
    },
      );
    }
  


export const getCreateAnswerOptionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnswerOption>>, TError,{blockId: string;data: CreateAnswerOptionBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAnswerOption>>, TError,{blockId: string;data: CreateAnswerOptionBody}, TContext> => {
    
const mutationKey = ['createAnswerOption'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAnswerOption>>, {blockId: string;data: CreateAnswerOptionBody}> = (props) => {
          const {blockId,data} = props ?? {};

          return  createAnswerOption(blockId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAnswerOptionMutationResult = NonNullable<Awaited<ReturnType<typeof createAnswerOption>>>
    export type CreateAnswerOptionMutationBody = CreateAnswerOptionBody
    export type CreateAnswerOptionMutationError = ErrorType<void>

    /**
 * @summary Create Answer Option
 */
export const useCreateAnswerOption = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnswerOption>>, TError,{blockId: string;data: CreateAnswerOptionBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createAnswerOption>>,
        TError,
        {blockId: string;data: CreateAnswerOptionBody},
        TContext
      > => {

      const mutationOptions = getCreateAnswerOptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Delete Answer Option
 */
export const deleteAnswerOption = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/worksheet/answer_options/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAnswerOptionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAnswerOption>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAnswerOption>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAnswerOption'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAnswerOption>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAnswerOption(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAnswerOptionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAnswerOption>>>
    
    export type DeleteAnswerOptionMutationError = ErrorType<void>

    /**
 * @summary Delete Answer Option
 */
export const useDeleteAnswerOption = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAnswerOption>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAnswerOption>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAnswerOptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Update Answer Option
 */
export const updateAnswerOption = (
    id: MaybeRef<string>,
    updateAnswerOptionBody: MaybeRef<UpdateAnswerOptionBody>,
 ) => {
      id = unref(id);
updateAnswerOptionBody = unref(updateAnswerOptionBody);
      
      return axiosClient<WorksheetAnswerOption>(
      {url: `/api/worksheet/answer_options/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAnswerOptionBody
    },
      );
    }
  


export const getUpdateAnswerOptionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAnswerOption>>, TError,{id: string;data: UpdateAnswerOptionBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAnswerOption>>, TError,{id: string;data: UpdateAnswerOptionBody}, TContext> => {
    
const mutationKey = ['updateAnswerOption'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAnswerOption>>, {id: string;data: UpdateAnswerOptionBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAnswerOption(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAnswerOptionMutationResult = NonNullable<Awaited<ReturnType<typeof updateAnswerOption>>>
    export type UpdateAnswerOptionMutationBody = UpdateAnswerOptionBody
    export type UpdateAnswerOptionMutationError = ErrorType<void>

    /**
 * @summary Update Answer Option
 */
export const useUpdateAnswerOption = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAnswerOption>>, TError,{id: string;data: UpdateAnswerOptionBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAnswerOption>>,
        TError,
        {id: string;data: UpdateAnswerOptionBody},
        TContext
      > => {

      const mutationOptions = getUpdateAnswerOptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Archive Worksheet Block
 */
export const archiveWorksheetBlock = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/worksheet/blocks/${id}/archive`, method: 'PATCH'
    },
      );
    }
  


export const getArchiveWorksheetBlockMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveWorksheetBlock>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof archiveWorksheetBlock>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['archiveWorksheetBlock'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveWorksheetBlock>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  archiveWorksheetBlock(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ArchiveWorksheetBlockMutationResult = NonNullable<Awaited<ReturnType<typeof archiveWorksheetBlock>>>
    
    export type ArchiveWorksheetBlockMutationError = ErrorType<void>

    /**
 * @summary Archive Worksheet Block
 */
export const useArchiveWorksheetBlock = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveWorksheetBlock>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof archiveWorksheetBlock>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getArchiveWorksheetBlockMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create Worksheet Block
 */
export const createWorksheetBlock = (
    worksheetId: MaybeRef<string>,
    createWorksheetBlockBody: MaybeRef<CreateWorksheetBlockBody>,
 signal?: AbortSignal
) => {
      worksheetId = unref(worksheetId);
createWorksheetBlockBody = unref(createWorksheetBlockBody);
      
      return axiosClient<WorksheetBlock>(
      {url: `/api/worksheet/worksheets/${worksheetId}/blocks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createWorksheetBlockBody, signal
    },
      );
    }
  


export const getCreateWorksheetBlockMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorksheetBlock>>, TError,{worksheetId: string;data: CreateWorksheetBlockBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createWorksheetBlock>>, TError,{worksheetId: string;data: CreateWorksheetBlockBody}, TContext> => {
    
const mutationKey = ['createWorksheetBlock'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorksheetBlock>>, {worksheetId: string;data: CreateWorksheetBlockBody}> = (props) => {
          const {worksheetId,data} = props ?? {};

          return  createWorksheetBlock(worksheetId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateWorksheetBlockMutationResult = NonNullable<Awaited<ReturnType<typeof createWorksheetBlock>>>
    export type CreateWorksheetBlockMutationBody = CreateWorksheetBlockBody
    export type CreateWorksheetBlockMutationError = ErrorType<void>

    /**
 * @summary Create Worksheet Block
 */
export const useCreateWorksheetBlock = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorksheetBlock>>, TError,{worksheetId: string;data: CreateWorksheetBlockBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createWorksheetBlock>>,
        TError,
        {worksheetId: string;data: CreateWorksheetBlockBody},
        TContext
      > => {

      const mutationOptions = getCreateWorksheetBlockMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Worksheet Blocks
 */
export const listWorksheetBlocks = (
    worksheetId: MaybeRef<string>,
    params?: MaybeRef<ListWorksheetBlocksParams>,
 signal?: AbortSignal
) => {
      worksheetId = unref(worksheetId);
params = unref(params);
      
      return axiosClient<WorksheetBlocks>(
      {url: `/api/worksheet/worksheets/${worksheetId}/blocks`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListWorksheetBlocksQueryKey = (worksheetId: MaybeRef<string>,
    params?: MaybeRef<ListWorksheetBlocksParams>,) => {
    return ['api','worksheet','worksheets',worksheetId,'blocks', ...(params ? [params]: [])] as const;
    }

    
export const useListWorksheetBlocksQueryOptions = <TData = Awaited<ReturnType<typeof listWorksheetBlocks>>, TError = ErrorType<void>>(worksheetId: MaybeRef<string>,
    params?: MaybeRef<ListWorksheetBlocksParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorksheetBlocks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListWorksheetBlocksQueryKey(worksheetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorksheetBlocks>>> = ({ signal }) => listWorksheetBlocks(worksheetId,params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listWorksheetBlocks>>, TError, TData> 
}

export type ListWorksheetBlocksQueryResult = NonNullable<Awaited<ReturnType<typeof listWorksheetBlocks>>>
export type ListWorksheetBlocksQueryError = ErrorType<void>


/**
 * @summary List of Worksheet Blocks
 */

export function useListWorksheetBlocks<TData = Awaited<ReturnType<typeof listWorksheetBlocks>>, TError = ErrorType<void>>(
 worksheetId: MaybeRef<string>,
    params?: MaybeRef<ListWorksheetBlocksParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorksheetBlocks>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListWorksheetBlocksQueryOptions(worksheetId,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete Block
 */
export const deleteWorksheetBlock = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/worksheet/blocks/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteWorksheetBlockMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorksheetBlock>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteWorksheetBlock>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteWorksheetBlock'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWorksheetBlock>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteWorksheetBlock(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorksheetBlockMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorksheetBlock>>>
    
    export type DeleteWorksheetBlockMutationError = ErrorType<void>

    /**
 * @summary Delete Block
 */
export const useDeleteWorksheetBlock = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorksheetBlock>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteWorksheetBlock>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteWorksheetBlockMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Worksheet Block Details
 */
export const getWorksheetBlock = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<WorksheetBlock>(
      {url: `/api/worksheet/blocks/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetWorksheetBlockQueryKey = (id: MaybeRef<string>,) => {
    return ['api','worksheet','blocks',id] as const;
    }

    
export const useGetWorksheetBlockQueryOptions = <TData = Awaited<ReturnType<typeof getWorksheetBlock>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorksheetBlock>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetWorksheetBlockQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorksheetBlock>>> = ({ signal }) => getWorksheetBlock(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getWorksheetBlock>>, TError, TData> 
}

export type GetWorksheetBlockQueryResult = NonNullable<Awaited<ReturnType<typeof getWorksheetBlock>>>
export type GetWorksheetBlockQueryError = ErrorType<void>


/**
 * @summary Worksheet Block Details
 */

export function useGetWorksheetBlock<TData = Awaited<ReturnType<typeof getWorksheetBlock>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorksheetBlock>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetWorksheetBlockQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update Worksheet Block
 */
export const updateWorksheetBlock = (
    id: MaybeRef<string>,
    updateWorksheetBlockBody: MaybeRef<UpdateWorksheetBlockBody>,
 ) => {
      id = unref(id);
updateWorksheetBlockBody = unref(updateWorksheetBlockBody);
      
      return axiosClient<WorksheetBlock>(
      {url: `/api/worksheet/blocks/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateWorksheetBlockBody
    },
      );
    }
  


export const getUpdateWorksheetBlockMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetBlock>>, TError,{id: string;data: UpdateWorksheetBlockBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetBlock>>, TError,{id: string;data: UpdateWorksheetBlockBody}, TContext> => {
    
const mutationKey = ['updateWorksheetBlock'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorksheetBlock>>, {id: string;data: UpdateWorksheetBlockBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateWorksheetBlock(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorksheetBlockMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorksheetBlock>>>
    export type UpdateWorksheetBlockMutationBody = UpdateWorksheetBlockBody
    export type UpdateWorksheetBlockMutationError = ErrorType<void>

    /**
 * @summary Update Worksheet Block
 */
export const useUpdateWorksheetBlock = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetBlock>>, TError,{id: string;data: UpdateWorksheetBlockBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateWorksheetBlock>>,
        TError,
        {id: string;data: UpdateWorksheetBlockBody},
        TContext
      > => {

      const mutationOptions = getUpdateWorksheetBlockMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Move Worksheet Block
 */
export const moveWorksheetBlock = (
    id: MaybeRef<string>,
    moveWorksheetBlockBody: MaybeRef<number>,
 ) => {
      id = unref(id);
moveWorksheetBlockBody = unref(moveWorksheetBlockBody);
      
      return axiosClient<WorksheetBlock>(
      {url: `/api/worksheet/blocks/${id}/move`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: moveWorksheetBlockBody
    },
      );
    }
  


export const getMoveWorksheetBlockMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveWorksheetBlock>>, TError,{id: string;data: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moveWorksheetBlock>>, TError,{id: string;data: number}, TContext> => {
    
const mutationKey = ['moveWorksheetBlock'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveWorksheetBlock>>, {id: string;data: number}> = (props) => {
          const {id,data} = props ?? {};

          return  moveWorksheetBlock(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MoveWorksheetBlockMutationResult = NonNullable<Awaited<ReturnType<typeof moveWorksheetBlock>>>
    export type MoveWorksheetBlockMutationBody = number
    export type MoveWorksheetBlockMutationError = ErrorType<void>

    /**
 * @summary Move Worksheet Block
 */
export const useMoveWorksheetBlock = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveWorksheetBlock>>, TError,{id: string;data: number}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof moveWorksheetBlock>>,
        TError,
        {id: string;data: number},
        TContext
      > => {

      const mutationOptions = getMoveWorksheetBlockMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create Block Solution
 */
export const createWorksheetBlockSolution = (
    blockId: MaybeRef<string>,
    createWorksheetBlockSolutionBody: MaybeRef<CreateWorksheetBlockSolutionBody>,
 signal?: AbortSignal
) => {
      blockId = unref(blockId);
createWorksheetBlockSolutionBody = unref(createWorksheetBlockSolutionBody);
      
      return axiosClient<WorksheetBlockSolution>(
      {url: `/api/worksheet/blocks/${blockId}/solutions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createWorksheetBlockSolutionBody, signal
    },
      );
    }
  


export const getCreateWorksheetBlockSolutionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorksheetBlockSolution>>, TError,{blockId: string;data: CreateWorksheetBlockSolutionBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createWorksheetBlockSolution>>, TError,{blockId: string;data: CreateWorksheetBlockSolutionBody}, TContext> => {
    
const mutationKey = ['createWorksheetBlockSolution'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorksheetBlockSolution>>, {blockId: string;data: CreateWorksheetBlockSolutionBody}> = (props) => {
          const {blockId,data} = props ?? {};

          return  createWorksheetBlockSolution(blockId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateWorksheetBlockSolutionMutationResult = NonNullable<Awaited<ReturnType<typeof createWorksheetBlockSolution>>>
    export type CreateWorksheetBlockSolutionMutationBody = CreateWorksheetBlockSolutionBody
    export type CreateWorksheetBlockSolutionMutationError = ErrorType<void>

    /**
 * @summary Create Block Solution
 */
export const useCreateWorksheetBlockSolution = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorksheetBlockSolution>>, TError,{blockId: string;data: CreateWorksheetBlockSolutionBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createWorksheetBlockSolution>>,
        TError,
        {blockId: string;data: CreateWorksheetBlockSolutionBody},
        TContext
      > => {

      const mutationOptions = getCreateWorksheetBlockSolutionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Delete Block Solution
 */
export const deleteWorksheetBlockSolution = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/worksheet/solutions/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteWorksheetBlockSolutionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorksheetBlockSolution>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteWorksheetBlockSolution>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteWorksheetBlockSolution'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWorksheetBlockSolution>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteWorksheetBlockSolution(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorksheetBlockSolutionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorksheetBlockSolution>>>
    
    export type DeleteWorksheetBlockSolutionMutationError = ErrorType<void>

    /**
 * @summary Delete Block Solution
 */
export const useDeleteWorksheetBlockSolution = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorksheetBlockSolution>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteWorksheetBlockSolution>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteWorksheetBlockSolutionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Update Block Solution
 */
export const updateWorksheetBlockSolution = (
    id: MaybeRef<string>,
    updateWorksheetBlockSolutionBody: MaybeRef<UpdateWorksheetBlockSolutionBody>,
 ) => {
      id = unref(id);
updateWorksheetBlockSolutionBody = unref(updateWorksheetBlockSolutionBody);
      
      return axiosClient<WorksheetBlockSolution>(
      {url: `/api/worksheet/solutions/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateWorksheetBlockSolutionBody
    },
      );
    }
  


export const getUpdateWorksheetBlockSolutionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetBlockSolution>>, TError,{id: string;data: UpdateWorksheetBlockSolutionBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetBlockSolution>>, TError,{id: string;data: UpdateWorksheetBlockSolutionBody}, TContext> => {
    
const mutationKey = ['updateWorksheetBlockSolution'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorksheetBlockSolution>>, {id: string;data: UpdateWorksheetBlockSolutionBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateWorksheetBlockSolution(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorksheetBlockSolutionMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorksheetBlockSolution>>>
    export type UpdateWorksheetBlockSolutionMutationBody = UpdateWorksheetBlockSolutionBody
    export type UpdateWorksheetBlockSolutionMutationError = ErrorType<void>

    /**
 * @summary Update Block Solution
 */
export const useUpdateWorksheetBlockSolution = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetBlockSolution>>, TError,{id: string;data: UpdateWorksheetBlockSolutionBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateWorksheetBlockSolution>>,
        TError,
        {id: string;data: UpdateWorksheetBlockSolutionBody},
        TContext
      > => {

      const mutationOptions = getUpdateWorksheetBlockSolutionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create Worksheet Response Feedback
 */
export const createWorksheetFeedback = (
    responseId: MaybeRef<string>,
    createWorksheetFeedbackBody: MaybeRef<CreateWorksheetFeedbackBody>,
 signal?: AbortSignal
) => {
      responseId = unref(responseId);
createWorksheetFeedbackBody = unref(createWorksheetFeedbackBody);
      
      return axiosClient<WorksheetResponseFeedback>(
      {url: `/api/worksheet/responses/${responseId}/feedback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createWorksheetFeedbackBody, signal
    },
      );
    }
  


export const getCreateWorksheetFeedbackMutationOptions = <TError = ErrorType<StandardError | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorksheetFeedback>>, TError,{responseId: string;data: CreateWorksheetFeedbackBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createWorksheetFeedback>>, TError,{responseId: string;data: CreateWorksheetFeedbackBody}, TContext> => {
    
const mutationKey = ['createWorksheetFeedback'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorksheetFeedback>>, {responseId: string;data: CreateWorksheetFeedbackBody}> = (props) => {
          const {responseId,data} = props ?? {};

          return  createWorksheetFeedback(responseId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateWorksheetFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof createWorksheetFeedback>>>
    export type CreateWorksheetFeedbackMutationBody = CreateWorksheetFeedbackBody
    export type CreateWorksheetFeedbackMutationError = ErrorType<StandardError | void | ValidationError>

    /**
 * @summary Create Worksheet Response Feedback
 */
export const useCreateWorksheetFeedback = <TError = ErrorType<StandardError | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorksheetFeedback>>, TError,{responseId: string;data: CreateWorksheetFeedbackBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createWorksheetFeedback>>,
        TError,
        {responseId: string;data: CreateWorksheetFeedbackBody},
        TContext
      > => {

      const mutationOptions = getCreateWorksheetFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Delete Response Feedback
 */
export const deleteWorksheetFeedback = (
    responseId: MaybeRef<string>,
 ) => {
      responseId = unref(responseId);
      
      return axiosClient<void>(
      {url: `/api/worksheet/responses/${responseId}/feedback`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteWorksheetFeedbackMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorksheetFeedback>>, TError,{responseId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteWorksheetFeedback>>, TError,{responseId: string}, TContext> => {
    
const mutationKey = ['deleteWorksheetFeedback'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWorksheetFeedback>>, {responseId: string}> = (props) => {
          const {responseId} = props ?? {};

          return  deleteWorksheetFeedback(responseId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorksheetFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorksheetFeedback>>>
    
    export type DeleteWorksheetFeedbackMutationError = ErrorType<void>

    /**
 * @summary Delete Response Feedback
 */
export const useDeleteWorksheetFeedback = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorksheetFeedback>>, TError,{responseId: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteWorksheetFeedback>>,
        TError,
        {responseId: string},
        TContext
      > => {

      const mutationOptions = getDeleteWorksheetFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Worksheet Feedback Details
 */
export const getWorksheetFeedback = (
    responseId: MaybeRef<string>,
 signal?: AbortSignal
) => {
      responseId = unref(responseId);
      
      return axiosClient<WorksheetResponseFeedback>(
      {url: `/api/worksheet/responses/${responseId}/feedback`, method: 'GET', signal
    },
      );
    }
  

const getGetWorksheetFeedbackQueryKey = (responseId: MaybeRef<string>,) => {
    return ['api','worksheet','responses',responseId,'feedback'] as const;
    }

    
export const useGetWorksheetFeedbackQueryOptions = <TData = Awaited<ReturnType<typeof getWorksheetFeedback>>, TError = ErrorType<void>>(responseId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorksheetFeedback>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetWorksheetFeedbackQueryKey(responseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorksheetFeedback>>> = ({ signal }) => getWorksheetFeedback(responseId, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getWorksheetFeedback>>, TError, TData> 
}

export type GetWorksheetFeedbackQueryResult = NonNullable<Awaited<ReturnType<typeof getWorksheetFeedback>>>
export type GetWorksheetFeedbackQueryError = ErrorType<void>


/**
 * @summary Worksheet Feedback Details
 */

export function useGetWorksheetFeedback<TData = Awaited<ReturnType<typeof getWorksheetFeedback>>, TError = ErrorType<void>>(
 responseId: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorksheetFeedback>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetWorksheetFeedbackQueryOptions(responseId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update Worksheet Response Feedback
 */
export const updateWorksheetFeedback = (
    responseId: MaybeRef<string>,
    updateWorksheetFeedbackBody: MaybeRef<UpdateWorksheetFeedbackBody>,
 ) => {
      responseId = unref(responseId);
updateWorksheetFeedbackBody = unref(updateWorksheetFeedbackBody);
      
      return axiosClient<WorksheetResponseFeedback>(
      {url: `/api/worksheet/responses/${responseId}/feedback`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateWorksheetFeedbackBody
    },
      );
    }
  


export const getUpdateWorksheetFeedbackMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetFeedback>>, TError,{responseId: string;data: UpdateWorksheetFeedbackBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetFeedback>>, TError,{responseId: string;data: UpdateWorksheetFeedbackBody}, TContext> => {
    
const mutationKey = ['updateWorksheetFeedback'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorksheetFeedback>>, {responseId: string;data: UpdateWorksheetFeedbackBody}> = (props) => {
          const {responseId,data} = props ?? {};

          return  updateWorksheetFeedback(responseId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorksheetFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorksheetFeedback>>>
    export type UpdateWorksheetFeedbackMutationBody = UpdateWorksheetFeedbackBody
    export type UpdateWorksheetFeedbackMutationError = ErrorType<void>

    /**
 * @summary Update Worksheet Response Feedback
 */
export const useUpdateWorksheetFeedback = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorksheetFeedback>>, TError,{responseId: string;data: UpdateWorksheetFeedbackBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateWorksheetFeedback>>,
        TError,
        {responseId: string;data: UpdateWorksheetFeedbackBody},
        TContext
      > => {

      const mutationOptions = getUpdateWorksheetFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Create Response
 */
export const createWorksheetResponse = (
    worksheetId: MaybeRef<string>,
    createWorksheetResponseBody: MaybeRef<CreateWorksheetResponseBody>,
 signal?: AbortSignal
) => {
      worksheetId = unref(worksheetId);
createWorksheetResponseBody = unref(createWorksheetResponseBody);
      
      return axiosClient<WorksheetResponse>(
      {url: `/api/worksheet/worksheets/${worksheetId}/responses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createWorksheetResponseBody, signal
    },
      );
    }
  


export const getCreateWorksheetResponseMutationOptions = <TError = ErrorType<StandardError | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorksheetResponse>>, TError,{worksheetId: string;data: CreateWorksheetResponseBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createWorksheetResponse>>, TError,{worksheetId: string;data: CreateWorksheetResponseBody}, TContext> => {
    
const mutationKey = ['createWorksheetResponse'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorksheetResponse>>, {worksheetId: string;data: CreateWorksheetResponseBody}> = (props) => {
          const {worksheetId,data} = props ?? {};

          return  createWorksheetResponse(worksheetId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateWorksheetResponseMutationResult = NonNullable<Awaited<ReturnType<typeof createWorksheetResponse>>>
    export type CreateWorksheetResponseMutationBody = CreateWorksheetResponseBody
    export type CreateWorksheetResponseMutationError = ErrorType<StandardError | void | ValidationError>

    /**
 * @summary Create Response
 */
export const useCreateWorksheetResponse = <TError = ErrorType<StandardError | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorksheetResponse>>, TError,{worksheetId: string;data: CreateWorksheetResponseBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createWorksheetResponse>>,
        TError,
        {worksheetId: string;data: CreateWorksheetResponseBody},
        TContext
      > => {

      const mutationOptions = getCreateWorksheetResponseMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary List of Responses
 */
export const listWorksheetResponses = (
    worksheetId: MaybeRef<string>,
    params?: MaybeRef<ListWorksheetResponsesParams>,
 signal?: AbortSignal
) => {
      worksheetId = unref(worksheetId);
params = unref(params);
      
      return axiosClient<WorksheetResponses>(
      {url: `/api/worksheet/worksheets/${worksheetId}/responses`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getListWorksheetResponsesQueryKey = (worksheetId: MaybeRef<string>,
    params?: MaybeRef<ListWorksheetResponsesParams>,) => {
    return ['api','worksheet','worksheets',worksheetId,'responses', ...(params ? [params]: [])] as const;
    }

    
export const useListWorksheetResponsesQueryOptions = <TData = Awaited<ReturnType<typeof listWorksheetResponses>>, TError = ErrorType<void>>(worksheetId: MaybeRef<string>,
    params?: MaybeRef<ListWorksheetResponsesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorksheetResponses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListWorksheetResponsesQueryKey(worksheetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWorksheetResponses>>> = ({ signal }) => listWorksheetResponses(worksheetId,params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listWorksheetResponses>>, TError, TData> 
}

export type ListWorksheetResponsesQueryResult = NonNullable<Awaited<ReturnType<typeof listWorksheetResponses>>>
export type ListWorksheetResponsesQueryError = ErrorType<void>


/**
 * @summary List of Responses
 */

export function useListWorksheetResponses<TData = Awaited<ReturnType<typeof listWorksheetResponses>>, TError = ErrorType<void>>(
 worksheetId: MaybeRef<string>,
    params?: MaybeRef<ListWorksheetResponsesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWorksheetResponses>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListWorksheetResponsesQueryOptions(worksheetId,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Delete Response
 */
export const deleteWorksheetResponse = (
    id: MaybeRef<string>,
 ) => {
      id = unref(id);
      
      return axiosClient<void>(
      {url: `/api/worksheet/responses/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteWorksheetResponseMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorksheetResponse>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteWorksheetResponse>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteWorksheetResponse'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWorksheetResponse>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteWorksheetResponse(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteWorksheetResponseMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWorksheetResponse>>>
    
    export type DeleteWorksheetResponseMutationError = ErrorType<void>

    /**
 * @summary Delete Response
 */
export const useDeleteWorksheetResponse = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWorksheetResponse>>, TError,{id: string}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteWorksheetResponse>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteWorksheetResponseMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Response Details
 */
export const getWorksheetResponse = (
    id: MaybeRef<string>,
 signal?: AbortSignal
) => {
      id = unref(id);
      
      return axiosClient<WorksheetResponse>(
      {url: `/api/worksheet/responses/${id}`, method: 'GET', signal
    },
      );
    }
  

const getGetWorksheetResponseQueryKey = (id: MaybeRef<string>,) => {
    return ['api','worksheet','responses',id] as const;
    }

    
export const useGetWorksheetResponseQueryOptions = <TData = Awaited<ReturnType<typeof getWorksheetResponse>>, TError = ErrorType<void>>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorksheetResponse>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetWorksheetResponseQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorksheetResponse>>> = ({ signal }) => getWorksheetResponse(id, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getWorksheetResponse>>, TError, TData> 
}

export type GetWorksheetResponseQueryResult = NonNullable<Awaited<ReturnType<typeof getWorksheetResponse>>>
export type GetWorksheetResponseQueryError = ErrorType<void>


/**
 * @summary Response Details
 */

export function useGetWorksheetResponse<TData = Awaited<ReturnType<typeof getWorksheetResponse>>, TError = ErrorType<void>>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorksheetResponse>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetWorksheetResponseQueryOptions(id,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Create Worksheet
 */
export const createWorksheet = (
    createWorksheetBody: MaybeRef<CreateWorksheetBody>,
 signal?: AbortSignal
) => {
      createWorksheetBody = unref(createWorksheetBody);
      
      return axiosClient<Worksheet>(
      {url: `/api/worksheet/worksheets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createWorksheetBody, signal
    },
      );
    }
  


export const getCreateWorksheetMutationOptions = <TError = ErrorType<void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorksheet>>, TError,{data: CreateWorksheetBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createWorksheet>>, TError,{data: CreateWorksheetBody}, TContext> => {
    
const mutationKey = ['createWorksheet'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorksheet>>, {data: CreateWorksheetBody}> = (props) => {
          const {data} = props ?? {};

          return  createWorksheet(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateWorksheetMutationResult = NonNullable<Awaited<ReturnType<typeof createWorksheet>>>
    export type CreateWorksheetMutationBody = CreateWorksheetBody
    export type CreateWorksheetMutationError = ErrorType<void | ValidationError>

    /**
 * @summary Create Worksheet
 */
export const useCreateWorksheet = <TError = ErrorType<void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorksheet>>, TError,{data: CreateWorksheetBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof createWorksheet>>,
        TError,
        {data: CreateWorksheetBody},
        TContext
      > => {

      const mutationOptions = getCreateWorksheetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Worksheet Details
 */
export const getWorksheet = (
    id: MaybeRef<string>,
    params?: MaybeRef<GetWorksheetParams>,
 signal?: AbortSignal
) => {
      id = unref(id);
params = unref(params);
      
      return axiosClient<Worksheet>(
      {url: `/api/worksheet/worksheets/${id}`, method: 'GET',
        params: unref(params), signal
    },
      );
    }
  

const getGetWorksheetQueryKey = (id: MaybeRef<string>,
    params?: MaybeRef<GetWorksheetParams>,) => {
    return ['api','worksheet','worksheets',id, ...(params ? [params]: [])] as const;
    }

    
export const useGetWorksheetQueryOptions = <TData = Awaited<ReturnType<typeof getWorksheet>>, TError = ErrorType<void>>(id: MaybeRef<string>,
    params?: MaybeRef<GetWorksheetParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorksheet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetWorksheetQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorksheet>>> = ({ signal }) => getWorksheet(id,params, signal);

      

      const customOptions = customQueryOptions({...queryOptions, queryKey, queryFn});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof getWorksheet>>, TError, TData> 
}

export type GetWorksheetQueryResult = NonNullable<Awaited<ReturnType<typeof getWorksheet>>>
export type GetWorksheetQueryError = ErrorType<void>


/**
 * @summary Worksheet Details
 */

export function useGetWorksheet<TData = Awaited<ReturnType<typeof getWorksheet>>, TError = ErrorType<void>>(
 id: MaybeRef<string>,
    params?: MaybeRef<GetWorksheetParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorksheet>>, TError, TData>>, }

  ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetWorksheetQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}




/**
 * @summary Update Worksheet
 */
export const updateWorksheet = (
    id: MaybeRef<string>,
    updateWorksheetBody: MaybeRef<UpdateWorksheetBody>,
 ) => {
      id = unref(id);
updateWorksheetBody = unref(updateWorksheetBody);
      
      return axiosClient<Worksheet>(
      {url: `/api/worksheet/worksheets/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateWorksheetBody
    },
      );
    }
  


export const getUpdateWorksheetMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorksheet>>, TError,{id: string;data: UpdateWorksheetBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateWorksheet>>, TError,{id: string;data: UpdateWorksheetBody}, TContext> => {
    
const mutationKey = ['updateWorksheet'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorksheet>>, {id: string;data: UpdateWorksheetBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateWorksheet(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateWorksheetMutationResult = NonNullable<Awaited<ReturnType<typeof updateWorksheet>>>
    export type UpdateWorksheetMutationBody = UpdateWorksheetBody
    export type UpdateWorksheetMutationError = ErrorType<void>

    /**
 * @summary Update Worksheet
 */
export const useUpdateWorksheet = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWorksheet>>, TError,{id: string;data: UpdateWorksheetBody}, TContext>, }
): UseMutationReturnType<
        Awaited<ReturnType<typeof updateWorksheet>>,
        TError,
        {id: string;data: UpdateWorksheetBody},
        TContext
      > => {

      const mutationOptions = getUpdateWorksheetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
